{
  "source": "https://raw.githubusercontent.com/nvkelso/natural-earth-vector/ca96624a56bd078437bca8184e78163e5039ad19/geojson/ne_50m_admin_0_boundary_lines_land.geojson",
  "sha256": "2faac4f6b34386f3d21b6e018cf151f241f00e5c936d44dd17d7d9bfb147fa48",
  "scale": "50m",
  "features": [
    {
      "kind": "Disputed (please verify)",
      "lines": ["w|xo@uvycH}}j@g_\\iej@uo[icm@cm]ktv@ivc@yjs@{pa@}wi@kf[i}T?upn@S}k_@?kxxA_@e{u@Isjs@Iu|t@I"]
    },
    {
      "kind": "Indefinite (please verify)",
      "lines": [
        "w|xo@uvycHxlm@fdo@hos@bmu@nev@|fx@lob@fyc@xkw@hny@`{m@nro@dhr@~_q@`km@ngl@vf_A|zy@jqh@fbe@xd`Avuz@r}g@npd@pjAxsDcbBput@m_Bnds@ozBptaAtAntFpzBjlRxwBrwJz_Jl~n@nzA|yG~pPj{f@buS|tg@`zNtlTt`VrrOlmO`aFleFjmFfhEhuKnqNzftAdaAfwWfmKv{f@rySdgTrmIjbE"
      ]
    },
    { "kind": "Disputed (please verify)", "lines": ["akn}D_p_pEuoO_cSosLsJ{x^ega@ccB~G_mGhcH"] },
    {
      "kind": "Disputed (please verify)",
      "lines": [
        "_gvdEqs~wEge@zaLeqHf~N_hGnbBgyAlxCca@rkJieCdrTnmM~_X~zV`tIzcJvcA|mVhoGnlMs_BzsQem@hhNwcA|cHtfAh|C`xC`oByl@tg@sgCacCsuLjcCemMv{FyyLjcDob@``B|xHz}JdeVnzLpjOryKrfC~gZ~_JrrDmo@fhBoiD_|A}wd@u`Jyga@}vJexXrUidG"
      ]
    },
    { "kind": "Disputed (please verify)", "lines": ["}s|hEuchuE_s@_lUtlAyuO`Wy~RupGs~NsqXmuFcbC_cHx_EqrC"] },
    {
      "kind": "Line of control (please verify)",
      "lines": ["ipxfEiulyEgsOu~Gc|Ist@ujLg_HexG~sDsrQbvA}pCj~Be|Czm@y}DocBkcEdg@csA|pBchHrt@qyEz|A{kG}m@qlDorCcoIyxC"]
    },
    {
      "kind": "Line of control (please verify)",
      "lines": [
        "yt_uE}npnE|s@fqFgrDdeK{q@feFfdDlvEnuB`wF~s@z{E~MvaErxB|yHq]b|JsbBniPrnFtvHu[|iA_zQlp@}uF~dEcgCp{Fxw@hkJsSnaNidBneJlgDfdU`yDh{PrqDv}KuHfxHadDptO{wDdnKq_Dzm@"
      ]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": [
        "oxswE_ezyMdfAagAlsC{|FrhAinGmlCm}HisBqlKf`AunE`}Dk\\hyZ~mFl|IaRvtU}kKpxc@cdOfoa@wdNhsUc}GbhH_xGxmHe{c@twF{g]pvK{_QbfK}zR~nFi~LlsHsqE`uGsi@~yDlf@htFzqFzwRz{a@|gE`dCjfG|^fqWizEpkNqhCf}]we@nl\\iiAzkLijK~sGsaI"
      ]
    },
    {
      "kind": "Line of control (please verify)",
      "lines": [
        "{khuEypguMbhH`oBvvL`yD~kIliTvoFzfTtjCz}Cl|D~s@zyJlhIb~Hz{Rk^vnOg~AtkIlgP~ov@wL~sXpeJlaSxeIj{MpdJjz\\|@zfSesEt{\\u|Gr_Y"
      ]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": [
        "wzlhDmzgnPXcwNxrA{{TrgBkpOeCsiL_bNqcW}[w~IuzAksK}yAuoDleAayB`z@wzLaWglMkdCmzKunEw{K_sLc~UiyFiqCsdF|@yuCrgC_hAfiC_fE{w@{nIcsHgyN}cb@amR}{\\sxEmpYu}L{nBsbLykIu~QgkLo{IkwHaaFkmz@avFcvQ}oAutY_aVs{Mm{DycQ}hN}ze@}~OywFsfPrjAi~Lica@kxQig]f_BypIzzGa_JlyHayDz}Ckf@xeE_ue@__@_cE~xGon[tsIufYhtAomMkHcaFshBm`E{jHabFaxE{gFswAuoCswIbFseFase@wsQcuIeu@ekTuyBwa`@{xAc{NzgTk}KreDgzFc~A{}RriAgsBntFlcBpnHloLfoGtoPxnGaOliTinBieKim[ipCgjPlpD_cEphK_~@tiXkfMb{Ke`Exo]lwQ`rTrg]roDfVf{FdfHvcBcOv~CunFhwBibHeCmlCamFipF{oIqda@r~@sxHxcOu_W`\\qdJjyC_{[mbEmmQbrDisLveSae[vtBmmE"
      ]
    },
    {
      "kind": "Line of control (please verify)",
      "lines": [
        "ssvjFkdpnWj`BrzEtlO|vJlzSj~IlgJlsIzfExdKltBzcLtq@dbYkl@bqVigAnsFhi@vl_@xm@hcHur@nrm@pu@`iWd`ClnN~mGdwNttKtqLpqLv}JjyWjiWfaKxaPxlP|@zhDfK`uBz~D"
      ]
    },
    {
      "kind": "Line of control (please verify)",
      "lines": [
        "ysxgD`~~s@BjgY~hGqWteOcvDpvL}~@zqGjzAtzIrtArhIuc@`gJikClsJg_CbyF?f|Dl_GzfBxkQftA``U?xbOa|@bfWhKdaN?ddL~{@hvJ`mFboMjsJvbOlsN|eSdvHpbKdbAxbO?nbOiyFnvNa_CrbIbKntE~oD`~I`yB~}K?rbKgyFzeScsJdfWg|DxbM_|@tbScyB|eS`|@zbM?vbQbyFbfWbvD|eSf|D|bUviDxdXrpPkbEfpHwtGnyJ?d|HlbChvHpbKxkKnyLdvHb_GlpLnbGhyFh_EzwKtkIp_OzfHn|HtzAfmJzuBxlB~cFn`BlrWf_CfsN`yBtsLvvEvaDpa@dYpvLh|B`vH?hyF~{BnmRjyDtvP|xFzmVh|DjmRhyDfh^~xFpd\\hyF~mZjvHnpPfyFdvHh|DnyJhsLdsFhvJh|HjsLdvHpsNlsJnmTl|HvsPvmCrdFlgDrmGhpLpsLxsRlvJhsNbyF|jXnsLlvLjvH~rF|{DhyFrsNf|DrpPdyFrpRlyFhsN~xFrmThyFjsLjsJpyHlvL~xFrsRhvHljThyFpvL~{Bp|m@rvJtgZ~{BrpP~{BppTjyDbe`@|{BxgZ?nsNj|BjyJ|~@lpLhvHdvHhyFjvLdsLhyFnvJhyF|{B`vHnvJpsNhvJjvHhvHhyF_|@jvLc_AlvLf|DrsN`yDjmRpsNjvHnpP~{@vmX?bbb@_|@vjZ?be`@cyBxg\\e_CzjZa|@~d`@?zmV`yBtg\\?lekAdbA~g\\hyFd_j@rz@|bI"
      ]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": [
        "aie[arfzEqdO`oMqqSxbOgyZhj@mh]koCa`IybCw~HhiAkwLwQaxK`aHgtMf~t@hc@jvGznDb_Hr}BlgIyvBxjF}mDjnCy}GdDwuEc["
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "yq~fH`dnxVh{Hewa@tkHs_`@~|Gcrc@viH}fe@`gG}y`@pfFi|g@zb@s`TieE{t\\kfOqnc@ehLikJ_fJxwCghPdqHkbElcAqyJzw@ogH}nCekNuwe@giCav@_~ExvC}wQzb]}sMbkX"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "wzlhDmzgnPs~FzN_|VemAypDvaF}zDn|TexFbqWygGxzJyxAfrEpk@peH`uGvyMzeIzaMlZfcJaxC~jJwfEl|ImyGbhd@ui@lvObo@vy\\qy@jiWcuAvyBarCsB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_bmyH{kaoCsm@gt@}rOr_@yqBkmF{lAsvJdYuqOdqAwdMdrF}}Oaf@qhDeiMg_\\aoTs|\\gmKgpGytDimF}_B_`Yog@utUpFqlMobAukb@gjAm~S}wBwcQkl@cdf@jpAsc|@xDocg@h_AufZplJewaAfaAyzWv`EyoJ`gAidU`bEgjg@hgBw_b@si@iuVzu@agLl`Z_`XbdBwbDhSk_IwiAkmS`[mb\\juDigPrbOvoApiAkpCq[u`GebHohHslHsxFu|AwxDbkEov\\}_@kqL_dFyoKwe@ytFraDkaTzpBu}XlFc_TtzBgaLfyOqoHfmByhGba@m_Gy_NgbKoyDw~ImhCufNa{@gxHqhDq|EudDyhHaLaaG|~@spEddFgpFpiOw~IxkO}iLp}DciHe`Ds`WacD}hO_^kz\\irBkrf@euCsg]zXe}QxeDgnJnaIanPxmMmwC`_IauU~x@spQ_lIqiEwfFozIm}HdaCktKby@qwJhcGitKvlDcbQm}HwyNqzIerGwlDwyN_eP{hJqsP{dQ}jYo_EqgRzvAelPhnAktHswIk_X_P_nk@xj@i`d@"
      ]
    },
    { "kind": "Disputed (please verify)", "lines": ["{n}jEscwyEx}G~kIjgFjjIrfJd}SfvEbwC"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{n}jEscwyEscBipDaqEe|GeyEshAmuEm_GsmDwtIykCokAkoAvo@o|CrvIwtGbvDitKwaDm}BwmBqbEckEyhH_jMmp@wfJIwtHpW{kOrt@qvKalAkfBsaBdMasFpvNqaEvZioE_|BihI{cJqoFkgLsj@axEmcNcdNc~OivHufh@xvNerEfpHktDbmNsZ~aH}tArUwmIodKebHctGmtGnqH_aClbPn}GxkEnYv}TuB~ca@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["nnhhAqltrEce@uyEf_AouCxmB}hBtoD}@bvD~~@njCreD`q@rzEaoBfiCkkIs`@{pFylA??????????????????????????????"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "wfo`Gm{phNanBgsCokDwaDeqFdX}mWbsHefVjdD_}SblByxFuR_nLqgFsgKkkHqlJy|`@ymBimUumFu\\atChdQymFzcLsgCfjA{yCaScmCeaBmiG{xUshGsnT~_DyeYweB_eDgiGwp@mjGrrDctLdiDu~EpbKgkGzM_nMioFywYjjIyrVneJylg@b`R{sJvqKksQn~EcxHp|FumMgV}cIag@}cSf`AmzTfsB{dU{sBurMc`FwqDvz@keCevBwk@_vIa~DcbDocEbbDivCjnQmkFbtSbZzyW`h@xoXwmDruK{}EfbJknChT}wJshNydKohTekDc_`@{_Ggnc@{yDclQkeCyoWuw@ek[bf@uhM{wF{oc@w`Nunx@{rKafs@}oFiqP|oFs`L~pOm_EpqGmeNvcCybNcEctGkmEqaYovC{a[tqA}aJhnG_iM~qF{_O}JajGezDoiFeyJwlFeaNouCe{Nk\\qvHnwAsqBxtDmvDbqX}jHhlWqpG`yAebEuQu}MwlEolZ_}Nuzd@g_Ooz\\inG_pk@exY_mm@u`T{uaA_da@ydLcuDuaTccBcuGmy@iqCo{JrmCkaSzeNe|o@`xKcfd@jiC_rN~oC{dVziDgyb@uq@muSmcB_eQaHedWf~B{xd@dD_uJbOyoMpmEuiIlsMkdDhqE}yF{lAqaMw{Kea]}cI}eRqtMa_W}_AqxVygBahXahF_xGacPygHm|KaoNojOuqA{oJ`nDqxQ|wIctKkI{uc@teDg``@z}EorYwaFuu\\yoK_bHi|Ca~Je}FyhMedJqnC{uN{`Biek@y_Ea|g@_eEq{SovBcsTipCm|Kg{SkiUi`KyqIg}^kxFgjNxuDgqLkxCm~F}wIo~FmdNwj@}cIelA{qTnX}lb@h|BmcQ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ybfhI_zinC~{BmpMbn@_ba@mqC{bZoSq`Mzl@eoKurAqsQ{`@caPn}D}yGrgDk{N{qFyj^{jHywZl_@mx[mrCobCyqVubFqbDeqGpjAina@sgCqwKwqJuhLgfFyiSHg~O{bGeuP|lDwtGjvH}fChxFhzDv`BkpAjzBmfKwBy~SefBqlLqmCobBwaGTsoF|hBcoEn{G}iBxvOuBxqJccCr~@wyGs}BygOmhIevMitKypDmvFgbDgj@k|Glo@s~N`HepUukJqxOgiNgmDgpSs}AqbXc_Gq`OmeHe}FowFq_BsuEwxBi}Ac_Gry@_m{@omMefHk`CieDsgCcrJucDaaGm}Bz_B{pAdlNkgAlic@wwCljFgwDsiAg{MkuHseR{fHa{MwvCkwGyO"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "rg}lEh}vdIk]hgDojDp{KckErxI_gC~lAwjEjf@y|Vel@si_A|D{cKwxBizFktDijJqbP_hOcsOmuScwQanOghPu`JheE_uIdmMysG~tXafNrvW{pRx|TckSfcIo}TbhHojP`{G{|Fn}AshBltGgzGdwLegGnrGcvClrKkeDpoUu`HvmVgoTpd\\e{Vp`TywNnkIgbJraJejQff{@o|TfjZ~yElwIcvE~aOepIvyNkbGbwCohGluEeoHphEicHj_Ci~NxhO}gPt`Tg|Cj|Gzl@xuCdsExpC`lEf{AtfCn}Fd|F`zHnhHhsH"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "seboHsudgUrcZ|gQjlu@jsc@v`m@d_^t}XfjOhxRt~JvwQdnKxgJpv@tcQh_Mz{Tr_YrvVpsDljTu]hdRbdApbKvo[|xI`jUlhc@ojE|uLgnJbyMqrQnzJ}oRn_I_|OmwCytQygNcyNglL_p]cImxOraBw|Jb[}kY_{Cq`Z}_@{eTngB{mZdfBozHp{D_aVb|KyzWdmMgjPnwAstKirCknEeyKw{LsjKgqRqfSiuVkpNi|P}iAqaMl@{aZswBwfKi}@gpSvvDcbQz_Byoq@n}FwpLlsVa~V`sKwpLbjEqoVpiCafMxlBwqK`bEmqKvkFs~AbhJo_D~nEwuFbkEafMn{BqzI|dGwmBj_CqkBbvDc|H|kWgj\\hpEshMxcMwtTruJc_H`iKcOdlHgrDhbMonM|oHszEz}KptA`mJihAdzJ|qDhxGtkVfcCb~F|K`{O}lCjp[joAxwZozChd`@mmIpaYsiG`}Lq}CrbU~pAfnIbxIddLa|@vnM`|@tiLqeAjka@wuAbuQnoF|s\\|iAzuOhfH`l^d}N||QfyBnbMwW|uLyyDzzHwaFfkMrKpfT`_BljEdoE~rAvuRn~ElzGgB|uDrqC`|@lqKwPtaUuh@nra@qbDhkVjeAfaMztIhdRpv@lqLnpC|aJrwNx}GfyHf`MzcKz_PpaYtdQ|zMhaIf`GwcBzuHwfAx`JlkGfhIvcP`|@fvLh|HzqS`zPfi[h}MtbTftB|sZ`yBroRpsCnjj@dd@`vIviAdpn@gaGzfb@pf@jmQnpCxlOr}CjkG~lHt|ApuGr|AboL`iLb|Pr}Yl|JfeUzjNp_PrqDhwHf|DjlRvcBpoIbvLrkWheK`mR|mBdyKyfBbmN__@zeIcvC~e]aS~mS{_Brs[_hM~|aAytEfnTyeQd`RkfH~dPk]bhVTv~a@ysBptNxlBthYpmQpu[|vLvqLdaMfwJ|b]nlMjcSbkE~jJh}Ch`QziNpcIhu@twG{iDd|H_aJhqNspEtpOaeOl{KazNjxSi|\\n{IgnGxnKk`IxeKmdAb_Gt{@jbEtvIj`Bz{SnnGj`IjiJnlN|`L|fQ|TzpGvnBnfIjeOtrr@`pCfrRbjDlnNfoOziQfgKzkMrgO`xPxeFtxF|gOvyNlrQ~xSj~HbqJ`~DpgEnxFnuDh`E|wTrkEp~PvsHnbZrrIl|e@|fIlk^jmGn_S`tIlw\\|lB|dSuL|sg@bwAdfq@r_Axpc@oqAloZum@joh@{`A`x^||BpgTjdCfaq@j]zdJhbIdcxAblD|jf@fnAjac@x|B`qYh|Cf_NjaFlhUpaBrwJvzL|jf@bs[fyvA~eVhyy@l~BlsH~jO~qf@flEp{UdrMf}N~fHttKr~BfkLklH|wV~Nh|OolBnxt@gsi@?t_Erud@hrHhc{@n|Gr{v@klSr`r@owNplf@wpLfea@y~G`}r@syFzfl@m{KxvpAahJn{b@{|MjdQg{`@`m_@}tEnoI_rCnxN}}AzjOnDrmb@_sAdij@_cF~j}@ktDpop@_pIposAih@x_SdjHrek@|}J~pw@akHfwdBykCb`l@_}GdlzAsbIfkfBmmIzfcBvwDhxgAjeB~pg@|qC|ym@kdDvmEw_S~|@coNtkGcwO`rXi}NteP{pTvw_@aqLtiIm`TxlBcwu@~e]{_d@vwQmpFduCs`K~bGkhEbrIuzB~lUsoEb`EqxK?utPkpBm|KuoCifBjfBpsBvty@oqGd|b@ygHla]swVjoi@sdH`iXmpWnh_@ayD~cn@yrH~oPk`Tt`UonLphRynGdkZ{pFpij@gfFn{hAg`Bh`XpyCxxg@|Kph]mcD~`p@_oEv{ZcDzpa@jA|mUin@|}\\sfCloMudDbnLhh@deX{cDfsP{sHnlO_rCjcPtHjyQhhCtvFsLhdFg`LduCw`T~qPslH|sAe{IrwIe{HvjE_tLov@ynYgrFa~VkzOifEi`JkaFkwEokKceMy{HgeGsoLt]_cMvrHifQb`FanI}h@gmKkkImpZoeKufFj^mxD`yCkwKtf@udPfkAyeYptMk|Lz|Fo~DbzL}sB|hOyyQzaMqeUftP}{LraJwoGjzB}nNdw@mvQdgGmgIjuGg{FjnEojJhhBobCdkB}`Dx{VumGlcPijJ|cFmdHnnAaiDlaD}t@loLpeGjlHhbCnmNaVhkIg~CngIueDniE_zD~tI}oQncN_|C|}NdYjd\\xqGraYsi@bwNu{A`hLegHh}McsFhlIonAvoNemL~p]euHltSu~Qnx@gbLtuHkuBtcSalLxhSgfFzs\\wrDptQ_kBtdOeaDdlAejCi]wfF_oFkwEavFwgE_}@wpDzgEqxDbwOwcDppTorGxlCy}Gb{K}eFagAggD{dIi|BajIgwEelAseEniFcmHrqBm`Fov@qdHldA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mxshHceisAoqHhwGozJtqOoeOlyYnX|zSshCjvFo}DdlBihIvuGcdFpyH_xAx{JsbHx`P}zR|xU}vLd|S|EhdSceFpxK}lHf`L_cHxqHgeUv{MitKpyIsyFhmGsoEdpHkdDxmBgyJktJ_zD_fCqnCy_DgwCu|AyqBfBetJjsIklG~iMmpG``TwwI|kL{zHf}CwlDxm@yiFpeHswIjmFknEUyx@wy@Hq}EzkCsxF|nGk_JrkKm_HuvC_pDgeLuiIk}MekQqoGiyQwUu{OmjAczLsgCyoJvu@waSnaBapM{{@{uC_xF}{DsuEcxBs|Bid_@g}Ki`JbA_fE{|@scFy{CkyEm_A}pEplA_eDhr@syE_bBubFgyMepI_iAs{D}hAkg[awGyne@ywFsoRifCadRooF{pSmiFot_@s~Awp@}oFbdNyvCxaD_{CnlBskDejDes@acF`gAmhHteBgjZhbBunF~rFevA`bFe}E`W}qD~pJ|~@jnCmuG`oBqvKwUklG_uCw`E_gBsiA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "w}b~Iud}eDnOp}CmoAtfZq{Fp_]}|DddLhA~|Kh|BhsNvgJbaw@csAdxLy`Jd`_@i`KteOw~Vhac@ouD|}AmqCnuCw|Dbpe@}yGvfMwf@nzJclCnjPc{Qtdl@uw@neJvdBdvAvmCeXtqAbyAqAvwDg}EzmIubEnoKznJr_f@|aBpbMxThjKtbNn{|@ncGtyQsZrxF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "w}b~Iud}eDpXw~UbbBabGxhNmkDl`KydY|~HyfWvrCieE~{Ga{@tkI`q@hkDz`BreErbI`vNpzGn}Mjf@rzXt~LdNmdBatC{j\\ftAciGxuDklEhfO}`AphFcsH|kJ{xHf{GobBhqIytQ|yEco@zdW_lJt|LekCxwIq_AxtLfrDhgHz}C"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}dfuIaqm_C_aVyms@_uWmdaAofAq`NqrMa_|@gd@ucGtuAg}u@bnBkdj@qLkkc@{vBm~RbcBwbQj_JwqMih@q_N_cFczMhoEykpA{CckQl`@muSjsEode@v`Ec~TgtBcho@mEctSqkAqxIcrO{h`@gzAqkMq~AwfL`pA{bKvdMy}FrmWwrWjhC{wYnlHm~hAh}CccNnqT}rh@xqIk~WhmGa{NzpOmfWl`Ku~LtbHilV~bE}tZt]y{H"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mwjdLswz|BfUzlXplAbhhA|{Oyi_@zwEuuIh}HccAtnQ|qDxxNjoNbzKnaQfwKd{a@`rK_~s@v_Pl}b@hsElyOoc@tnRs{Dn|a@ufMtlsAejDrhg@ss@l_c@|E|eRudK|kkArj@nwMvgDzlZ~yJd`Bbn\\qv@juUo`CzbL~aId|G|aIh_W~q]giOlvcA{xIp{m@pkMvb]fkYxpjAzas@tte@vu@tfAvfLdzUvaEhh\\l_BzdU`oNl|KzeUcb]hvJymN||Q{jMr`KrsA|nFxjBbjNbk_@dpg@x`dAvii@l{~@`dKxdYb|b@yzJdpIdgTb|J|gj@|qC~bUluAzyVfwCdehAxne@}_Ld`P}|CnbIzB`zHfqFxyQj`H`kbAtsLzfF|lIhgQdlMh{j@bjm@td\\zdd@d`i@rrt@zgLqrj@vtHmzf@p{MegGl{WwnDl}Oti@pfN~eNjuIpyJbfDpfGoeDfrw@otErngAw@vwQvxCjdi@nzHr`e@~hG`aS|hBdkDz|Q~iXdt`@jal@fuM|vWdgSqeFndf@bmh@vpf@{aZrh@md@r~N}jM`iIdaNhpDniErgQmcAtlSi}Bd~JvnBzhLdm@hyz@y{c@|_M|Kt`Hxy@bfd@hkJt_q@rhNncLsuYzuN}_e@~dEyiTttQ_p^vfQsaWrbK|iBpjLz|EbjHrbIxyKrnHrmHfgCjpAvnCb`@nai@nqBnfUd_CjsJzqT{~Bvpf@ooX~b[geTbpQuxEjxQn~EbsHffFp}KvFtxXhqD|_LblObfMhoTvrI`~Vl~An_Rff@fiOvkD`~IvzNx|H|sOpdHrnSp~\\hcFoXxgW}lJ|sZiuIxyXj`HdcZ~vFvaQbqLtmEbkRifBveMwxWlbOoaItaHsqAzpGuSpbKhfBxaQl|K~xDvgKl~ItqAnl["
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mwjdLswz|ByjEsnIgK{th@txDsma@mnAqqF{cDupCysSfuMikDssAanEadNkdDk`WuV_~d@jWc{X`QknDjuUuse@lcUid`@dmH}rPzvYmbj@bnNmbOraJanD}@_pPtzCyr{@xaCc|q@reEceMag@sab@}qDs`ZkaFiwn@muGoxKchHk|Nxm@s~ZxiF{r]lsHuva@vmC}}]d_Fkph@j`HckRtqAccZk`Hol[opWmxOm}Iw{Ma`G_bTqpBqdW{g@wlQ{fE_}LyzLszRmxO_{Boi]vxBg_I}rB{jOweOikj@uvTeoKiwHerFy{JuoCejOecLeu\\__Yyli@meAqnJ}h@wm]r]w{d@tqCaaa@iJ{tBgkAugNoaGoxZw`Ocrn@clCao]tRqvZhqPcv]pqRejj@foHazZjyPy{jAhvJ}saAfwe@}md@hmNjnQ`iDfeHdkNzq_@fuTf{a@zhJftA~kJmqJfpFemM"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "imp~@ywj|RmdA{|Fc_GgeHygI}xHul@onWnNcqWqtAizEu{Ie|H}~LccOkwFweKwgEa{AowMh{CecNfuAgxCiqCfuAefUv`FujWvdBg}DcpQs_MegAwwBf@idHilBydWc|CwtVnXoeJpnKozIleKciGt^}gCueDmhKtoE{cIvsIqfTnM}uK{xWxiEwsPkbFyyC|j@{bGt~Jom_@~qg@ctHp}EigNk]qkUhj@kaMfsBufGuRmqEwoAurAioFk[idFwwDkxD{vMkvH~h@q|QjkGkrYtdDotRs_@mqJebAirA{|FrIaz`@qj@odFdW{iByvO}UusXi~@moLkgMmrKi|Ckl_@}eR_mVawR}cTmgD_kI}lBceLxN}yH|lJ}jK}zEygIkmL{xJecL_eEicTekB}k_@fiAojXfgEs_RjzD{~Q`e@gbe@}tLgnh@suJakOtfAm{XpwK}o^j}Kosa@jfModDpiDwsH`yB}gJbeAukb@etDc{JeX_cOelOumQuvGijSseGswIzaB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "x|yiBfkggLhkUocBdv\\ewYhn`@avG~fC}`EdvOqxc@||BuTfgErkDjaGdjDrkJovBhsNysElnMweAj|McaCd{Uu`ClvSymAfr]qjHr{Qa|@hkJyCddJehFjiLqgMdmL_iRftN}hNbrIyvJvtGgeMd~Fe|I`nDmgCvmCul@hfC~uCbtSnfPvl^~_WvyBgLlrUa`Vd}G{tB~sK`G`eNvuFvyCxzWjcCzoDvyCbUjlEcvD|~Mf[jqOi~GpsDfsCbsFfdHjmFfGdhGa_BvuEmsHbgVwge@veBe`BnkAjRloNlxMdqHbp@nwNaLpdIuaArfCywC`yCmeR~lb@cwVbi`@myUfu[nH~m`@{jA`gYcoMv_Tq_AxzVo{CboMsgPfu[cvErgNew@t`I|`@je^}kLnxY{p@fgRjdBhvIcDpqFw{@~wEooJhgCyaDv{@o_PnNc{WacFmoi@gpEcu_@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["rbziBbiggLxcL~wM~}MreRh}AnuVdrFh~Gj{NgaA|lUcsF|rP\\tcS`gFv~Tn|ObcNt|X~cGdjWf@vfR`r@|qQ|iA~}F"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["svylH{bve@uuJcYg~OuyDqzGspDqfFmkFe`DgzF_bHgw@urGvg@si@~`HsjEtuUcuErkLwkGl~HwpJf`LivJrpDeuJvGcfDar@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "c|zvH{clNxhHmdAv{JgqF~nEieD|nGpiCd_FolB`rKecMxzJgsPzqFguNiYwlC}cAasJaxFyuRmmAykOp}DakHzjBqhDplLajIp_Mk{AvsJgrCbvCakGlp@ok^`iCgcVd|BkcEl{Xe|FzsBshCk`BuwDmgCeuDsTq|Fls@kqLhOs{PfzAcmQzrMenXnyC~]~mGf~CfwEfv@~uAekCj~EmvEjaG~r@zsDrpEdtChsA``Bi@poA{kAveA_fDr~Aasd@s~A_ma@ufGuuTwtGguBoxH_dEqeGa}KiwAc}G~jB}dG~la@zwLxxGaaI~cLmn@zoJirBcFuhKbcAa|MhgCoqIhzE_iKjhEcwPveAqmKfgD_pCvaE_aIpwKczNloGaeM_@szEojByeLocAorRxDcnN"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ag|pHesid@mPjg@u_EbbCx@nuEmoAfiN`nOvjTnuLltHn`IbvD~bGdrG~qGzu@nrBga@zsCt|Ar{CdDvsHaiK~eDeaBdaPi~MpfE|sCrvEnuBfxCpiCd`Bz_D"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "oyt~F}ikzGmtArqBc{Ipa[wwDrwIqLjiIigBtvToeDlmQw{EpoGetFlqKypHviVw_HtdPmxDbZk}VcqIm~UetFaoCpjCkyBtuHapBvaQhd@byi@mcVxmYifDvjHsvBdiPs`Fh`XgbDncMvz@|~BvkXtoNkcQnnNy{ClgH}tAlgLc@zwLhyGhma@tvHhjXxgFf}Qz`CtcRntDdfH_^rtXqjCl|KuoCjeCe|FkgAg{Ge{G_zCuScwBvcBozJtc^udFfwKeeIh~g@o`Qnpq@yyJlkPidGht@a`G~yR}eFtgXp`AfrRpWblQ{nLpu[{V`fZn`C`w]jr@bvEdw@lkF_uD|tzAqcJrkVwcJx_S}_Gnvt@koGvpZsaKdlZkpIp_]xgCbeX__Eroa@chDxod@jgBpxKriLl{JhuKzzG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}nixFwq}~B_fCxb@udEt{Ck{ArjKdnAvgXmoCtcEg`Y~kIudCtbGwvGhbH}g[dlNskK|J}xIq`@mjXzpGilEsgDe`C{|FyeIqAmoNtfAcm]_kH{eAmpA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["smq~Fqyo|BkpGg~A{tQld@{|]xgIicInhFoaIdaNorEhvJo{Dl`Tg~O~tIkhRz`OglCjvF"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "i{k|F{lj|Fb}Bi~Kx_DqmWbaEmdN~q@yrGsjK{}RtHeu\\dm@s`YhhAemLbbCmnOnwAq|Rw{DubGylPmrJkfAkoCqq@keBgj@ewMri@g_M|}A}qEv|LqrEt~CsrOngU{j\\t|G{|P|vBgjCjoCh|DtpDiiAxgFchIfvAelMu]wpNvsAsnGnbCw`EpwDar@`uBfL"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "uksbCguhhRzzGygJvjUbdClvC_|Dn~FmxAbpKjq@vsIymA`dDsqCjqA}pEubHet^sTehRz~DubGnvBwjFn{AsdH|xBaaFaf@upCmiHeyI_t@siB_qCuHekGprFi`FfzFssNwFobZywBq`MgVos`@tSgnHdm@y|I|eFe}S|zQuxKphDiyKf`BkbG_IogHtxCwpGxnAamCinGc~HqdIefNwbDwbJ}|CuvCm`Fgu@kbE~]wcCl{R}}Ni}H}fSh@olNlgDebLpmEy_F"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kzwoF{dl`MyrAolOyeDy|SctGuvHsyGyuEumDcn@obTzgE{lHljGchFlZiqDoaCyrHipDsuRmqI}pKciIkdB{sDk|AurKwmBww]iyGw``@sjYahf@ioFs`LgwBkdPpGagKafBmeAgiOf|F}{Du|@{sC{tCecAq}D~qGocZ{[gzSqbDuiXkw[ssu@tMkxEd{BumDpiP{rExqc@}oFrqCmcChOs`e@oiLyyXscBuiJbdAmlQmfEctHujCoeIliNgwJsiFmeNetJ{jOy`Ky}Fo_L}bJaoOysG_rNcmB_iFudCmoFefHaa_@{qUydG{iOo|AelNrpDode@qU}{RxeC_dy@_dEwzYwbEmvQt]kqZyzC{r_@meg@uoj@kpGcOaaHssAc~GevNweGqqR{rRw}e@ga^ignAcmKgj[~Ic{JsxFae\\qeNcfr@m|QmoMowByoLykB{zz@cdAeuBaeBcdAstLfiBiwJ~zB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kv{yFqgchGus@cgIaFu{\\cyAg}[mmDysU}qCiy_@oaCcpLi}@cxNtjCm~n@qjB}|PuRg_u@av@qk@spDxiFkbAqAepBkc_@isAq~C"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "wfo`Gm{phN_aUt}YgoTdj\\m}Cb~UopBp`g@yDrcTeaDraKemKzxJcgJdcMg}Jx`QkdQtmFogBjmFriAp`LaQfzTer@vgKubBfhQ{kFvc\\s_Ft`Vsi@|}[tk@xwOti@dcs@yjF|fj@wj@`_b@pLfpTg\\viIx@xuPar@t~XuiJrxa@mQvoLfLdrGxiGtby@~|@nyYk]~yw@u\\`zv@ew@||Pj[l|Hh_Sv`ThbBb_HyjChss@idLxe}@alMf}k@ufNnce@iaW|mq@y{Jhf]bzEdjCbeAx~Ffa@tsJgg@zwYneKjiKdvG`v_@xxFtxS~xGl{Ippy@vuSlkT~oD~_c@a{L_bAj{NgfHxtQ_gFtmEcmCp~PcuE`q`AugGvfKivEvuFskC|}OkkB`_WorN`fs@uQngUo_KdkbAhCv~IhOd`DlzFbdYhhAh|OqdBd_Q`uHph_@l|K`mPrxNflMf~HlyLj|Mz`C~vF`uHboN`sJj`H?nxGepI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "iizJnxvwIz{A|iGb|BtlFk_BviIhs@niMdiCr|MncApwLyzE`}Xi]`|Fc~AhkDmpLfwI{q@|bDdiExxLxjChxOmY`eGxpC~rH`bEb~GlkYfcPliHfzGfhC`oHkCh_Rz\\phSxkEzdNbgBzfMpL`cFdnMzkAvuE~fBfzB`nCrc@baJiOb}H}_Ex_Em_BjeJ}cA~{HcmBtmElZjdD|_EvhCjdDhmBbnHj_Bp_BjaNrkDzmE~vP_wBz|E`v@lkDfdBpa@neQ}J`pNrpEz|GxrFpbJpl@vvE{Mz}F{yGbqIe{IfcIksFfwXeiElpXuhPdwOioGv}ByvBv{FsoS|zRmeLp~IwoBv{JsoDntL{pHwPkeHt\\ovBtzDonAtfGidDp_B_aKsZgb^ur@cx\\dhAuiI~iQo_Ff|Fy_k@p{LczRrpEkvM~Hq}j@srCo_RoeDkce@}dMm|KwdGmsHqMglKnYknWjdCemNk~VynEygIwiIav@kaL_zKwmKotD}wHsvCkdDhh@m_BbrDmiHdrEsxYxzLslDn_DgpFhfCo{JadAwzKslDikDfUg}ExhGmqJbbPmZveMqdCp~IaQrcOkh@l|KwhChiFobFio@anDeeBknLqzIolMkgFebMo^ooQkeAuaOscBedQmu@g}JhaP}xHfmDquGl`F?`wFyvBtuJtmJpgQybA`kM|hC~{HsZlyUarDnsMnvBhvP"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["gbhoI}gfr@n_D{lLlwUwnNrpFklI|mAa{MpL}lc@nYo|GpeI_gv@~cFcoLrIq~OetE}r]s|AozUlbCg{Gfv@gmKBk{A"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{dowDacby@wiImhViuJua`@sxGybP{lFciFef]ezWwwOw|Ku{UetPy}NawFcyMyDuyPhtAyvi@xxLaqh@lgJu_OuwGstFw`FeoRqjNe{BacE{aE}c`@{~KmgL}fOsbIwpG}rAs}GenMe}GqhPwrJuuIe~Pe|a@klOsz^}gP_ad@wjLou[atJo`EiaIpLg~UhrNmdZ?_rUg`@cjLaq@oad@}zE_dDgL"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qs_{F{itqG|yGkeC|xHgaK|}BmeLllDwaFrbC_In~C~iVhnAlq@nmAcp@|e@{}EhiKmt_@pGetQxvB}xHxjFs{Cj_IkqNjvHglKdjBqW||CpjAj_Rtwa@vpExjCz|ElPxsS_hNzpUgnUjcPum_@|rQyuk@noJkQhuLtaFlhHxaEphEnwAvsA`mDgQrok@zeAntEluA~|AtfAlFpdCq_OftMa~WreMsjM|eE}~MpiJaxOxpIqmLntLo}SqnCkjVhdKse^pgGkh@vjF~|@v`GzrRviBdmAfxASn}BaqAvqE{nJlwHwpL~rM_gN`jChxEhSlfMox@raJ~}Ah|B`xCcFbbJomMzaGcyAz`MjRnvPeW"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_riqFsxfpGq`BciRm~Gac_@jjC_wGnaHukHpwFeuCxlMoYljAkzBizC_sNxyDo~E~}Es_Kl|Eq{SwxIea]exA}}MxEkiKnkBesEdfJgjAbzLdlAjqFlnBtoDeiEniLktWzlFyfIbzKz~Crj^yjQnfKkdEz`N}eF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "yqlxGqnpzBmwCmsF_sEojk@voE{rS{jAyfHwhDaaHcfCg}CaoCa\\qrDwmCisA}~MdlB_sf@izF_~N}gCg|D_mHsrB{qFudCy`CweMk|EjGmpFxcAcyOqgG{{Ee_DapAa`GghDuuHu_JcyOyqHh|BgbFokBaiPuoPwtOgkLgjGvFohFu}@y~FgxJilI{lKio_@{jOumDizD_eEuvIucEm_GgjTwZkdE_nFk|EomMgcJahM{cLasJucEw~Gis@yzJkdDw{Ky|@{lMdpAi~Lci@}zGskEsjLacWqda@gyCkzC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "adrtFi~apLccByjEaeBohS{`Bq`h@dhA_~LjnEa{NnmEkhKaGivJ}i@wsHbx@mbCnvDebBdcDy_D_~E}sNk`HweMkh@eeJgmBwiI_`Eq_Bk_IkbGwbRqdVyaBi`KHixFnaB}JbyAowBxkCegSu_DudE_~E_gBiaJbaFgsCnCofCssA{oAmxBznIei_@wEscFs{DgwMujIwoLucGi{CynYweaAwxCouCwnBh]odEfwZnmBxnKXlrJa{Bn}Eso@bv`@uuA~kFwbRljUygF|iNcxC|jK~TxnLn_Dr~NehAx_Ds~F~h@saI}@mxIhgBgoAppHlgCjhKkjCdjQwp@~qNivUd`CkuHnhEqdI~nE_|A`xEoaDpcJy_KrT{kBfjAir@r}B|j@djDf`Ef{EvfLokBfhL~rArtEz_Ch|C|xFtBp{G}uEbnNleg@xlAbnAr~A{tDblQnmApvMmnA`_UesE~pOyy@~jKusDd}R_jFjfNs}YjkHcsHz{G{`AtkG`iHjaa@qeFflKqfH`_VcmBdlPq~CntCkcE{We_]mot@_tSuaTkvG_hLuxD}{Q{kB{wMe}Q}oF}dAwzA{k@{nIuwFqxV_sOije@}pCqVc}B~yBioGxcOuwEbjQdpBfcJ|nBfhE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kaemHkd}qBdmAauShwHevBjdImdAkVakb@uwTmtRsrAgeIqqFekO{sEgyIfdC_mFn~L_wIlgJikJbmCgqE|mBgU~`A{rEjg@yzKzkBeqGfnIaqApnHyDfxEz_Cr_EzaAfjA{{GygAi`LukBqeHryFisZanPswHk|Gm}I{cCafMamDy{KmzB{xJlFicGsr@koBpLgcI~v@ivJu`Au|NfgCk`Uv`GqwLjvAcnL_NqkNcmCqoIiiNihNrFsaJklAejPdCeoWbhBknw@tzDcdMloFkwa@htGwcNdjIwvEtcFwnBt~Imsb@r`Myys@pt@{xK"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "adgoIj{`k@|pKh|]lwCfxCtdRjuG~mD|_@~aIn}HhfJhlH`jCb}IrmBfiOrlBxgHgv@ttJ`HxwM`yBnjFt|AsJzjBelCvcDk}KdtC{jMraCxq@bsChuFjnJv|o@z|ElqMrqCl`DhtF_eDl~Us_f@`oAosEbkLmwDvqD_la@vjGqbM|~@ecKgVsjYlcBcrIekAu~D_lCcnBejJqeUw}C}iFa|EllCggDbxC}mIynLmiIwjOtHgeGjiEi~LvyGkoJ~yEwp@p}CgcAlrIk{IftBc`FdcAo}QzcCylCvjNnkBfbD}xApGmzRwf@gaTvQsjF_fBerFcnB}uJle@kvO"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kaemHkd}qBmvDlQ}jMzjCmc[lmh@}vJn`D{oCis@ymFj{AaoCv_HujDjw_@taBtlGmdBxrFkvEl|JgnDbvSqyA~fAayCtmFuSjcCn|AhtApcCn_ErfDxhTcdArnGspCjvFsxHfyG{qGfxKy`BnpIkoCn_EcoBfj@q`FslVugFwbDcgLf_Bgt@lnBjnCnhH~|BfpRby@x_Q?peHgcWflr@ckFvl`@icAvtRjmAzbA`pL{{GjuOqjNhmCfVryEvlQh~A|mIjxDhiKb_GjlI`sBt_He\\~xFkzBnhGuuWnhT}{QbxYsfC`eB_^ljG{iCzyJgxDp~Bm`E{|D_pDsdGilBymMweBokCuyCuqA}fEejD_gAzk@maFngIytEvdNp_Dvci@hqBbqJ{sCroEkxEf}Cuh@ltIseEtqM}`EfiPex@h|OcxGpcb@eNlpL{_BrzFesEfdGahFf}E_wM|qBouEl|XoeCdyXrcAby@`{Mqa@d}Ffk@h|Cp_PdNtzO"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "adrtFi~apL~pBwQvmE`zAt_Jtqg@biHllQ`oOh}BvwChzC~{BzgGv[|cGykRfmKy_CxcMuyEjlSqgL~rf@awDtmShsGrjf@nzJp{l@zeFtcFpvF~zCd{DgMfzFqhB~~DrgA~|@xsG_hF~~KeeCjjJh|H|pDxuPzsEl{Kx`BfrQa_IlpZykByn@giQpA}_MscGomYcFiiLjpB}oS|Ue|b@ym@mm[tQszEieDouErx@umFdiEe}EgtFew[ga@whTzfA}`LnfAaxF~dQcyLjiJmsIhsBa}KgjBocg@s|NgwJ_}BkjIaf@kpO{_BguLuoEozIiuDoxMic@c|KjeCckE|oDayA~dF~fA~mFbOx_DkkGxd@_uWjuCasJzyG_Sr{Lt{@zqDwiIzMcjDwuMicc@{F}bItbGuaGrvHuiKtkImcO_r@uzBwiJ{hFoiKywLk_Cc{X{zB_hM{u@u}M~~Ckll@tSs_Nk]gf^ymAopWkkFwwRs|Da_IwnB_fOpQgpSvu@m}I"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "yvjqFaoayBaGadChgAqgFniFu|Ltq@oxMozCkaGsmCgtCohF{_B{oGaf@myAelA~]whJecA_rBysFdDepHnhFyvJvlEarDh@ugAqiDgbD}yGuhEcwCycB_kHkQyzLowAcnNaxEk~HwuEon@knQggEk`HoaC{fGerEgcJuqBsmIm`FokCewModDgkLenLibIipJetDcaFi@mpJ~lGofJzgEkqMgt@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "n~otAyusiEocMfnI~pBbuGx|Ht}JptAvmEuHdjBmoAdcAyiEptAkdQdfHi~KvjIo`Dj~Iq}Dn}GkxDi}BccCkdC}fCnx@sfEx_Da`HjnRi{B~HuyFaePmhHozIy|GckF_pRkjHumRqqFoiEytDa|Ku}@aqMtg@_pQwwBipPmz@ayE`wDexJtzCacSwwDyyL_aHcmMqij@_`Lud]mvDmkEqcJygIe{IotD_gBnaCuG~uVmdCtyDmfe@jcPkyj@}nHifPyXmiTlF_qNp`BipErnFmjGfrCe{Ukf@guA{}Eif]eaNayPytEweMv_GciSzzGc|Kf_CsfC`fAm_GkcEwvFqdIccAikJ}sB_`Kkrd@k}d@{hFoNarKz{Ee_RxcMkwFxcBqyUfu@syEdsDgkN~xSkeOz_OclOe_Ds|PquAqyHf|F{eIpxJs}MnhFibJ|hBmlCvhHeDroGd}EfgE_SjwEgkAhdGmrHzuA_lIdMw`F|rD}xHblDkeDrT"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["edmfHcsafC_{^ycAc|Ucw\\oqJohFmaXsbJmvJciGuuHw~HukHy~FmaGwyA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "y|ci@`qfeAkvGejIm_[qeNi}YohTc~NoyR_mOswN{qKgsO}tMqzVyue@knc@knCwpGqwYyyDcca@ccHeqIeqI_iEyyWq|DayDk_WgyGi~ZqsD}`EyN"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "go{s@ghkrCtkAcgH|xGcbDtv[x~Fz}PspDrdNweO`mEwlOxuBqvNljHayu@npIuwUfv`@y`]~s]gvd@xgO}dHjwMfu@r|PneJtkF{u@||PejPhkQszRdmSmic@t~^u}}@nlTcy[jfO}yHzsPyaObdOgoUdmKcbN|cb@rkIdpJccBz_IqrD~xL{bL`yPqgDzeUi`LhbIaoNlwBc|XlhIguLduPwn[dgNaqZtoI{xJviHghFd_J{gE|~IeaB|wVsTjo\\cvCrdSoxM??"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["shcbAaj~dG}ae@crWen`@csTceY_|O"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "shcbAaj~dGjGdjNweAl}J{mErcGw_F`zOeNz~QpqEvaQrdGnt]ftAruZdpCbhUtiDtnQk{A|sOayCnmMwng@vcB}}j@xkBila@sJ}|QkbDwjFwnCceYedYqsIa`Haij@s|\\gcd@ksXowZidR"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "`_dZ_ymrDdgHcExr`@~cFpq_@rdGhjKdMnmOywBrud@obNzlZk_J`nO{hDphR{pFvn\\}bIp`McoAtkIpaAh_d@xrSlsJzaAdv[cbD|tZawEnvNuvHvmj@yfVrsM}gPjvTe~^pzTaf[jiJ{yIjtKc}H`k_@esRhjYa~JpyVohE|o_@{kN~e]_iMl|c@ipQfaY{aLnlPi|D"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["czakAo`taGwmDi{DsgDkaGno@awDjwYyfd@mV}pEyhGqmKsr[uhJ_mIq|FpH{kBs_Gy{Ve`HauT"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mxshHceisAfk@ipD~eEwzNn}EmqK~pPqxJntCmnZzMava@iyFskKcy@cgJpkAgvKdwAczYmeM}~AqvMmnNoeDo_FhOctRe_JazCgo]_zCkjBadCnSsiMbqDagMfoC}gCsJalFqaB_kIg~@ujJ~fB}}PpzLgke@haDkxRi^mpKbEiwJjlTcil@f_B{s^pA_|[{mEchHenDaiKdWeyKxxAcfJvhHiyTfkAsbIlo@qlLfaAezHjdOavG|hCazC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "uwnaFwfpaGs|Bq|QupVkab@}~TcsSi}@ipE|eFumQl~@eeLgiGam]xkCyaQhpDufNrJqoG|tLczg@fu@{dIxt@w`TjVyj^c}GgfSosGihMxEu`IdaA_vHfuBsdGxmE{|E`fH_gBrm\\~h@xxF{aBhqDioDf`@caFwkEgpGiiH_|MgdIckQgiHutLcnBixFdNikK~r@}_KvmCytE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "q~_}GqdfaB{eTad^i|DmnNx_@g~Pk|@kwDeaBcp@a|EeaByoEap@kcEcp@smBj|@qa@`uGmcNjeCivDanCm~BwmCmlQroDqgEqt@i^i`Ms|BusJgnCsnHotDgtAgrJixFmfM|dFogHvpg@kpBnbAy_C_mHyvD_aIanCuyD{RuxFdgAi`JrhIspRrn@}nF}~A}fFoSkvFbKcsTkkAueQg~IlbCy}Fq@yjEnaBy~Ek|@wmDmkFcgKweAogGikJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "c{hwG{hzi@lhCmwEdqC}hMsfEoze@wgEqcWwqE{~Odd@epIzyH{ce@e_DarKsjLynZ}_FwbCuhTwtToeD}KqjLd}G{|AowAquLurY{cKi_LscG{aMuDicIhwAcxAztDce@rlVxZ|eFu{B`yOq{SjqHu{MjqEgpa@xcBur@~sKzoHlcNy|SraJovBlfEysHu`B}tL_zDknCcgIbkDyvIr}BseE{XucFywBs}H{nH}xUyzX}dLwhHglS_u@okOqAg~BmsG~{AspQiIuoD~`IapAp_O}{FbiGwhHb~@c}Hn@kuJmxHq}[yfCi{Qfd@uuIjtEoiEtnPmpLh~@avF}~@wiHw~AihBivEr~A_sMp}BuhJllD}hDvaFk{Edm@slKwnC{jIc`DkyAqzH_i@uiJj~Is~MbnBovPqQceL}kEgiA}_FlYw_H|zFosLkq@}kXscH"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["{h`}Geqx~@svE_J_uK`wFk~BdxKh|Vjc`@rbAj`HkrErtYefIxgVinFtpAecExwBayDzqRg~BrlWRjwF"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gkuaFeefpG{uAwHyzJjs@chIioF{_CbOg`LdmN__LvtTehA|zDqzLxDgoIoXymHj}@}kDjcCsgCzCeeIkvGcuEprD{oOp|^yhGt_Kos@|bUkmD~gAopJcmBu~LyrFewLk_K{gFayBejKqsCowGar@uiKqlL_fBs@ykCzuB}nAhwIc_@`~IkgAvbCkrExn@q{Yqj@aeOlmBuuJjoCimYazAwhDxsFw{Lh`K}uJjcD{jCcxAavFwpAybIqu@ydFxNo~E|aJwjFpfGicGv\\y|H|gBizFfsC_dDpaA{_Bq`C{kA}sNxs@svUrCipQabDepIuwn@__LkrKyzJ{gFgwLr}O_}Yn~DqcJ`C_zE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["ybfhI_zinCuvBpj@udHg`@wgM~HwqKllDgcJfiO_xFlcPa`Gd{TqoBldOq\\fzGasC|~@a_CteBmoBpqFcvCldOy_@puLtrFnfJ"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "`i_q@qauzDnbM{~CjkVopI~ePu}JnaNu|M~bHiuKxwAmkGa]iqt@rcHggRbrJevOn_QwdCvgJi`Jp{Gm{Jza@wcDmdAkvGcEiiMjzBkhLf}BmjEzaNaSvvEy`C~rAmbQbd@amQneImxPby@gfRjeCyfU`_JepIjhJwtV~aIi}[pmJsyStdD}`J"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "guedIgv|j@hqQhs@`tc@cE|nE|_AbnNleKzwZv|K|fQvnBlnB`{BqBfur@ldBxjFf}Bf`@nuCsrAptCtf@vxBdaCl`EafA~zEo}G|fC{iOrKwnPaWa_Hb|CsqEfqFioEpoHxN~wKlpAjyJngGvrLxzVpxC`uIhmAt_IhrBlxCxpC~fAj`CwO`}Ii}O|nA|K~tD|{CdjDtoE|bJtxj@yZxaQhpD`iIl`@teB}aDfmJszDdoXv_AbsHzeBdjDt{BdaOtbEpnJvzFp@~iSmjSz~B_dFzqF}IfpHgzHj}J_bIdrFeb@buFxd@n{IheDbpXzsPr{CxEdvBco@|_@c`Et|@irCzkBhj@bvPx~_@dbBrgCc[lyL|}AdcAxwCm{@~dCckDpeAqxJpnCibItxG_cGjd]vsI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["u{e~Gkcny@irB}_BubEi{AuzCby@s`DlvDikDlcBefDj\\}gCzv@a_Ch`@wcBby@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ugcm@doxr@}mG{_JpeAygNjrEilVipE_aDsh`@utPojKzMgpGjw@gxUgjIczGafG{oHwgCe~K|i@_zC|eEp[feG{dB~wH{mFh}MusEprF}b]yiAgiH{k@okD}gDim@kfG}[qdVxlBawQr~@inOSmyGn|GaaF~bHymHgAwjGaxEe|Ayu\\`|@kvNvqDcdN|qKq|Kfr_@}aQ~WarR}gBehFm`FqmKufWytEhgCocFlvFseFzjNanV{oB{|S}V|iAp~K|e@|iLkmElgJouKzlHm~a@rw@elg@c@uzPhy@qpH}rBmxGqnJojJwpKwgFcnC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ugcjG}nvl@y{IbOaeGht@s_He}FwrI}aLiiLgaKmtHe_DqlEpjAapHvlD}TbkFb_Gnsk@gaAdfIgmKl``@mhNbqb@i{I|aLw~Ip}CaaFyuBizEp~AigHz}EwoIqhEebLsaJq{GspDyhAchHglDwmCerTtlF}mB~zBwtA`mEqHzzH{mChfP_nF`hKuaIrsA{tH~nE{{G~`JevHfk@qcDurKmEkePp{@gbKurNecZwj@w~HkkBm~G}hTioFikEwwDcwB{j@cmCniDc_Nx}TmsNj_I_pPxxN{vFfuM_`Ep~ActF~ImvEq~AeoIasY{eJ{tN"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mzgdLskxoDzkAfaLfoH|jg@vkEtsWnuCdu\\hfEwuFbi@whp@tw@erFteBanD|bDu\\xgGn~Chtl@tgt@xrHrt@jwYmmPxp^}lW|_M}whAp}Iuzu@||X{eb@fea@way@zwKmx]|}Bev@|qVrcHvsVlfd@t|Rrya@j_Wh`c@dnSbe[hpWrp]t}FjoBloFbPrhGsfDt_]{af@riNkfNhqO_eQx`QisN`eOu`HhwN}sN|`GavHfhJudOlxOuoRthLinEvdm@cn\\rwJg~AtuGdm@ncAt}Kfk@tq[xuDd_^j|@vp@x{I}eSzrQhzP~sYtqAl~LlaRdgBdx@zuAmZdcAgkBnvBkib@lxB{`BpzFqCfgFncBlkDvvPd~Fn`RriF~eCvpEuS~`JunEl{KmpK`bGu|NltF}pw@xiE{hFbuGmbBrnGld@`~O`hYbpEoErxNgxIzaNa}K`jO_ev@v}Gq~QjcFy`D`oJcwAzmKfJlaJpiCtgMrhPbd[p`g@b}Itgg@zjAnmAp_HgnKbcc@q|eA~{Oqfm@fyU}k}@b`Qagg@`~K__LdlMamPfxJsqRnfIybMpqEeiDlaFnN`jTf{Q|nOhvI~dWr{Q~zOdiRbx]``p@hie@bhgAbrJxwO|dSry`@vog@p|x@d}Gr~Mdi_@|mn@|gIbsTxrHf_Pxp]l_n@deVnoq@fpTbrp@l|Ij{MliG~nQp|FtaU|lClhHjo\\n{p@t}g@tedAdpNr_L"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "oq|hLcgl{D|uXwrIb~GhIvuGn`DpmCn_Fz|@|_MeXp{`@{dI``m@{qHzu\\{KdgHld@p~BbsH}dFbkFh|@j`GlnCnhFffE`cEvuGp{FreQ|fEjo^ndKpxuA~jDr{E`|`@h}Zj~CdsFxeCzeIvmDjy\\"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qkqiCsnyoIyn[kr@_gMrJ}yTyn@{h]{vLmqe@ueOusXqyJohUcgI}{P{fGkmQkoCe~KzkAevCbkDkcEtpCayHcoN}kEo`\\|j@ccO_wCimUghCaxPwwD}j@quHn`DcdMvjFym@ndXi|BzqFk|S_wGarEhIyxFpjBgbLhsBc}Ooy@eoJ_dD_gHi@qaRxmAo}O{XylG{hD}yFwiHg~BgyGnHgfHpiBwiFf{GccBtbEp_AdZheD~pAny@nzJwlFvrJ{yIe}@miGscHkjHgkFgyHyoEuiKqrK{|GqeGauFsc@uyE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_wk~Fo{mgHbvKbrI|sUjdP~~JxtFrbJ|eQpwJxl]xaD`zOtjWb`QttVl`SbsA|tLwtBv{e@mcAl|LslIhsf@_kE~_JimZb|IwxJxfKqpFzjN}kEznI{rEdkCoqHhbJegMdqSioLv{MgtBxoJlwCloM|i@tvGekAnvBejJlyAq_Cl`T"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kmeMtfjlI{Cz{GqhEd}EimFpa@gpGnwBupAzuGv}AhqOsbAnwCmdHtzHy}HhdGgsHf_Aj\\phD`vG`rKxw@zpGigA`xEtSzqF`jHreRxbA`iJ~kHtaGrgCzlt@xmAr~LygOxz^khDtfGgWteCb[fpBhrBznBtmSxfDhpDtyCjoCviGfdGdcGz{Ftr@fjCeoKfjN}mIzhK_jJnzIubHzgKlf@hlP`q@`}DpqEz{At`JolGbng@soF~~]_t@laLe|@nzD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "oyt~F}ikzGh_FvwCttKpdJtmEx|Gf`@z{H`|AhwH~wEbmBrxGfLphEus@pkAapAj`Aa_IfmQy{H`jHkpNbrIqdWraKgoTrbJqnIjaGr~@hwOl`Fp{Lz}PrqBt|Mwi@rgDajCpxHswIxtRinGxiTpvAlmOnfBpxIsxBxiTmjFlfXqgFncLejDjyDaoHk{BsbP|gx@wvChrZtcDzmKnyXlci@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qvujAvnodAurMqj@mhIt}K_`DbJysLog@k{[wxDk_JfRgoTchDauHhoG_dFr~@{mJfoHugOv|I}_LroAqjIzyB_rNfnIimAvuF{jAzjOrjDdvApwFraEzfA|oDqoHb_HcdG~kBkmF{Bk~KneKozVd~Q_uR_~@}qIsuJo~FmnBk`Hga@{yI`iDkqG`gEe~Q{v@uhY`q@gfLnrHyqHfuGolItdKa_ObkIi~TyeCk`Nw}Bsl^|jQ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kmeMtfjlIjpA}vCd`CabGvhHk|EblFq_O|kIgjZxDsuKldBuyJbcBkhF}vDwzF{_O}~Zu|GksLuwEgeHwmEq{Eev@kdD~zBcmBjdDq_Bn`B}}Hx`E_kV|u@uvImcDkaNuvGmzKe`BedEjuG{pHjhKcoE`jDakCgg@yuH`{@gbR~{BidMmJowGwmDu~JswIwmEuzHq~OoaHkdOacKogHucSsuLosG}qCupMa]ihi@ohR_wFiiFejLwhCaoNawFm|K?_oK{rDgyIeaJawEcdGedQs`LsbPoaHc_e@cxUswIgv@wmEk`HwdGk_BiaI}sHm_G}cIgxJ{iCcgKumF{dHwiO{eCc`E"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "y~ze@oroOclJuHiy_@ykDw{KkoBkwHcbCiuJrfCqzNlcCm{Wp_AgvFkcDqkHow@uuMle@{dp@RujDs~AoaCipBcpEmFsuKbtEqoM~dEyzSwE{eSlnAweHrfCkka@aeB}qj@cx@uhRrs@}tLg_Cur`@cdAg|_@~Io}r@geGcoAiaWokC{t[wkSgxK}yXcjF}qXhiAalGiqDqzL{mJuxRkvSowTbZsuEyuDk`DsyH_rAq`MeyIevN{~QkwGik]{pGicTlpL_vCkGujJacDmkJehGmtBgqEh}A_hNu]irAiqBgjAco`@o{Hq`Ht\\mmUtfMy}NriAevVzaAa`TbnBo}FlbCcuEnsFajCnkBeui@`o\\qgScPk|X}jKmqKkbG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "pfh[ogxnAq`B`yCodLh~MiySpsPkdBtlE~H~vHbtFfkNt~J`eNj_JfkZjdEpyUppFz`At}KdjD`bGfqFtpAffSdpJzgF`jUtnPdeIbqJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "k_yzGcyxcBcxCfhP}~@hxStqA~{BlsAljGjuChfC~nQifBvdBx`Dsy@`sV~bAtxFb{KbzKllDddLpzBxvOjtCrjKn`ChsNhmAriLzrDrgDvfEteBd_EcZnzJcpL~sKwy@hnNbn@jgGdbBznDnjDnbFvi`@huKpqa@~{AnXfhJywNhyAkS`lE|`LfmE`h@hmFyn@htF{|Eh{EynAd_Dn_Rsy@ruX_rHlm]dl@`tIh}CviI{bAnpIg|DvrJuhKxlOipFv~Fk`GtgBcd@jnCpiAtxE~wHfsD`nPjeNxvCdfJi_@f~OjH|wVnl@xwModEvbQbe@nkCt`Cf@blEvvEtdC|bJimHpmr@yyFdhF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "g`jwGumkrB?t^naCxcLtfA`vTuq@x{IrkQ~wRjjBlaEzrDvxQnxAxlNkfA`fLoEteD_]pry@y|Bfr]ieFxtR{_G|_L}zGbkEckDleNa|@~~VsxGduQ{uNrjLgmKvaQqdHpyUu}KlbQevOfkLaaNhbWqkL|wa@e|AfoI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "yqlxGqnpzBykB~dEebBzoHkyBnkk@j`BtoPsd@hlV{jB`uTjvA`dOzfLjhMfnCtaFpzAjpD`dCvfKd_DpdIhrBtrLcOpcKiuDdoJrh@vbCxfDhsBjnCpfEdpD`dPcAnkC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["k_yzGcyxcBqiCp`AgsOd`PkcEpgFqfGuS{tCnkBchBheEs{JpiBg{G`}@}uDtzCsd@xed@"]
    },
    { "kind": "International boundary (verify)", "lines": ["ebeuCah|wH`_CrqP`iC~oOwBdxLku@haJmcCbkFaoO`eMelTl_I"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "|hrkBojdyCltHtzBzaM~|AnoIiqBzaM_zFjjKahJbiFyrG`dQofIhvUogIptPonLvog@isf@loMekCfjMioD~sZo{WzdH_{BlwQ|s@fhw@_sXf{_@wyOx`EufMt_b@{rl@bd[{wf@n_Rqqm@doKeea@fcHa{OjwGsmG`zOi{Ehg\\wnBf|Qae@gWiwc@ru@cl]lxButI`lDs}BfnKt\\zqQqLh~Mol@|~NjdB~yQvdAtiVpm@~bH{tCnk\\yl\\x`R_kK`z[ebLngHwuFduBkdEldBaqY|aKcmcAh_Jaci@hlJio`@f_Bk}Lf_BuxEvyAshAfbXjeCjaGen@fgFyuBxtDeuDtpB}{EfuAomX~gNwfN`aFutH"
      ]
    },
    {
      "kind": "Indefinite (please verify)",
      "lines": ["oxswE_ezyM|~ApuMpu@|q\\{HdgIuLpjMijE|r\\kqGh_g@{}Jtfh@omHzzT??"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "uad_Giq~iDylBflYl`@pfHtyCf|Dc^`gKf@vdNtpDj{NtjAhxGgbD~uJigNpzTwsI`hLstAzzH|cBv}HhrBfnb@xeEvkGryEdkOjgB`oO|hA`tVuHdnKvhBz}Ef_IhzDxwHp~B|}BvnBzyC`o\\zrDjnEtnDnx@tnDcQ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "wmmfA{ggsR{}CxaBuzdAhmb@wk_@z|Da}WabE{jGupBkcLdfIq|MpjMgpRrlXw|]dv@}mc@ptDkhKbsF}mUvsJgrQdhEqdp@bdA}}BufBql@{~P_pBgcVe}FqsB}pElaCgcJmxM}kWsdTaoX{kOcbO{xJq~Nw_FurUixVqsN}z_@}sBmhUqiDefVqqFcgU{UopIfdHusZ|iAu|MaCqtNt]_gOe]mdMwkEiz`@baDw|b@}~By`_@kkFguf@dtCunRvkFcwPb~MwnAxyEcbC|gD}{DI}{FmmI}bIswIulGo~@ywA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kdveD}qp}ObsBj{@|nN`uVxhG~eCtaG}fD|zEmjH~oE_fCriSokC|uDi_KzbLgxVppHo}SejEe|b@|hCqdItoC{sP`l@exL`kBy~FrgBkoCrbC`RlfC{Vva@yuRdlAajI_kCu_b@q~Dsbb@ucQufOoh@maFaaFgfSfvF}zRvqIo|T`eB{xJht@whVsd@wtUo_Dgiu@fsAay\\iaNqkZf@otDjsJu`Kb`@wa]wrDq`O{iC}fPgk@k`JuCgyGnc@atIe{Ba`I}xF}rCgxJ|_@eyKpgFioFphE{_Ctf@ygHg_AgaLsqD{{M{eIcnMroFkuOnqIqq@twFzyBjnReWhcTm~H|qOeoK~jKeoIf_B{xKiqB}wJkoDmlCyd@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["}qxF{odzRozInM{hLfv@{rEf}]izCzvMtoCpmVtePrjLhaProG`lF}VxkB{a@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "keif@ioabRybHeuB{z\\kpC}{D{_Bk{AixFpWawG~|XykOzaOqti@`yBeyKmkEayOz_C{qFzrEotFzmQamCzyO{eJqkA}lUflA{|F`PouC`}MekClzX{`ApaNxbAdpTvdOxtMldAxaH}nG`uHk`JjmFohEgf@sqEo_DukGeuKosFyzIeiDodK{v[m}Iqt\\xb@e`CjzCwxCjzNqnHfjB_qDjr@w_Gwu@a|L_~GaeOgyOqoGqgLguBm|UcgVaeP_qAyfJykE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["gewtHauqc@xpBgjAfjIgdUfeG_zEn|Fi|N``IbeLvmC}~@dqCmwC`tAg}P|qEo~Gx`IwOtlOoaCzhO~~c@~eQ|nI~qB~\\"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mejwBdkbuLhzDmgC|jf@c~GzrKc[n`Rv_HfpFuh@xpPmkRxiE}JvkEhhAxsOhrOplJruKraLo`CtlKwhIjkIah@pvL|cB~`PlyN`cE`gGzVjoVzlAlsAzsO_vJnyQwfLdsMyrTpwLayC|`LtdD|d_@r["
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["skynAqzytA}cb@huXgcl@n~_@a_i@du]"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "szqpDsd_{Gg|^mu^wcPowM}bd@usY{lYsuLgi\\afLezU_lJkdC{kAwvF{rEk|F}sMumFibTchB}yb@_DodXrIotDvuBwyNdiQi|j@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gnbiDg}wxOesEzbA}pDu}@ibB{gEq{BydYwjGmm\\mmC}vJanCq{G}_Fk`HnHulG|dIskYvkEygHzmRuzCfpF}|BzwRztBl}n@nxN`~PebB`bLweLhcHqnJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "i|yrA|u{dPuaHzaAgbIcFcpLs`JcfQerSolHotLcz@skEx]a`HagDgtG}pK{mFqaGexFgeGgvRufBkoCc`Fbp@isL|gCwkGuS_{BumEaWawFekBu_OrTk}EtgAa`C"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["~o_x@mz`tVfrEccBl_GwjF|h@}}Ccy@yuBzvAmz[owAgfF{mKk_Jq}EehFmxMq|CklHye@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["rqqu@g{myVnkP|k@|gC_gCxbAubF{wJeyWjfAquCphDkxCduN}AhaLzpH|^t_WztBnkBn~FtHjvFk{@heEgrDd|IidF|kXmvE"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["m~{\\{gw}TnmE}pD|tUwrJrwUgqF`ua@ymAnwMogHv_Bxm@hnA|qDp`@pqGaiBvzM}bDflKopd@pyIkfT~yC_jX{KgjNpK"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "__kKs{b|SrsX~pPbjH_}@zeG}gCjxDiuK|q^upBv}P}}NxkOeaO|_G{xJttJa~KzyIgcHrcHorHz{G{lMl|d@cdf@|bJ{jOdcJodKt|BctGcdBohTaeZqc~@gw@kiJcvC{pSzl@{ec@ngHsje@tGglKsoDezJrs@okO`{AiiNgkAmtF_zRchU}zD{i]qqRixHanQgqFyuR}qBo|FutKizEmwPctG_hYqp@ydzAlxBsyGz_I_|@nsF~{@dpCsqB`L{bK|rCcgJbyNuml@h{CckRcf@uvIxcMmhT_yCmrJo|HqjN}jLisMcsIqbLcbCcaR`QmrWwrBo`\\iuDc}ThkHgoWs}AsoEwdHueCebSusKsoLqrD{|Xs|CieEokBupBchH_{CqpH_xFwnA}_HwnBkrFj{AckE`mDmsTxuD{zHa{@yiFapB{tB_wH_|Nw|X}rQc}UgcHwpKi|DkoDapGiJk{Gx}HmgCxqH}hIfVqbFsJ}uEk{AsoEpk@_wHh@{nIabEkpNocMu`IgcJzfEijKo{AomM{~CsuLkiQgqFixGmd@{|Evy@acYaxCiwB{b@mlOk_Ho`Jm[etXlbDalRmeBydg@cn@sdFykDixSkcEcuTu_IozJqfSapNcsIi{AotCaCq|EpiJqnWcrKk`U_m@g{Rfv@olOzcDegHnvBscHcfKqqRlcAsnFvdCy_FeCwtH_bBypJn{Amm[fRefq@|jFopa@bxSsz`@peCi{OvZisg@cwBweZ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{h`}Geqx~@h|@_eDvGgrRzl@ukTtjIqwL`pBcoLxb@}eRym@c{K_|B_fEkcK}nFq`NgwL}uFoqTem@yzc@sxAylQjDicRfiAqlMuGu{MgnIozd@ehGs`f@vk@mlD~vAoXlkEn~EhnG`xEjtH_qCflR{fUhzMecKjdJujJl{DyvP~qBuiVrh@mwRteCysStkI{|eA`{Auub@xMq`Zr{E}~g@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "s~|zGywrrAneJr}BvxAbiG~oEzlMx}GrpO|aIplNr|IjdC~cFaeCbnAudCaeAqrDbj@seGh|BuiI`yBwcPnwBoN`yC|qBxqGhkL|tH~_Kl|Dle@jiCem@drAkeCod@azP`pB}rAf|WbtG~fCguAj~BisN`_EsjJfxNmkTzxKgoGlhChzD~bAdmLab@l}I"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "dhrO{zapDozIexA{bKwvE_j@{qF`yCetQlhIulRrcVmhIpiB}{Fi@gjMe`Batc@|JsbH_pDgtOswH_qOibImwCatUa{Bwyg@anBoNkmGjpMgcVt^{}CoO_{C}eFo_G_zD{zHzCegFayEmzY`iKqkM`yBubHl[uyC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "arceCc``tP`kFkp@ru_AaHltZox@xwU}eEluGag@f`F|eEri@vbE_`JlvD{lGxcLw~GbkRe_E|eGfkAx|HtrLt}LtsKfrDxvP{lAznPamCf_ImuHvaJeXzgManBtbLq_DxdMekA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ko~bG_~uGkoQzkNmwB`~IaS~qOosDd~QseF`wRipJb~n@mk@leLxy@|gDp{EtoBtnR`|@|cA|_A~SdgUuuAnlZ|i@pqKfAjeJkdDdqI|{D~jn@e{Ab{FoxGvlJobFfwKssBd|HkdCbmG}ThtFr`CjuJ|u@zcOyOblLvQ|cF{qTz_]g|DnkCos@h}MaGpnQs~L`en@soFrnTwmClcBsrBkH~WltBlkEzrEteDfnB~]|qCyX`xE{|ApgEaxBvyBmrEybCyrG}dFakHm~AukG~SikDf|JegA~oPkSjyKqxCtvOgmBt{FcjHruFkxE`G"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["ko~bG_~uGe`D{}DmbCohGfo@q`L`~D}tZbqDwwD~vBoClaE`cDnjCjp@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "sllbGuelIv_Ho_]n_EuiLrpE}qCbuE_zE~]k_HojEeyKuxEe}Rp~Dy~`@|tGqxd@f`@{iO_fCkRi`Ei~Aq_BgfEm[chHmdBm|KsfDyxMwdAqjN~{BmcOldBamR_@cqJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["ko~bG_~uGxgHhsA|lBqk@|lE_s@ncFfLdtCe`CrQohFgl@cjHcxAcfIk}Fq~Poh@ekD"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "uxfbFyebhM_rBsfD}nG{rPuzHqxLecGswFyxK~cCumNluTchGdxLyqDteCwwOapBssOcaD_jEpiBglDbbCudQbz@y|T~lHqxK`iIyfP`zAudOvQ{hXenK}|IfsCwuHdcLmqPtbl@ktJrem@`MfrP}Ux|IfhIv{KflLjwFfe@dzIiuDxuRcrGvdLg~PzgHibVdhF{fFx`CifEebA}pD_pCieDarK{iDobAspEt{@ygG|bI_vJhlIejWjfO{kLyaB{hRuqAaeIj\\"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["uxfbFyebhM~g@l~HsuClfM{bFhpD__@xkAjuCxgJ|zDrnT`lNpnc@f~BeX|sN}wV~dDiqD|s@i|A"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}nixFwq}~Baf@ooYsj@chH_Xuka@iyF{uNlUezItwEmtUejDibIiqI{t\\_t]gh\\irCenKwz@ql[apBe|GtTskIleEiz^p]wbQofC}nTonFktVweYs|DowBqrDq`@gvMvEsaJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["_oz`GebrbCfmDrm`@|jElhJvcJntEpxDbcArDp|DawD|xHy~GhlKfVjdOrqRf_v@`hIblDxgUve@n_EbwBfzB~zDulAhvUum@dlA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["gmgaGgakgCmo@heDynDf{F{r@nhF`nEjdQf~BtnQg_BvpMsKriMrtAb~H|_@foFd|E|uMz~CjsVua@zeJ"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gmgaGgakgCc|AufNc|DsrCs~NkeNgzFqv@}lC~q@iuFdeIgwOz~EmuN}gDaaG{Mm~F`dDy|HckDwlDc}Iar@s{Eaa@s|[m{RqhQcjEgcJygJskJwbCghD_xGo_Dm~Ggv@cqKn{UimHtxF}lIzdIseFdxLskKnxZaqKzyIihOh{CijKjkFc`G`bGgpEvp@g`GzjBcxNlYo~SqqE{kF}fCgaAklH{dJgaX}hMod@q{GuoCcbDy~F}lBcjF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["ynh{F_xzjCuzBqtAuvo@igCyvToqI}mCrKokB~gA}nB`kHsvJhxEa}]ncMqgEn}F_pEzeUo|GjmRwwJ`oOka\\xb]"]
    },
    { "kind": "International boundary (verify)", "lines": ["imwbGizooBxdFuIrdGgpFdlHy}F"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["imwbGizooBggD~oPynAliGuxPpdb@{{HboNk|KnpWijFvcNkdJntFuqA|`KtqBbeM"]
    },
    { "kind": "International boundary (verify)", "lines": ["izwjEmlt`NlzFseEfwI{oKx_GyoIruCo~GjEgZ"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "wykdGiod{BczDaiWgcCkoBk{GrpD_qD_gBazNya\\}dFmxCqsDow@{}Dr{BakH`nDm}BssAglDybNqhEugKoNqgFtoCuoCztC?d|Fe`CbgCm`Ht}E{_NbwCmmPfoHitLl}OotQvkGmyAvoFayOzlGkrNrsNplA~sL{at@}Au~J`kAqtDhqBpCh}IteChs`@hxTx~Elx@xhFjrN`fC`dAlhHmlCpwE_gC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["wykdGiod{B~tDvfXdsGxkC__@bfK}@nxMjnDtyCv_HaaFbrIgrClpMduBj|@tf@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "eruhGw{ctBtkAbPf`Fa]~yEqjCb`FapNl{LivUboXqvYpqFahKfz@u`JtqIgoTtqAq_N~{AmxOhbUevj@jmEosRbiG_~LryFyn@dzCjS"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}r~vAfsl`Pz[m}Cb~Hos_@_}@auHv_GgkKdhEc|DnsGyeDrkPawX`rFujCbgIggRhzFqwFhfBkeGf_BobOfcCexLf{Akr@~sJyh@fyHo|AjSspEmwC_}FocLuyXgvGqmWbfD_xLx|IycGh{CciHa_BcjRh^uoPtpHoyLnpD}cB`x^dmGdrL~`BjoJ~n@`_B}}CfnC_zCbeEl`@jeInaN"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "k_fnA|`atOgkAaiu@keBuvHy}GazH{mK{_DqaKgZesGaaAakGgvGcrAy{Ns[wgKitDgsBuiQ~tB_pk@`sE}kKfk@egHugAekBg}CkfAgbWbwBcql@ayAmyGwgXqgQsqQw~OmiGkbKwoAkpHznO{`JvtVsne@on@{nEoh@}xBokB{e@y{I|T{{HcsHo|Ge}R{uNaaS}nUsdSkfL}nPi}BcyMucEksDyiG`pByyJyd@}iNs{D{zGerGklA{hJkyCanCwfFzjAc~FueA}`LgeIeeJijWbxBk|Ld`NcrJzeIakOxkD}cTc_AslOqkHkuJazAuoIpuBajHebA}|Cq{FyOcy@uyCfgCscH`b@_cGeaAkbFqyBewAy}B_m@y}AwhDt|AqgQiqC_oS}`KivUuiD_bNpk@qmFsaEy|GaqLukI}`EivVt|Akhq@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "rxS|~njMihLt`b@kxRr}\\wcD`c^}`KhcSs{QhqQqwKn_IyiEddGqiQtqf@yw@v{F|nG~`NlbDn|ChsMv[viGfy@d`DtcLqa@vdT{hDpvM{WpzH`dCr_Anx@rpDce@b`Ky`ChvPmlDjaOqnJ`yTzl@naIcnAlxWipEzfSm`E`dD}ih@~wGuzAptAox@tvGeuDvtMetEtfHgmJvxCozIjxDxlArvWiiMrog@ssL~`[ocNjtXuy\\n}e@mkFrzMicHrjQkuMvyI}yMl|Pe`Cn_E"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{{pSrbp~Ie@hBmMhi@grCxqGouDry@qhQoh@czLbzLwbPz|TuvTzrE}pL``Gwj[jiWinR|hCgvLf@grKqpGgdUc|JycSs{CsnIirBgvL_dEkxPwrDw}I|gCuvIbfF{_GdkAmwJw_FehGcaFmd@_~F}}CudIucFs~Fa{@adKwVafNWe_^k`BkzNsvDs|C{~I|Vw~H}zFgeCehGqhBqiBqtBoNkkBldA{eAlhBgW|sGqhPjrFmpFyeD}{LwuEwyFc{@{iK_kI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{whSj|aiIodDiuB{qQmnIq_OiU{oJ{_B_`El_B_w@~oDo}MjiHskKt_EiuK`pOm_L~iJu{\\`rQ}wOqt@c`EvgDkdEruDarFmLoxQvzB}sP`yCecJzv@kcRcrCehTrwAieJ~_E{_Plt@ugNuf@srGkdD{tIf`@y}`@kpViuRyzPiyLimO"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["vwdnEdbpcJyjQp}Dm`SdzEkxQ?ecZaaBwb^wkFahVgwDeaQ_lA{iCu_DywAe{UmxNefOukHkuCqxKgZifOfcA_wc@l{Fkw_@fxB"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "z`gwDtvr~IxsFfeF`hLb_@`nPlaKlsTrcVxuQ`aGvrVepIrs[wp@pnJxqCt{BjeIjkFziAx{IioDtiMiIlwPrzCliS~vId{UrrOhhNp~BvuFcsGrdGofCltGrDbqKfpB`nOz{ExeKlmIn~Fx~LhaIpeCndK}qD~tKeXxdLz_CnzKgkAnoKoxG~fMpS~f\\bgN"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "jib{ChdjlIpA{fN~eEabF~fByfJabFoyJigB{`IkHc~No~FoqGkg@oaIfiC}{E~eDytEvd@meMtrLsfJlcCqlK~rNmgDvch@}~FbgWa|MtrZywMhiKcPrlK~gG~yP`l@rrj@ddDd`Ovu@v}IwbDhgNk|@zsQp`Gj{ZtpNhoFdcN~HdzBbcO~mSd`EpkMoaCniGx~EzoHx`QbvI~aG|`LlnC|sVxbAjaFuRdxL`oC`yJlsHfzH|qBtoIolAneJ`pB|cIznHrbHbhI|gD~`Jnm@fpFn|Gd`CdlO~pDxtDtvFc_@x_EfjFpgEzwZrcJjaSz~NtjK~`I|`LtdErsStfOn}Z~_I`_CzfHmsIzeGgyB~dFr~A~]jvG}fD|mM{a@fiIxaBtdEjxDd|AroG_J`xDpdDdaBhuI``FzwEl~IfzAbzL`lLduOv}VfoU|{Q~g[bzLfrQfdOz{GvnQ|tKfvKbnO~}ExnXxuRzpa@nm_@juVbm\\b{KplY`pMlzM`eO|gBvmQfcPvuSp~]`jHnxG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mwjdLswz|BpcJuht@dlA}iAtxDsJt_Ea{@dgNqvr@taGa|MvgKkw^zrEwkGdwFol\\hhG_bTbvEusWhmIew[piGure@`vAgr_@jgMabqA|rCi_Mb}HauVznJm|V`sV_pOlf@cqYbcG}eFz|LeeVphK_d_@lcCnd@jiJ`rXpjNxvAfrRolAv~Nw_GntCxYnoDxiExsGdsFvpFnvAduBsTl_AaqA`DynLbx@{cW|iBweMflQkaGdpBnvAxiGxjSzrEz}DdvHtQduIgrBz}Je_FtxKs|NlkL{pTf~IedMpvFcuEblDylAnxEjuHdmLjvGvkNhs@n`I|}BdyLz}Q|{CncLnhFnvBxfK`r@n|MazBxaIii@pgFe`CxvCq}D`kGcm]jdPy`PzwLwrIh`c@uxSb_Hf~Cl~F}qDnzKwbEhxGjId~RxbM"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["olsxHilxXxjFvzAhcGzqFbvJv{XfuF~|Yu]v|Ly_CdpHkfC`cDcaCplMq`AryRxkCtiKtdChyG}TvuFwnBjxDyjDbmC_|OhzD"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gewtHauqc@qXhke@s^pyHi}A|lIkbElxCojF`xD_oCkq@gxKykP_pBkrAq{@dx@gsD{v@maRgkLctFgv@ijDp~DweBnrG_tDn`[i~FhjLe~E~dEu}@ffEfjAfeH`rAdfViwBh{Q_eLjiUaxJjdDq`HfvAybBfqDlsCtnF|iFdoHb[bvQ}u@djDy`Cv[k{Bfa@ayC`dDwtAfqDrpLrwVi@fyGseD|cJcbDroD~{AxeKfhEv}IdyJcwBldAf|Dqa@xoL_{CrhN"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "svylH{bve@w`@klFp~AcyMdlHa{MxmHggExdD_s@`sDwlE`mX_~Wjg@e~FuzBwtGanDgsD{a@icGvoAqbLd{AslGp_Jg`CdbAazA}jAotDwOuaIzuAwbOobBgdU}qCyvPnDk`HlzKusMvxC{tO~zBqwc@n`E{mf@x{CaoNtkAyqIz_Pga@~pA`eBhca@thf@neK~pOrlPtlG`vYjxDhkXlrJhaWxkPbaQxiEx`KyvCt|Q~}AfxXttIhnRnx@zcLm`FpuAixH"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "iaaaH_dcy@_rMx~`@m_Mns_@?pxIhxA~bo@gf@pk@y~F`kGapAtlFrh@lnC~hA|~AmKtdDw{KzpTsz@zyGvu@lgK`}ExmMfoGdiEx{Ck|@~bAgoFul@{sR`l@_{AhwAiT`uAlcAveAr~NdfBprCjXztCxNr~AekBp~O?jhXb_E`lS`lA|p_@yd@lvk@qmClbO"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["gqo_H}ycy@msVu|NguMghByrG~}LqpAz|D"] },
    { "kind": "International boundary (verify)", "lines": ["u{e~Gkcny@m`@`fNbB`zAm{Etr@ytMk]_dR_mG"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "c{hwG{hzi@umEpjBikJpxHgwEt_JgjFdtFaaGdfImvEpqE}nTuvGaqFvjEixItgBciF}t@_x@joB_fC~bb@|i@jd\\|dFp{Sx|Jd`PhqAp`AxcAq`@`~IinGbqJzjMx~G``U`\\jrNqv@|zEskKjHiqCm|KaaGktJ_kJi|B}~Fol@{tHthKw|Dmo@ufJ{rFc}HcmCorGaaE{`MchWocMglWg_N{tB}gQc{@ikCcmBi}I{|_@qiC{eGieEccCsnSw{XciSitX{xEadD{~BqiCyhBT_qA~eBcu@bfKemEvbC{oJ_hLw`FsrOgBccO~fBknEbyB~IbbC{}Efj@mfK{l@ybN{hCq_NyfIegHkwFojDgzGoqV"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "or|aFhoel@ypo@l|JatQpsDabKnm@g{ZasJejJsuKqmVs|OioRszS}rCu`UwzAkuHyaN_dGc{KcrCug@vjBxrAruXs~t@vem@krGal@qwKkyDwbOqyBivKe]w|I_`K{_JgmQssNqoNygNuwF{{L{r@q{HhxGunD|gXesf@r`Y{xWjxDoqAdiDmhJhbOkeThmNihBtfAovB}|NiEsu`AetCavLos@uaAwnOk~J{aZopKopOc}AyyEv}BiwOjwT}|C~\\w{FaoBimGa}KerHunPygGqoH_nErgAaxElbD{hEzXexFmeBqpYmc@uyEwfAqbWnlBcuRrgCspX~xLqsDwoAgwCskEgzG{{SizSevOwlPmgW__Mkx^upNefUo{JmxGwcByeEspDnx@kaGzdCq{FxtKuoCziObE`dQwq@hfJidEbhBeuOag@woOt]orFlnBcvDjkG|o@ftOktCpkMqb@r|IfuB~hEw`@re_@ysAflLwhB`kH|y@n_E~eBxkBn`DpQdtEreAx_EhoJd_EbkYqMbhTghC~oRccBvgEmyAbmHvnB|uf@wpAzwCheEbuLrjFreS`M~iJaq@nbCgiBbo@{nJ|nGgbEkfAmxP_hOcgCny@}vDbuEihGd~DsgCpv@}UjjIfjC~_Jb}Gbbi@tfBjaIhsG|eQndLrkQ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mxshHceisAlxB|hAx|J|`@tsKwGxtErsA|xGt~J|z@reEz{@fiBqnJfyc@r}@h|Apl@hiAzg`@pzH|kEjxEb{DfbIlvDl_T|iAjrMt{ArkJd}Lhac@vjG~fOtoIpoIx`EfAvxPspPvkQ}fSvdO{BfbKx}GptCpaAtw@q}DhToeJtaAkkHpoGg_CxyMle@t{LjeB`zDpjB~Mj`Hk_ExkPc~EvqLshC~dDgcDjIofBu|AiiEtyC_zDpuOjpA|{P||BleLgFfpGasDpeHaiCndM}yA|oQa`BzoJnx@nlAtdKgj@`iDtpBf`F~pzA|qEj|ZvoGxhSduBf`NfgDptB|{E`{MleAlxOegAz`C`eBrwInaBbkQu^v|JmqDprDgpGtjJq|D~pCmxBoNkWrtXqoC`eO|`@bja@a|@fnGv`Azw@lfW`dDh}HtxExgI~~IbvDdbMf`@xfJsnFcPa`HwyA{bAjbGg`@ndK}tAh{D}zEmp@o_CbyAcxCx_DieEneKqdHxzXkpCfsPzyCdrEnzC`rK_r@rzRn|@tzC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "q~_}GqdfaBhrBb|IrnGfxJ~sQsUbu@~q@jyBlzAgqEbgd@`Brh@`lAl|WzpGx`P~zCvuSirAblj@fiBhgi@vnA`_Itl@b~I|}ClhIh_FhzDd{GpoI`~Er}M~iD~fOtoC~zBtqApiDokBj`H|DbjFyhAl~GaoAby\\mcCjw_@s}BhrNccBxvPkpAx_RkRbaPcd@drG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "imwbGizooBu\\ylB{zAcbD__G_vI_eCycAyjEnO_cSxaN}`LxcAchWvdAawDwdBexA}oD_`BskYw|Q~IqtDar@wzF}fDqeFokBmhIssMsgKs{RsJkuGvu@esFtpI{qG}j@_kHitKu}@yrOvgKsrIfqEczDq`AaaBsqCp|@oqIn{AibIy}@mkE}n@iaIfLszD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "eruhGw{ctBc~HsvJom@k`HiIcsJx`DwtFpa@uaIanEqrDciHi}AizJhj@qqZvfW{fRhzSufCdkAirBaoCy|@ogFtr@kxFfk@cjSax@}pRutCmtEiiEKuzDtcFkyNzyUw|LvyP_uIb~SihC`qNmlDrqCuxD~|@gtIqv@soLs^aoGguB{`O}_Ma`PqlLokOmiGueN{jC{jCtr@efBn_FchBlyMtzAzpStoDbnPfLhyEdXnzKapBrnSsdEjkHaiE~q@szDzC}rHhoEo}H|hOms@``a@}cBlqK}rBt}K}tAxdMpGzaLvsAnwNikCvoZdzDbiHjwExnMiD~_KwtNv}V__@|cFx~Fd}SzLroGapAfpEo~Dhi[kh@zwKvyAjkHeaB|sO_nSzjg@fqNj~We{Bpxq@~tInaNzfS|gPltHt~LcnBxdKe|GzkMm|UxdXscChvKy]hsM`pApwKzsCjxEnn`@heDjo\\|qChuPlG`kOg_[fe[o_`@tfBwrInfH}fDrwVavFpvYmtGnuPywOhtKybNpcJwmQvmPgcVjdRq~QjaFy_DhjX{xc@xzXaub@t`Hq|^xwC{_Dz{RaH~mFanB~ySoiT~n]anj@baFy_DtdDgl@z}BnxAvdCrkJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "oozpGsi_sBuxE~gA}~A{vArJknDtg@knCoaBwyC{dHi{Ag|^ngFyyA}`LqsCmEs`Cwe@vpDonLfBq}Q{b@srOmcBwoAiqCnEipBlmBq{A|zDslChhCu|@bfJooJhbb@cfKrgPk}KwQkbFe_DcoAw`EqkAlx@e_EtxRujGd_FuvIcwDovT`iIclLfyI_yDmsIgfGcn@ouCyY"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "w}rgH}cnfB{fN{gE_hS_gN}wJ{bMk{BaiIfpBsdTb}Awgc@{vAw{Zk`H}~X{{FecMyhGiaKskD{_CoqAojDwxCgoTsqDizEyqImyA{xJwz@{vGmlC}kE_pD_lNcyf@clDkqBqgDwkEy{DqwJgoGilJifDgbKvQ_qNwa@sjMc~AeeJuHi|C"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["gd_dH_btgBaqEt~JcpG`pBslUfrQe{c@z|SqsIlPgcKidGigHerFcjFga@g_AoY"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gd_dH_btgBce@eiDho@w`SrcAovChNyaBndSs{^vdNue]jwFgvWjSajc@vTare@wsAwq_As~@slo@}wBkeB{`H{hFuwFlxDicH_Je{J_dGyzHc{V}iCupcAmjFqlf@k`I{}Dy{H}_Lg_Am}JrpC{jOzvGmuR`sCghPq~AsbIgvM}xa@qjMgag@e~e@kqZyeE_}AmmC}{\\dX{sj@naDakUztAkyOg\\oeX{jGwic@vFymLp|DilIrbDslJjgEwuFhyGuyDfiBmcBnoCyaDxeE}cHxs@e{GmxIigbAqiAg_C"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "okluHymkyAinAa]uwYidS_{Ou`Hcx]aiIkhWflK_kJnlBwmDtwDoyJ`lb@obCduAy`OmlDcwEfuA_cFfoGwdMneJ_`KpjCucM_iMokIapBkfMseEoxF}pC}cAyZkpDvjH_xFnkAyeJkpAyhGp~CykDbpKicF~cGg{GvwBo}Li}Ay_RuuH_{UpqSsvYdzq@cuQplWqtI}~@gtHuuImtGamRokN{uMigQ{gGwmBuGi`L{Lsht@bsU_jLptByaOduAukh@bgLqbEkqA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kuscH{asjCopAf_CudF`{@cjEebAe_ElbCcyEnpIcyAlpAhOveLbT~qByCri@axDxiQa}LddKalF`yQsnAfkMe~DfpE_}F~eCa_ElnCaQxOoaHdaBw\\llCaGdXvq@frQ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_l~iGganmD~Irr^_ZrlHenDr|\\wtHzq`@kxQvvRqlL`sK|`Elm[yr@vlDknEjxFejCrmT}AdoYcpWfoz@}cCzqEpcCvum@zcKx_eAh~Mzkt@ruYvcv@dgSjkUhwIl|X|~Fl|c@a`B`|`AqdIpscAw|I~vhAb`Exxf@{oC~{t@gaLhhpA}}Bdp{@luFvtz@c{D``ImvEleAkpHiiAstFukGiyDenM}{DesFe_EeXcsHjfOwgLzf`@}hG|tL"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "yqlxGqnpzB`iJurJ|tM{dJ`xEcoNv`GknQrzDqnHbrPi~L|rGk`JqLgsBigA{uB{w@uqAtr@_|ApiDeDjyJsTjrKhsA|{Js}BzuBgBnkBzvAdaBiIjfBa{B|zF}~M~cKwzLvpG{_OzmDmzMbJwjHfzH}iNjaF{i]nmAuuHd`C{rEztC_zCd_DkInlAztCzwEroEvfG|tAdbA~yCbD`zCplAtpBtpByXnkBg`CdaBohEdaBqbKtoCm}JtpBdD~zBnlAnm@vdNtSvhJtr@jdDrzEqL"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ynh{F_xzjCpaA_lTfU{mXahKekOe\\eyXuw@u~JbnAy~RqCclRwbDoyWqkGgdVxUwaQmo@wkFqw@keCijJuoCiUw`a@~b@yoJjHo_RceEkwRxOi|DfsOa~H`yC_fDlmC}vIdnKw}VchBgiCgdCc~HxuDss[nrH}hZnbMa_VeaCopXq|E{i[g_AmmQ_^c_Sa_Bc|JvrB}_ZkqF_}ZczEenLerH_{Bs|OjgAs|OniE}fExtEkmEvcAm`EkyBkeCigCepBseQ~hD}nVr}B_oPvlE}cIl{DojEraDatHdd@ieFblPspDzpTi}ArhHnkCvcAl{KhkSbeg@xsQ~]``HmPlkEyXdkDkeC`wFIbiG~nCn|LtpPnaJndKf_NtrLny@luFpsAn_E"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "m_ubG{vmyBoO`qB~lGrySf~BlnNr~@~}Ly`CfrEkoDhgB}}NmQskDvoA_sAvwCbxBzpHtiKfcJhjMliIr}MtoNbjMpxK`bQdxLh~MrlHnmGgxHbwJe~DxxGby@dcDew@`lNx`BdvH`R"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "awpeHs_naDqUsoQvn@ijMlvGoeUj}IuqNluGucEvgKuhLfgPi_Mx}UekNvrJgkBvpKiyDzgNeoJl|Oo}TteBg`Br|Ja~HfkY_eRhqI{_OvnJs_MlqJcvEjoIu`Ij|LeoV~sKcaRtkc@igNnvOkuIzxKkxEt|XrhB~aJ}fCdgSjvGnxg@zuN~l_@vxBvnPquAnfJiKbdFmxBrxMkdCb{K}TztBdtD``Bd|FbuAp`BhyD{gFfyIe{HrjK_wH"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kuscH{asjCkiBmaFegGevZeiGy_FcnFqoH`QuiKvmQmcg@oc@eaj@|Tq{FbKwoAro@{gDrcH_ex@y_@q{GkVolAzpFk`V}^mjSyfDyiRuw@kcSbcBsoQ`tIgaMxqUqoc@jlGoyI{f@ewO{eC_oQobNyuQacPspx@ufCg}j@gzE_zi@_{Cmrp@}_M}jMqpHe}F{tPgrDwbDsuYsrB}kXafA_bH"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ooojHsaqhC}ZaaGvgFiuVbwBgeTopBizDatC{kAyrBh^ovI|}OsyE`tIkeCrSolHuyB}qIq`AmmJlmAsjXnqJ}xIvdA_cLiaJig^u`c@svJi_KkeMolOe}`@gqk@qvRyc[s|Iw`Rk~Qm{ZmyHkgKmkEm}q@qdHciEk`IyhHshCehFc|Oa]_tSrmHihFzrFa~CpsDqsC}sBoi@gsDcTy}Ec~CyrGqlD~|@}eLfoTwdIlhHobYvqM_cZhp\\{wGliHihGhi@_hG{hCypIlaCanL|mI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qdmpIu~p~BhqCcha@sFclj@gdAu{P``GuhJnsFo_TjyEi_XtsJ_jd@pfFgwe@xYexKk]gvg@~^ucj@rgP_wJrdGciTvfJuePblEug@peg@tvVprLp|C|sLv[jaPauG~oH}dG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "w~~|H_xz`EqyCt\\uoQ`hLubGn}FmlChmHyjDbvCweUdDcxSqw@}tA{|Dm}O~oP_zK~h@mkEerGslDkGurFjxDqlKb`Qs~LjpPa_JjhJggDjbFesGyrG_gN_`Ko}GetCaeAcwDkg@{i[zHgqSlgBymNdhFizDd}F{bMtgBwdg@oI_|OwgFefTy`Ooha@atJklGgfGefT_fBa~Kom@_uJizEmd@akHzVqrDx`CohRjei@{hEfiDqlFdjBm`Fy_DgvFdDcgPrwo@u`Bztg@x]tm`@wrBh_LcuGesDmsN{fG_zKemA_zD~hAm|CzrEqxIx}^upO~{j@ouQ`lSsoRpmIg~JxzJ{qFhnT}|Cgk@uiQkgM}xAlPuoCz_EegHxwYcaPdec@cmCxo@ivIurA{pIe~Cy_DseF_mTysTehF?kvHptBmwOt{NmxIvhKooDpWupCg`Ag{De~FgfFeqFw~War@kvGrJucD`yCmdAjcD`g@|wIobCnmNmoElqJkbAtdFosEdrFgkLtvTqoBnvBclJjnj@zu@vhd@ev@bsS`pAfyIngFlgJfyCtqNdCjsJbsBvsIh_Lvz[}zFvoL{rJvsJwyHuzBq`HwyCsaEhJudDxbCcuDd~P_lInee@aCxzI|yBbnO`sJ`y\\coAdpIefHrwHopJzoIa|DvfMpQps]nMr|AntEnxM_TfgE{~OhsY"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "w~~|H_xz`EnI{uBfqDueQnvCsdR~HwfLwa@ewNiiEumQcaEy{Kc{]gtN}lC_pDqlAyrGaGycMbwDmzYhdDum^gVueQmlOoqo@aqAqaZjzBsd_@lFsp^{jAqxV~tDsiObpK}cSzsQ_fQbma@waR`|e@}rv@frFk]b{C~pCrvC|jZvpAt`VxtExb@ffF_cEhqIeqIzrLis@|oKxOhaJupCfoC}xG`qDqb@pxEzeIjeCvyAhgAg~B~h@edq@dsEcqWb`EqsQbQukHe{B_cTimAswVuIolMlmC_qDztJmmC~tJajGviBkxFyPa|LxPajGlmCmmCxtEd_DjfFob@z{GacEtqSgfF|bEytEhxFmmCz{G?dxFfqDtbEt{Bf|Lu{BnqNq_Nt{BgcJ`|L{{GlmCmcOutJm|VacEojQdlBy}UpdA{eTj}FugMl}IepItbEwfKkeBmgKjeBmqXz{G_uJd_DutJkfF}_N{{GwfKgiH_yk@siAwzZsy@_xF_tEekOylCufPle@upNnyLsiNdpHmyN|_NmmCrtScjRhh[_ao@hsG_{Q}o@{xKkgAmuEm}AcbByyLk|AcbDcaEoD_wHtfP_sd@lz@ytRrIouQfkLydXzsJstZff@cjT}pCo`P{wA_uJhmCgfFj_IytEhxF{bJffAqxKnOmlQlbNo~^ljNoa]hZuxQkoCs}Nid@{aMh{BiwHttEexAz{GpfFnxK?xfKgjLb`K}Kd{IvxBj_IpqFjwLfhQ~yKh|OtjDdmXfrDvfM|lHevBhyGmiHtbF{pT~dD{nWlvDayA`{AnvB|sAztNevAjvTj_DpfF|iGj_Iv_NntEd|Lp_DxwBeqVztD}uLvlJ}gCbvKi{CpmJel@hqDhxFbuDnNxxAeuBtg@sbIfpAuwFr`EkRtqLvyMx~Xl{LtyLhmFv_NaQ`jGbjGlUbcNzm@`gs@cV`ll@gdAdtRkh@lw]`pBjfNj_WfeS~kHrhN|nG`iXzlAdwZl|H~{NvpNfrDdxLzLf{EtqAb`Ex_ErhCbdArvCih@`v@wmEbdA_wF~lB?`iCf_BlvCxrGdiF~zB`wFwZxrGst@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kv{yFqgchGbhGyaB~tJ{cK~cFynMxsF}xFbjYatKfqMkbDl_M~{@vkMhxG|{PrfRtnFmwC~{HshCldFzl@d|UkrL`fMseEhhB~dDnpCpiBv}IynWdeH{j\\pw@ujKefCkv`@a\\uuT`vG}pT~bTkl^`qZsz`@jkGcvEztBg}A??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "a~`kHi__wOoN_wUqjC_lIqlEq{FecFo`PkfG}rB_fOwF}uLqcJiaCqj[i_AezIn~@epJu|@{}PmU{iPbfCmtHjqBsvK}LojOumEgrDa_H_UsjAwaFfgE{yGptCi|ClcAmkFqqDwvR_`EywLmkKcnCacEw_GnbB}wIsAuyQeqHaoNysFcjS}mBisMomEg_B}eMf{EoqNa{@sxGgrR}`@ecYo_EwkR_rOykDwwC{oHwz@iwHyrAyqVgvEs}OoaBqmIaaHeu\\uw@u~YkfFwqJ_bHk`HcnBobNm{FomN{_ImkSqk@u`GeyDal`@scAi`Luh@gzFrKynMoqIucE_xF}tMisAguMuvFqgF}yHobMknDwbReXyv\\db@wx[st@_gPkqM_gMkfFstA_jF}gBwxA{oJz|J_~LplFsvJvvFcaQ`gFciH|^_uImlDeeJgfLe}Fg`AeaN~bA_qOdoEgjCniEqk@jiJysFj{HseQiOwiVuw@ujHjk@wuUxcAkiUliAkiWxJmbFvd@q`Y|u@u~d@{WywOteBofa@hxGo_FnxSeiEhyRckDz|Nyo@tfGe{G`vAskJplE_oFnwGcfLlpKgxHgZyzJy}AciG{]keQrZcgV`}EmcOxbHkcEbbDgbLks@suI}@i{^lQw}In_Dw}IxYyxNyjEkuGoiComZuaHu|NsAcfKtjCchH`~DwaF}sAeoIi|CotDHsdHldBk_HnpDu`VziIqtO~^y{K}_B{sO{k@cuFvbDoiFdwAswImxB}cGwtA_~LtrDwot@viIikKdzCgnHxmGotFh`Es~LoaA_p\\qdE}lJ}tLy|VijLgnHeiCu_KcdA_sLRutK{LijLswHwcOelBocLglKwlR}rD}rBimMilHkeHuyDkrM}xHopV}gDonKg_Bm`HtqAutCnoJ{eAzvMm{El|Ke~FnqHyeJ|qDkbLbtFmnH{LeiFxcAagEhoEa~IdmK}dGx_Ea~Ke`AkdUstMmhI}j@glEmz@ayDzXqgL}rCarD{fGmfM}mH{pEgxK}L}|Ne{Bi{E{eMolB}}IauFkwFccDymGuuHgiOiew@ohSkjVefIohGw~Tc_HefHwtGd`BiuKp}Ka{MjBqcJ|_F_qOvuMkbl@|rC{mW~l@gvNtaC_xSnrG{kL`aM{bYbrBw`Upl@age@fVqqm@|mAycLfcI_ba@jeJktd@`_I}nb@pwFk|YvoFk{NfiCg~M{tBkfOvY_ySl_He{o@vqF}z]trD{yX`wFyrGviImZ~vGxmBfeTc{@hbJciGh|MeaBlfMybB`aMndAxmFu{BzkCubGzxH_yFviItqAx_EbmBvtHwOn~FakHjq@gwLp`AcfKlqKq_NlnMewYz_Cg`O~nEclQ|jEibb@z|@o{VjdDoaMxnK{wLtqAgyUfiC_tMvcD}tYi~AqsP{iCmoNnYgmIzyAy~R`RqnVa~AyuRkxGqtNc{JejQy_Ey}TcdA}kXayCckPq_Gq}w@ck@w~U{vFkyP_`EowNuqAqyUziE_{]fhDcn\\`v@utb@biFauVv{EmxO`nD{lYkpAcl\\}dAwfg@fdB}tYxpKwzZraIcbP|oTeiR|lIuaSroG}rP`P{eUhUwmv@joCcm]fkAuiXhoCkbE~wM`pAxcTqWzuHrKdiFgrDnh@orGtiIyvCvbEmpKvkF}mUpaXyzd@~uIeqUxsBwxPioAaiVx@}nc@zAyz|@|oFoki@jdDusM`~Dghj@pqEkun@b{Eobg@a{G_vVyXixStlEi{RftHiyRq`@{jN{oCiaVi~YsnhAiaIyzXtqAwaQkqBmcO{_BkhKkdCyk^oc@kbRulAwvRer@qj[{sPoux@ymBskVt{Ccpf@aeByhTe|GgdT}dHynZu{MkcFemSoaMaaN_g]ocLiuW}wKecXusI_|]gvFo`\\wfSu_d@igIko\\ajBguMduBcmPtvAwv_@mYwrV`jAuiLn{HssYxtGqdWvmNunQ`rTina@zfFetPl~AmpKf`Ae_^z`@_jX}|CocNa`HmpXqmJgvg@pHcaOzaEmfYbhJgaf@hmGquN~kIibI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "seboHsudgUlxOmdg@~vGa|XzhLcwj@j_B}el@|jMifj@njCchUDo{Jq_b@gd|@gs\\qvr@sbV_nz@ccBetj@wvEux_@kjIc}TghPa}KefW_}BssM`vG_aDjlTqbDjoDudDkjIyaIesFc_NuzCufM_kK{mL}yRk|Mw}IikO{`AwiOy|J_hO}wTadNw|Jo_MqaAgbPi`Jch]e`]a{a@uoRm{V{e`@qoWqlt@kiWuk`@qbW_jL_hTf`@amQdmNgwQh}AmaRqpHugMjlGimHrjY}iA`n^lxClqc@g}DppSgtOjpCenL}xHchIqcWi`X}tf@oxf@kfv@q_Uq}u@_jE{_qA__LobaAagLqjbAqpEaso@lkC{gGpa@coY_gAyuk@ouD_qh@}cH_ke@wcAck]dzCajUdGgxKvQqyGm@k{Ca{BikH`}Ei_YpqS{pp@ldHsd^kfAeyKxuD_~L|sLmdN`aG}{QvuBe~`@`_Nau`@tX_sLkkGcxCayCcqKwf@miSvkF{k\\z_Oome@v`F}bWu|@swHb~AujIbpFoiGdgH}Ud~CbzAryF{fH?utI~vBykPryLasLblEwfKrpD{pGlrCcp@jtCyXrrB~pAl}DrsCzkEnl@leFizD~eDyrTxjDmkFv{Egt@zrFmwErxGguMxjFesDv|DblBt}CeiCpzBqgF`aMwp@dbGuS~aHyzJvqQcmAfrSohGjf[u}Z|gNqeH~dQrjAxoG}~BpcCgwKluFc`E|fJrUt~Eq~C~lFq~BrqJzuAlmIq_CfbEioEfhJqsCdbMirAbiUetQrp]uva@hvVqfTh|O_xFl|LgAl|InrFd}FpLz}CaxElvE{_ArnGdvAjaIuiJ~nP}ae@dyY`fN|zQp_CbzRqaAt~LimH~bGywOlnGgmIryGcbCvsHucSrmIeec@by@akm@iyEsqw@{c@yra@voCiuKrzEqhCneHx`Cn`EyqHt{AofVjxDg_OvuGkwGxmAsvIywBiuKbPsjK~yCa_Kgt@gzFghDkwE?c}IzBcfJvwKg}EvdFmgJ`r@_qNtpN_vVfgk@kwn@zvNm`^||Cmb^h_@use@dePeoKndQjaIbdNhsA`mDiyGjyPgbKjjIwbPfeGkfBhdHc~Ff~OpiBdxWrtMrdTg_ChpPktUt{Oi`LnfOelBpzHytDpnBc~Fqe@egVs{Dkqe@l_@uh[t|FcaQpHesk@eiFiefA_gAy~k@vyAwwQsmIyuO}vV_tMgdJgvL|k@eyK{rFwjSgtO_}Zu`GoeWrX{t]hZct_@c_FsnSuqMsfRy{Keh`@kyOc`fAssAyaPv[sbGhsAwtV`qEc~SvfLizRxnGo`BzcJtfAjnEfiCxgFpdGpxJbuFpfHg}CvuRyoJlfMulHpxO{nIh`ElvCpsJzhEfvRtmR|pFbrI`kF~kJdx@`vRpu@jlGnbBrnHb_Fn_E~{CtxEdzHvfJrnGl\\`rKmcDr|KkoA~oJpvK`wPpzHziD~|AzlLp}C|sCnm@fi[xbBhiRruKlnUlwPrkL}|BplKccBb`ExkCrgDfa@`~J|rA|qChqDrnFbcOl_HjtHhuLg`AhzJ|}CvnI`lFhyEtwFnkCfbJzuBvlFhjLrpDzhIpv@rgIreDpoIueBtaHduDbjEvxNtvBl~Gro@biGdzHxxN|z`@beM|uRteBzoPkfB`~IrzR`vGnxM}cBdfHe}AhxHmxBzpUeqAlfJytDrwUkgFvic@umGfnb@wlCdgUqoB|pP{xDtiLakIxeJteC|bJxfK`iIxgFjeP|lLhyFtiI|zEzwLjyPxtDz|FljHd{a@xbB|zFh~@nm[`cClsHpuGj_IhtGdvA|bHaaFvgQsaJ~nKacDnuW{qFdtlAmhX`lLheGpfy@bsFtoIwy@pjOpUn_KcNx}A_fDtdCaxEx_FwnBrvIxZp{FjoBjrNxjDhqUlaFpuGhyF|zEheDbwClmCh~NxOrpIh|AtvBthK`cEbgKkgAloMtg@|vKbbCxwNnvCpj[bjE`nO|rChzFnpDvmDthD~\\txAcwB`eAu{Nf~Hy|Il|Ikp@rfElfJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "eurbGmpt{WszEprDwdAljHerH~nPcqI~uKiuJnpHw}WgLuvB~s@qbDxkPulFjdDupBpfGhgAdxJqkA|yGcaCn~EoNvkGtmEpgFxyL`yBl~UndKj{Ldc@hzR|fDddXhfDxfDfhC`WhsLhs@puCzpGjbFnm@zpGe_DzqFe_Dj}JuSvhJd_DpdId{Il}JfyG~wEpfGnlApdI`}@dwH|`KfbD~_J|jMrwUd~DpgFfApiOwPxvP~zBd{Vh~@t}e@i|A`iVxvA`z[nuChmUh_FjfBdkIoY`xEuoCtoCunDt}LciHxnLuvH`vGmzMtjHkcE`vGiIl~Ix_FvjMttI|yGx|HqHtmFucDhlJumE~vF{lAbmQbcC~bl@g{AppUwgD|wIqK|zQm`Fte\\agAvxPuoCvkGwiIrr@ibFvkGcoGxuC{tIxrIojDzdIkgAj_ItmEj~I`yD`sJih@`vGrr@jeClyCvxCb}HnuQhbH`nCnhR~mFtyR~dDr_FtoC|e@prFt}DjvFttQtfOjdPftM`sJbiT`tIl_I`uHhdD`qLxdNplAbhUf}BbwPf`@n{IfnDfyFljGdtDvhBnwA?l_IjbFj_IvcOnpWl~Ab_ShxIpbX`eG`aUhrCfdHvaDxmAtmEhfBjh@`tIkIviIlzMx|U`rK`sJ|zYhel@tbNvlQlqR`xC"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["eurbGmpt{WhzJ{hDjpJenKjlGspEnvGag@x|CwvD"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "adrtFi~apL~YfmJxoEhbo@cpApyHkjIreFieJxhEiaCrlKccB|~LmmC~eDamDhJgiDem@cxA}`@cjT_n_@weRue\\qp@stA}sB}sAesE{}CmnBHqrFfzTuoBbZsrBykCqxC?y_MbmN{zT|uYygA`vFnm@xuDldTpnIbkDhgDv|Lvl]~pHdoXt_P`ll@piDfxJ_^peG}iBzgG_ePzlX_{DbnO`yDhaJrnGviHflPm[leHdpIvbCpnI|um@acRr_E`|@ts@~rMvqPqxIp`AhbHacC~_VwuAf~]txFtly@d`B~gC~zBrr@zoBekBbLsh[ox@cxZrgBysF`xDod@hsBteBtRpeHvnBpgSptB|iAtpBtShgI_zEbpEcuF~zB_^jfBjfBhh@~zB_zC`xE~]~zBnjC~|@lcDv{@vwBjnC}}@hmHnm@vjHntQ|qD|cTbvC`bMxmN|aD|oGbp@lpKgv@`wQeaA`jJebB~w_@kxDf|_@ikDt_d@jmKrna@`rFn|HdbFzgEbhBhoEzsj@r}Mv}Ckq@z{BwiGdaHuei@bwBifErgCeuBhtRyx@puAwnBtlAenM_Dy|S{|@okOby@upOdfCopJruEotDffFccBnfj@btRduNuq@fpUabEjtP}bJphPo}SraJi}N~eDqjBhbGoYvhI~qAfkO|eH|hMvfJ`bEdeKfdQh{OpjU~}Mdj\\lx[|iOnrHxgn@vdBpeMbsF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "q}ezEehazEtg@_sMfjNue^_NacDagSimHszEgdHy_EqgRgw_@kmDehEy~GujBozIkSgtOs}@woMwwDk\\yzd@biS{pHox@wae@}xHe|M_dEkzCs{Dt|@u`VhuEgg_@||IgoG~uHmxNiSwtVby@ugZnSajTyyE{_PqwKgme@sgCaaRytDgiPc{Sqtv@`r@whUhwAufNfiB_uJ`hMcfYxmMwsT`hCceNoH}hZdwAgmf@oE}mo@_`Cgh[qbFscc@iaP{l_Auub@kwsAejPyzp@m`AumTcEs~ZjpCq~ZtfBcv^gHusM}qBuja@yeF_pk@g|Ds~ZkuHsx`@ccOabT}t@kxEx|AiwGjb@cbCrdHctGjsVm_H"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "whc_Ey|jwEba]xkDlB{BplQvmChcBew@t_OmxDli\\v~I`zV`hK~hJnjCzcXl}Jte\\bfKzbS|oEtcFcn@f|c@z_BfnI{v@z~^~iMvxN~zAtmTlwDhil@zzH"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["_gvdEqs~wEfx]q_C~iYdhF~`V~Rdzi@yjDdeQ`sJrnTpsE~eOh|A"] },
    { "kind": "International boundary (verify)", "lines": ["{enfEgijxExvArgBvhDhfCbbC|Vdyj@xlB"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gnbiDg}wxOcoAj{Oim@hqPp\\`eMjsKjwa@ve@|vJoh@ncLmKvxP|J|z`@qeBjd\\qsP`uVywF~yO{~DtzPgnCz}PmnHd_EyvCduDoq@lzMfnBhuJrwVbjFxtC|fE~bAj{M}_ErsN_fKxrTarLfpGmlCngFd_EhkJhkP`SduJ`fAvvCtqLgnB|{Fi_KniEim[~{NctObxN}aJ`zNzG`hs@yfBpwe@upCtoP__JprE}zTmlEmbPspFk~BnEc`AvkE}j@fdJl}Ivxh@ih@~jJ{uBbiF{dBhyGoaDbiFolFlbDsfQfdc@y}HttIcpKpgRwoGrhO_jW~jIolVliH{lKjdD{rEboNg_DlxOpdInl[vwFjiVdXbbPc~VrwW_}XhyRwpU|lVyiJtqN}`@hsZawKtd^{z[duh@gpTbc]y{V~|r@w_It`K{pGfrCayOtbFs}NdzIu}Efyc@_|C~qh@~vH|{j@zun@ps^~lI~eNdR|`LucK`uIqxKpzG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mifkDwh_qQjgKpkAroLzm@nwIkbFfnHoZzuGts@p~DxsDjiBrsNjkItiLl_NrbTx`Kf~O`sIjiK`dJvmCf`Mii@luMiqBr}t@qlf@jjHtItrAxnKgbEjpOmuG~gM}bVnbOq{Ej|Kmo@xzKr{JdnkAviBhhObsGjgXhkPztP`|NdyKflE`hLbkKdiRz}d@|rt@tjOd_^x_EpfStrGveMr_MntF~`I`xD|vWzv@zn]apBdnRwuFlbCoaCduDuRdpI`vFl~GfeIhpDp~ClyZhpC|uLv_H~bS~oOveNhuMzxJhaVdpHhwGrrPlkGn|Mn~ChlDvGhvCisAfgDcrHraDwsJn}F}pDxqH{V`_VvsGj~^bnN`iXbwPjcWzhQ|zFpiCdt\\lmOjwg@hiMhmZbtH`xQbiGnZviIy_EnnKc_Gzi]gmEtmRaxDbdMfF~wHnwBvoLtqA|uL}yAhcG}|OtzQ~|@bvDngGduBdko@gvKj~PehGxa]|i@n{c@~gBpjg@||ChhH~fB`tIjaG~{A`tIieC`uH~]`wF~wErqAlmPigA`~RtlHvaPd}EdrOmz@jyOihBdoc@{bJxiLsA|}JleA`~CjxDoYb}Hz}CnkDnnFlbC|uZxeJx{AhwIqcCrwIunQ`eOykDdzHdHfgEd{CbxAhaJ|hCjlFdjCtnEpyI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_b_{BsdbbRkhKzeVe_FvsH_w@dnKnxF|uK~lGhcIbbBrkI`^`|N{jCd|Si}BveMrcAbcApzPavFpfMowAtkFnaBddExuEjzCxeIvyA`~JeHbrIgxEh}O_Hj|KtjBt`Jt_DbvEhfEnvBhfb@~nEz_JvvDfgEv`GrSv~Fov@v~Ihm@doJzrLfbs@|i@drF|_@ziObKbdNmTjtIu}L~~Won@rbKr}BnsEruQpsCh{JtrMn}XtmRh|d@tpC~lY}_AtdYtoPdsKtq@nv{@ujHbkE~q@|cBjpBhbAv}IjjEblQr`EzcK|Tr{DupCjdPwAjoC|rC_i@nhYsuLpmK_gMgk@gwMxmAulE`iEh|@|mOcuD~rYuhL`}Rs}B`{RvaGvbFcp@~cCmlC`nQ{nKt{[_sY|f^{bY|`Y_xTn_Qg_Ozq`@mrb@zvN{hEnx^gj@~jQixGdcL_cGv}I{sDj_c@qbLj{CiqD{{Tkp[~pC{rEhgGeuBfoIs@r|JvnCn~IlhHhlXx`k@j{T~qBle`@xaBlxg@|Udo]obAh_F~r@biB`zBuh@|rOjkN`~Vrj@rmGb|DpoIxgFv`GhaJ~pAtn`@cvChn^oqGdbVcyOjgQuhLblXioQ~`U_tMhgWuo\\vhc@wnh@v`SmyNlhWi~L`vSe{HvoZewBzkNy`Bbpr@c[fvJdsFbqL~xDveMifB`qLauHboN?xwZm`H|}OmcNpmJkqMj`HumEloMbbAjkN{hChwOmcBpeVq}DhsRivJ`g{@s|P~cE|LxeKtvFx_JlgJtpBzgFdjJr{E~e_@zjO~nv@d}_@fec@|d_@ruX~~YhrNpqRxgHjxDnhFI~~KapBtsWrj@~rN`eCbqO|pDtwMnbB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "asumB__ftRuRcFbZfKmFcD",
        "asumB__ftRwhOgeJwjFw~H{uB}kKudDueBosEz~DsvEmPiyEkcFe|A{jNh_@msVn}EstZ|{Kaw^lcCiySgsCy{Hh~RyjRfrk@wx[lu`@kuWfyUorSnoPauT~eKixUrrOqjOro^i|Mrqj@pcJzsd@z_Bdgm@qk@bmb@qlLlsWynX`|ReyM|dNudC|_L_zRtzI{ob@jzHywM|yGx~DbgIdNztJy_D`tHkiKtsFerR`aGktJlnGguBdxLfLraRjpC|sM|dGdfInyJz`Gzl@zhKf_BdeX?lxOwkGbiTsqAflPfrC`qb@`nCxwLvPpyJhgCrlJliIhvInvNdpHrfR~eCzwJ",
        "_b_{BsdbbRnoJdn@pkAazC{iDwuEs`LqqGwjFujHst@}cIp{GswItmR}kJ~`JivJpe@mmDv{G{~BzoGkRd`QfqDl~StlH`}X|kLrxT{kCxwP}fQfnIgzTe|AgcV{hDahKqlGa`I}}BajH{`@{xJhdE}vc@~_EeeJx`Kgv@x~]~oCjvUotDl}V_lIpyT_g@j_c@bzKjaa@rvItpObqJvsIx}GpfFhsAjyE}UbgIqfG|eLuvGpsKaeA`pN~\\vhTz~Dddm@biUfth@ntP`jGegHvaEspPf}DmrJwxBodKqrWeyXwhQogUahQirZar@}t@omL{dWsjK_aJowNy~DabE{pGxpBibJczE{`MigPq_P_~FgaLhi@_cHdvIqhO~bSgnV`~Jg{S`yB{hQtnFo|GddJpLvaF{`C`_B{pGme@mxBwkDj]a|FehGilIipPwbEayPmy@mbQegGsuJ{lTixF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "uksbCguhhRphR|lJf_Sjz\\bdI~aTtH`hKz}JfmIfsVpqG`{Lp{GhcCzdHb}Gp}DjwLdvArjFqhD~]}iLfzB}_@fvE`hJvjA|_M__AxwOdkDj{NzwK|~MdqZzwKpji@brIjzIpk@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mifkDwh_qQecFesEglRssMo_Ma`Hu~DmwCyoIy~Eui@k~JliBwsJt~Do~E`dKq|El}HorFc@ogHkl@}mHjk@olCriGiaHj~RufPh_DwtFroGehFz~OmxBvbPsjAtmz@crTnoKanEdqHayC`jAsaIeqHgeGofIweB}mB{oGvz@}cIfpHqrQzcDa`Ixk\\e_Dxna@{a@ttIbn@rm[icGbv_@kpAv{Pew@nbPoDblUxm@t_]dkCvrXbjFliT{tA~vHbkCp}CvxPjcGlp@plLigD|wOqlKxqIiIleFb`ElTzaL|uE`cQbtTfnKzxP`gLfoBngFo_DnfWhqCjxDdj]tmGb`Lz|Ez_JhlInnEpoHzoCdrGeaBpfRdiQzdIddWnfIznKdY~rR{hDfmDxvAxgCtkI`zGdaPv`[xoIzfZ{KziH_fExaC{wJpkGalGdcLoXzkOeiFdcRxlBnxZn{V|bNfVjtCsuKicAu_JerEwqLcsI{_OymNa_b@gyGyee@os@_f]xSeyXhhBisKntDowBe`Hajb@iOklF{NmkEp~DvEruWnzXpoJhzCrjKyXzmJyqIxyGygIfdUkuGrhSvuEvkFsgCjhGosFntJesCjfMwQjuUhgCdzJujd@diDqg_@pm@opVneDqaNznCsaHbcGokEf{Gu|@bfEf{Fn}R~|NtsYfdHn}R_^|gPpa@`}WjnQvcPvjF|qP`mExsFmEziDmyBxaBe{Fvz@asLs~@ouOjfCmzf@puFaml@nfCe`Q`wFq{D||Oxm@~wNj{A`cKi}AzcJoiFztB_iK`iCcrIroG__ArpJ`fBbcHyjDp~Dy_ErlBqbLulFyoY|hBqqQfaDovOmtAuhMinEcdM{i\\uz]qzNw~b@yxBexJz{@y~F|`Ai~@j}DnOvbWovBnwAhs@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_}qgCowinRvqQqzIvtSqbV|n\\arZppL_wG~lI}pQrgI}hDpuN_fChuJmz@f|EkcCdvAuoEcbB_mGeeEcjEyfPqhD}y@ymBxdMcvD~lAw`Ely@abGjdEqfEpwIc{@t_JpaArkKnrFz}KfiCh_S|}Ah~LxbCxjKojEnv{@cbj@x}HuwS~zJ_kp@jeGaxPz}FquNa{BaoNwaQmzMgcI_{PuqNse`@yYcsHddEojQjcQkc]x`PsyTd}GenLz`GaiIjaHvp@pzGxhG||CbqIdqGdyLbtGhyFzfBmwCldA{hSxsFw}Vl~GcjF|uFea@vpKk|AbxBsgC{fAyfUxxAszEnoEe~FhzOo|FfsK`GlzLd`OtlGp~DfgLhrAx{NfmJ|pYzi]dr@tbGosMf}v@f\\v|X~MvpKtSx_E`rD~rBnaOamFz|NkfAdcKf|E|rIzsQbbDx}ExyEv\\zbFifD|iFudP|{Ee~Rjjh@mz`A`vH{aM|iM{rQtdJidShtMs_u@`tH{yVfmDubErtEvEppGhfE|~MtdDh_HlFbwGsrD~~KgoH~dSgnTx|G}wJ|_Au~K~zC_kJf_N{wJzhQitLzwK{w@dkOkxDnzQcpKxfQkePvrUiaWh}NmyLheEmkEpwe@glr@zgMgnKdqZwaQd`CcuFrlDqeFbcN}rCjzImo@jg`@emAt{HogHdcKeqGlzGquB`qEuvFjg@snGakF}cIy_Fc~FtaA}sBhgVicGhnGalF`aGw|L|fEwfLv_[ky[~eIemN~fBgnIlwCk`HfyG}tAv_H`pB~yDjcEjfOpp`@v`FlnCfxI}rCnoLalG|qJscHxjJarJtnQoqVxnM_nS|}NoeJptIucEpwKvxBj}LzqGt~JvuEn}EzoJzbGxbBnnKyvCtrGa{BfsIzaAx|Teb@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "o{d^wegfDaiPdiw@yJtlG|~Ab_IpfTxk\\~qA`kHwz@tsI_rArjYcxO`txA}bOx`dAozDvuSspDb{c@j~I|kWrvd@fzUjmFfrE`dJv}b@a`Br}OjiIrqh@irNpc_AxaBb|U|zFp~PlbP`bm@~vHf~Zp{Grp_@pqLr{]nmFhxSqAnjSmuFbkQesEjbSmj@t_W~{B|`XjaNdgThvInrGtp[lmQxmm@hxTpjHzpG|[zjAb}BbkDofVjkcByjDhej@rcFld\\__Llrc@ihAf~NnaCrpFizDbjSyxNfd`@stElx^~gAnl[ghDjmPukNt~L_g[~cQs_[zs_@gnUvvj@e|OhiZuiJn|IkgEbpVce@|cc@raJvta@z_b@|wp@vzfAzfm@hoZ|vXjbFxsS`iP|eD|oZofIru^quAlyt@ffFpbf@}sA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "twsMconyDlbDj{Bxpc@f|P`oDbnBxjBi~@r|E{rFnoJbnCxaBnx@rvIzjBfzHcz@|sB}hCbwCasJvmBmlPfeGspSxn@myLf|D_gBnqItSfeHolBbmO}@nmMjcCtxE|dT`lFd{IzuBh}AnjCgtAhzDql@flMp|RtyQhnSfuKh{Cr_NnaCnqHz~DxxLhrNxxZ~{NbaQ~xFzij@|_f@nsTjva@`kF~aI_h@fm|@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["dhrO{zapD`mFp@jaGoNv~HukH`lS}gP~dRa|LpsOiIbzZztAp_O|Ll}Tgk@vzg@pAna\\t]p`NkfAj`c@ubT`|f@wiHte\\euC"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "danGyvosDrgCxsFrkJ~rLxtFv{Kh~@pyHniS|hOreR~}LtwQhlIdsG|uAvgWmeAxw[em@rjK~eB`mFt{C`pNpyUlfJf_NtzD`bFt`HftBngTgrE`pNyNrdHwlDhmFwaQ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{uo`@_jgvEatBdbBsuLtdPq}PbcO}zRrwHohO~lHanc@lxCelUj}J_lZttJkhs@djPy`Q|oFmaKr`MsgJvyM{cVfiNwkSr`g@}}NzkNgqZhrYe|LpsEwzLj|@k_LbhGmsMzvM_p^hdm@mxB|uKokB`pOubBlfW{eF`n_@aiKzj[iwG`|Ko`EnaB}cIqtAckPygIcch@gpRgk[onLm~FscHm`As`X~YwpYrbAwlRfHqkZklAsz_@wnHi~KkkIkjIafFigCckQqk@awMRuow@daAyra@jg@mpf@pm@owF_E"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}vsaAozojC_n@`jGyfDz_PypC`vS{tB|lXjvGbfWneJddYljGdgGf}CdhFeXxpJ~l@npIj}FlvDpzGdqHpiQ|vd@btEb~F`sEdvCleF?t{MwyBhqQfAl~MjlGjaIhwHdzB|bJ~aAliHvgEvaEp`a@buRjhEroG{`@phPl`r@~tp@``N||CxhT~dQhvVl_V|lJ|oSllC|s@toCjoD`dDjrK`{[|{j@ce@trs@tiJxgVh`DxrUxpDja`@wOb}HziAnli@mZfwp@bbClaRv}Ih{PdrH`hLnfB~|@d`C}~@zeBbOxpVsxa@rqJauGdeJ~vGlt@~dC~SnOt|GzsDvqYlkSbo^ba^|~GjzNhzDxjEl{SpeG~{AnjDzuAbiTzgAtei@byEnjy@tgAt_b@a|@jwT`lMfr]fuB`_Jtf@buEh~Lzh]fuTdeXxbCb~GteHfnb@d|MnbMvf@toE_uRhvUm{PloNmaQfqFwwDr]pa@rhCv~FdnKnbH~vI`jPd~CvvJvtc@v_Ini^prKtgMnhEl~T_qAna[keDf{Tqu@liT"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ydeL}kcpAofK|rCohE`uHqQjnP|mAplr@o}@flf@or@lqKaeBh~LkzA|{_@rgAhrg@uRpfHtMrn_@miBtjiAnNnch@jnF_^lkDrrA`~K`eA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "z{{Vmz|bAmc]_uJa|LcuGuuHqoIoqV_ei@v[{iEpt]ya\\bmAaiHoYkjIjg@yfKm_Eo_Eg|Fi]qzGpzG}nHtg@aiI}eE_lJwoBmoL_bHyiEk]g|EzqH{pIltReeIdnL_wHvcDenK{uBgcIgyIwnDtSibHzoHuvHz}EkbEtcF}sB~wRebLywBggRohFewM{v@}ve@joDw`FoNsqBclDfhC{xJr{Do{JumGmj_@ih@whJtlFwjH`yDk|KycOmriAanOqm@k|MqgCqdJyPsdFnbBclDduBydJleAu~J|@{sDkcFkhMgxVlPalF`xF{sOxdK_rNhtXozLjaUyqHzwYgiNn{Iip_@b~Eeye@wy@m_TgyU{~\\cxPe_PoqHkoD||C{zHtlVodJraHseFbtGyx@fyIx`Dp|Es{C||Cq{SqsC}gQqpHogGqmKutL}mI{BgzExiFakH?mjForFucSwkFguMshAakH}eFunEsuLs{Dq}Cqza@mtF_sKz}BsmI?_jLwsGgzTis@gyb@zsBarWboAsvX|rA}y`@cuEcgb@e~EkwGvg@iuIvsH_xHl{JaaGpt]{wK|kJwqLp{G{iCroEyjDtn`@mtF`lFo~Tg_B_m_@_~AeqUxd@_eQ{}DusLmvE{lMexMo`PgzFueCqhCazAs_[abFqdIsdFa`GauH{jB}~NorHo{IqpGcjFu\\cfIly@wbShnGcwO|cIo~DjcEskf@rjKwhHznJo_DtkU}mC|}h@zbFplX`fLjse@rcHvn\\hfD|dRom@lhJo_ElbDmbD_nFa~J{uBodPvxCwuN~mFuaUhgCylZyy@}vXehFum`@ymNssL_^"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "sn|l@mmn}A_wNofImvJg}BsjMi_@uvHjq@izCfwKosF~aG{hl@djQ{qm@h{Qg{l@~qYgh\\h}[azPd}S}gAlvEgsD~vIudDpoFkd^fle@gya@zxf@u|NdeIyuVn}RwmWzeUgcJbqJuaSblDacQ{jN_}U{jOefN}eSc`@cdYvfEmbj@`fAumm@mvCm`m@shBk}JjGqxJdiD}wWwd@kcj@ygHegUewNj_WsaXzwX_mZdeWuyWhtMy__@plLaqf@flKehr@dqFka\\mc@wuSazBkv`@__LkxRxqG}}Nk{@gtV`g@c`KtdCuhf@vxOmhC|iB}cZlzMkml@|pEq~\\lwOmoMj}YmsPpiN_d^hqDweG`tIkzIdji@aFvib@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "skynAqzytAx}yAaxQjiP}~@xxFql@reFol@hkKomAniDgvMjlAwyZr}GgfSj{MqbKxmAce@hlJckEjgGom@~yVzv@|r]daCzvRd}ErzY_{BfnJ`f@|yFz`Bl_HzlKxwGh|On~Xnmg@pyBnpJbUt{OdnEzuMl_MbmPncs@lpd@njs@jc_@jij@fbJtjh@znKllY~f[vzMr|BxrGxd@z{Rt]n~_@bmBt{NdkCzuCrpCt_Iln]zbK|pP|}VfoI`}X`zBnp\\~cEd}X`oBvlLxvCjbMl~HteNjpNxoGdmLpqDb_b@via@d_QxyY`fNnvIdMpsv@rtM~|h@lpXrxMrt@`dKpBf|c@n}^~zIjmGbfMfdGjvLu`GznKm_HteCuh@fwJbpM~lSjhX|fKbcN~tEpiBlv]veAzfGxkChgJjaIvkKxxMxrHdaNhtEx`PxmAnkOuzB|cHwiHrfDiqd@peHu`GftC{hFjsI{pSb`TuxSxgTirM~sXp`@vnDr}BrfCt{SdhF~sFrdFrsAnoLbEfmV{{AlbPqcCt{Bu`HlnB{gFxuCxsMjmSnaV~c_@vwBrmIlsCl~FvoTxqIn`VxyKx_KxwOrbIzjOxyGjkHznIzlLpaYjhYnqa@d{a@zyPthKruYfcKtp\\jaF`l_@`wFn_s@tjJ|k\\ptOhlV|sMnkQfyIbdNxuD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ylkfAkf}Te}EwgJg~DkgAogFpkBunDxsDcsJjh@_wFur@inGq_C{xPvq@ijZkIywf@k{@qjWwPe_Qy|Viz\\y{a@ud^yvPcrV}nHaqmA}vJmwCimGkuBa`Iir[k_b@irIu}YkcEqqS_eD}}]naAseR`g@w~a@wyAupZupNakVkjCmqImtAm{Mx~SsrbArzR}qbAiy@ahKrwAchI~wI_|OvaVa}Wv{McyMnwG_dFvbq@wua@fqKk}KhzEi_LbnAagLa\\ibIqsDcsHydJqaLeaDszR~^kfOaal@}csA}QidGppBqmWhdEweZ|el@_oeA~q\\ipx@x{Hylg@x_Fosn@xbAs|oAyk~@oe|@gzLmsUqnKwfZgcA_xGorHibo@gaGqi}AboB{nwAtpAykPvjGaqd@vtS}|x@txR__XtgBugf@u|Byc[osRgdHiyX_g[koIspS}kL}xTouO{oa@}oF{k[cbRskXg`E_cSyPk`b@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{idd@i{fFkzIpLu}@f{GetBrwImsDvvEwzKviHobIfjBur@veMkhJtoPw|KxuOk|K`yDg~Dur@kcEtqAshA`wDif\\f`N}wJliHymHdkCshFcp@{zHr_Ai~Fu|AswCuaGuyDapAsfKqVyjXupCoyW}}AszEfpG_}@znIqbFxkDyuJxaAmbImEolb@qpS_qpA~eCqmKeaBeqGwiHo|Hc_Gk{H~IyjW|tLytQt}X_cN`hL}oLbdF{gF|d@wsIevNsjFe~EmnGwZwnNjlEwpZcc@cuSy`EuwY}eEczFtS}}NbgN}dAfgGtc@puEznIh}Ndc@nvDebBfrB_fCvq@ugE_qDeyFr_AsyE{tCsbB}bIylBc~A_hBdsLwsCdr@yoCy]mZ_}BdGqhCsfBgkAkvUoaA_}Fit@auN}u@gz{@ybAqgEsbBopCaMi}AnqHmiOxrUspKlfLizKxoJimGjvHi`Ld~QchG|qDohGfWyrOcxDcvPybHeiXypCawEtwAivJdnK"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "iyzx@`pmO`uH{{@`uNvyBtuHwWdvBikD~nKt|AdhTbfJ`rKr@h|BqcJ|jLe}FdzUyvCxsFgxCpuC_Nziv@a`Gtov@y}HzfFniEzbAbuGrqAzsDjdDrr@zqFyuBf}EnlA`xCzyIfsPvrVn_Fhs@z_N|fErdHhfDd_PpuFn_l@bgK`hd@dpCjnJrT|_GlwCrpJdkDv}^zrXzbY`aLhjJ}t@rkJaR|eGtzBtaUqU`nQsdBzbQmqCphr@ypQzb^}sHfbXy_Eh{O{gDxyEg~C~nE{`A|sCwpZnvBckD`v_@spFpwMhj@prDblDnoKyDjpNtg@~cEz~BzW~lNr{DlnIwiAhyLrNleLzvFpiD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qis~@fyu`@}eJkfBi}NanD{kN_Ts{WasBud^xfA{vT~gCu`Ha}KubGi_NywMchHod`@auH}s[oaCgrIf_BklGp~CskKr}BeaNpfAodLwuAydKaiJqdIceMi|CsaI_`DwvYqqF{k`@orGkgR_rGwaMuxE}zFo}Lm~FwxIm|Ky{Ia_I{j]qk@ahPfAapH`lFmdGx`CkvVoop@}vOsJcvQf|EgaN`uH__LhrBghNutLwnJmeKywHiyGk{M_oRkzBihS|qDkiQz_b@ufu@zfA_lHqtAmgJufHuhMmfFspQcmVsyEmoa@lTmxNyeCwyAsxH`rEie^lKebG{eA{`H_aE}qEqbJvG}yHdm@y__@scIu_WmqQs`]sod@__EauJ{aBkrLnsSaebAwbDk}Iycr@ylO_{CyeQm[}zTekCqeMoqByjFmkRy}^umYokw@kiJej]mgC}|DmwQavTupTay[shCkjQqq@}jXzpBa`OlaEqiCbcB}fDcdHub`@fqM}nn@hiMq`h@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "iyzx@`pmObvCjdCtiE|sH}EhxHotM|kJkqEz_DwzMhfHy}MxyFspEvrIgbEpkIq}QntKk`HtgKtqAl|KwoBrzQcuC|`e@jk@j|g@jjCz~Ol{EhwOteNpoi@roFrxOr`RluKkMnmMabExmMssGv`H~|@bkRukGlvQwoOpbQqlDniLc}Jz_PsvUxuCm~NpxIccUzzHy}HpvMahDp~Onb@~lVu{GxlNk~KddK"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ugcm@doxr@vfA{vBn~Dc{DtlSmpD~}`A{{TzdQzb@r{JjiCtsJzBznJtm@tyQzkLbpe@xof@dkBeaBdkC_mHbhAorHge@{{FfsHe{HxaKgsInhE}gJ~oDigOzRkfMybAwbKpkA_aPn_IadQjpO_nEflMejC~hF{hE~mKmZf}Is|K|eA}kQnyKyzV_UsaEer@orAtlA}|Afbd@{~DttRqsCh}FdmAbgE~eBp}\\rDpePbyIvzQzv@|bEx`BvlDnpJvnMrAvoPbaB`rQle@tto@ifBvhc@aRnzEoeD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ugcm@doxr@ahDb_FgvFffGqcIfyAecAxpDqAxfIbwDrnHfnI`cCv`KzR|iHnn@zsDtsDtrMpnJboLhkDrvJbtEoT`pHys@xkCdaBp`BxoEnxM|z@zvK{wEpjBcmDtlF_vIpgGmtGtkHs`Ed~PfuA`bF}TrnGelBprDseDoXodLslH}aK{jDweLc}AypKb@ovPn`DoaMtaGidGt}@grJa]wxIvz@ksD~rAevIdh@owH`pAiwBfwCojO|tAcyO{WijEz}EasCt~IwqEjmEiiFf~BccAb~BdM`kBtpCbaBr]|sByvNhkEkRptAlrBfmChmPnuq@axE`fAw`GbhC{uA~uHh`EhvO|UnxH"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qis~@fyu`@_vApmE~h@p{YzoGte\\txEdfIxgH`fA|gE~mEv_F`kH~sGr}Ggk@rcOc|DtpNmwDnbGylBfQulGkcDgeHujCs_EgKczMjhDm~NbhCauFuw@woVjyBke@dcAdbEdlSho@roFdrArfC~nCdi@p|Ms{CnqAjeB}KvmJq|Cp_OutLpnPxlCziCn{I~{@l{Knc@~kVmlC`jGttCco@nuJ^zuNriAruLbPraH`jGduDbiHpkAhkImmDnkCbZp_C`dCnlAxkDkHnlCknJfvKkiCxbNmqEfib@ywNxgCmFzxDgiGbdGe|ItaGlQ~xEn`B~uD{e@|iRfsOpdPrsSbvKt|HnsLjjCl_N|DtxD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_wwaA|ayzAgdI{qGsrNktIqb`Agg_@o|MyoJeeDehFkRkgNuuGcw\\}jM_jWi{DadKvp@m~ZcnAy_`@k}Ly`j@edRiYspW`LkvHzl@iwGhhNqqF`|GwtHrtFq{E`iHqfFyH_eE{tJscBulF`CuoPirBkxDifEwiCmwNk~CyrOgv@qiUdpJwyN_T"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qvujAvnodAbfDfrDblJfwDjaMvgDlnHxkD~dEa|@jhKkeNvhPakT|eAauG_aCy}HmuLquNoxMskKodF{}JjM{|LhlIqcJv}UkrL`|SskKnbAuq@|mBo_DoCifEcbDgqEeaBkyCoqHmwDq~[_dWi~FqdQebAklE{jCouKb{Eq`Th|J_q]bmMabd@tmAu_LomAmtF_tR{_JcuF_xLq_HsuRwsCm~NqQcdH{iDaoBa_G}t@kgGdy@g{MzhIekCxIkzAs{DscAgvKdm@{nOzlEiqQnhHsbNt_J{rGznVukHpzUgfFzic@etQdpU~IncYfKn{CegGdbAsbH`zBifCjaSkaH~yD{pG|j@ufInzKocRbaDijKjzB{v@phDpLtwEtxCduC~mFtvGxaJpoJvdH`qZxzQzcDrPtuBg_C|T_yFu{@wiG_bIejPhrB}uLrtFgbLh~FayCpnI{f@boL|~AxbN~MvwXykChuXiyE`kHszEttUmxj@nnG_fCtpHaeAzaL`dB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{awxAi{foSryFbrIf}RdzHhn@`yEwfFn_Pv}B||DxnMd{IpzNx~QrDpdHy|@fhEtwEtlF`mKdqI{KhzCzzA~eQw~BtbFygI|yGwmIveMemF`}Kk_Dz|EctGnjEasDtxDziKlsIpwJz}PkfAf_Ps}@xhGtePjwEnaBp~Cv}Aps]nwA`wDxsN}|CvoYmaQjfNanDt~WvhJ_Txu^qdI`gMycMldLm_FbwCw{L~sg@nqHbcZiNdhGmcIpwKesFbtF{nJppFatJ`eC{hDzL"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gv`[ugdwTlaE{|EnnFskMrqHqxIrlKseFzrJieD`{HgKnaGuoErj@{gQteI{}DrqP_vK`rKasJt{CscFmtA{|GaoJmzLubMw~HqaRcuE_xAfgDalMmhH{pFex@e}EhhCszE~nDykPxbAidUbxBmaIjqAudFoiFkdH}tNmsIgtNynG{_O"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ia__B`boyOhtEjlGzkN~dQriYt}_@nqVzo\\dkTdl[|fR`rX`|@j_BzvLpm_@niEllDveZn~EvvEvdBnbNo{DpiVszDxdK|z@v_NfmUroLlhIvvGzoC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gazs@~cgwM|sAttBtkNhxIndLp{Dz{La|LdwMudCp`Og{FlbOahKh|\\qvLt~J{dBtxFx{BlwCpaLn~LvfKraP|iBhmGsiAjgZvrc@zoCzlHkeC`gEstL~xFy`JliHgzBn_D}D~{AtpAx|Ad_Exi@jrXkzCzkI`aCr~FtlK`uh@bfM"
      ]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": [
        "u_w^huvqJa~l@~jh@_gm@xsh@{ml@x|g@seEnvAcsT{bPaqNqgNqyGexKkxFo_Eqj`@rrC{~JaG}`Ld~DssMlhCyeK{cDwoGodEchBi~Fi~AmaRme@ynLs{CywC{tDgzFuHcgI~|BkbSijF}cHq~H_rOsfPaid@ofJkkGclPyzDgeGlTccBlyBwyAzfHsKfdMvmCdkJcmAbvJavIbxHo{GvPopKaxDmhGfjB{lYzsQ{gFqBozJooL_bI}tFedWunIc`GcjGgyAo~X{cDgrE{wKggLqqMwtR}rJ_n[wdTocG{wDs`D}cJsrUe}D}|BsfD|O}on@vhc@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "u_w^huvqJj`Ao{D`iDyxFxaOafFhaP{}DryG{BbbJfsC~wKhaI`jIbfKtwGx{PdhGjfMn{TbwJluFtbFxbBxoEjzAp|KcTp{Sgv@xxLjkOnaPh_E|yTfjU~rMlvPfas@zxLv|q@pmDx}LskJphq@tpB|aKvqIh}LreGdzKrOnzIxfChcH|cNvlDbfs@fyCzoNl`QgBxxTgaQh~MetLbwPgk_@p}]ifCtqGlE``GbrHvu[kdCnsLe`Dz~Itr@xjQbKvv_@pH|zSizGlcIqaQ|lHenEtjEueDtmFmsA|iK`Arus@Xr|HmnB`hFkoN`cIahFraJcIj~KppGhuDr|ZqoUhcN}pE|zTwvRbim@_dx@puMoqI|wQdd@hw[rIveZ_}@r_f@quMzuf@ysSjiX}rDruQ|yBr}Hv|B|lC{Lf_CsfC`wDutRdrBmih@Nu~WphC_de@x}L}xA``VdvBlaL`pF`yBfcE``BtwShcMjzTj}Lru^p{@bbQnvAppFzdCnkEvhDlgD~cYhdEdp\\viH~oPvrP|nMxjRns@vuRyc@xxN~fClzF`}JziJlzMhfOd|FxoK{VzzOxhF`_Q`~JrvUpyHpaNxwOvzKpsPvlQhjKl|QhgNz`HbkRl|KtSvcOasJhh@mvQ_wFwcOtkGysG|jNupArdFz`@bdFx}FneQdnM`kUrlInwLvwCfmK|hCvrXveAdqTi~Ad{GmsIf`Ooh`@fad@abl@deq@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "if_~Fwuk_I_`_@_tf@kuU{{`@guL{vZmiB}mGejJw|d@ofIy}o@gpFu`c@wlEian@ge@gkNjCyrUv`EcjQdvCgcJ|nRagf@f|R}`g@jaUaja@f_HkvHbwIanDnpIe`Ctm`@ue\\liN{xJj}Re`PpuHsuLh_K{kLj{Hm~GduCchIlz@ujJmcBs`Y}fEcj^krAyuQ~JyhG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}ve{F_bttI`fAutr@|~@imm@|mAckx@biAe`PxcAioShIqdI{pGk`H{tCe~DyuB{tCkeC~]upBpgFuyJflJivi@joEeqc@x`CikJwqLegGsrNyzW}nUytFqaKijEmxPct@imz@i{C_`Xq`GscGcjSodL{pOqjCoqFwjFgsDe{G|EabHxzCqrPvuAsjLztB{oHdzDctGtdIimGxuEuh@x{Bu{BlAmuEr@e_Din@qkBelBkfAupCfv@y~KpnJupVjhXyqHjoOieDffG_|Cp`AumFivIcgCukI`eBggQpv@efWivBqwIizQuaJl~RwoZtkUou[rcCgpIzjA}nShZo`P~kA_cFzxDyuFnoWmcNrlEmdNjsC}{QwK}y{@dg@cuQjpJ_hNbwCgoHlaCcaC|aDr_@pmEnvBvlKnNbsHr^~pCjzC|gCbn@nvBcaCldHce[`zHeoHhlCacFpbEgu@haCbwCc`AvfLlmEjmElpJ?pzI}mHn|HevAxpHzfEdnLdhFjpHbGpmDqiCjzH{pT~zWsxp@`a@gmJ{wDicn@mQy|TfzBm{K~oBqnc@b~BcrJjGiiKyc@k{OqcJgmJapAuyDcz@kcDkH_lIlaFmy[t|M{i]zrLkbShiKc|HbvYeoKnbh@ybNbwZggQrkMwkTnmYg`N`xx@__LtyJ}bGddEqgGxuOgmWrtZu_q@ziOup\\fbYctl@b|Vmyh@|{c@g}h@nkDckGn}Rc{c@zmSeah@gsC{v[tm^qhj@ptJ}rPv~BimFflKck^n~Xa_q@bfd@}`~@`pTsth@loAuiJ{ByfJgsC}`KqsBs`LzwCchUtrGqcWbpEshNvnH{tPb~Gs~LvcCmsIxyFsac@huCieE~fDs|BvlDwQhq[pgSbmc@xwA~lZnCvoTugA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ifyyGutnkH_hA`kH_fQb_k@izK~`c@wlJba_@qaAxuCgqDjwGctGpfEgoHti@{}EycBwmC_xF{u@qdHdl@_dGrgCuaHtdDkdOt]e}Sg~B_`LapHew@efb@n{Wul[v}Ukr^feUwmJ~kHymYjfZgaYxyYqeVffT_dFpcJq~Anfa@cvDri`A{uA~aVf{EtnQflDhpQ_aIfsP}mOj|LmzLniFocMiqB}zSqm@erSbsIadIpwJosF`p\\aiPnpd@gq^|aI}fl@sfQm`_@{j\\qlLwiT_vJgdIqcI{iBguHtqAghIjsKk_IxrRajKd}H{kYobC_`e@i~Kml]y~RqzOm{YmaKeeVcgJ}cH}}NoNyaNtQc}IieEwuG}vH_xFciIuvGapMybAmwQn}EavSxtQob[pzc@afh@dcWcqV`mFinGpkMqoTtxDwkRk_Hoj_@gnIca^{sEk_Ic|HamE_}Of}Cs`J~mEgaM|{EenWzpHske@vvEodKl~F}k@szD`pAkpN|a@qkMkmGgqSo|N}h[ipWsur@keOm}Ie`Q}xGs`JsiM}sB}z_@{wDmm]}vKgoT_fJmu`@eyEqvZkgEceK_lHmtGipYmw^giOm|WgxOo|TypIakFr}@ihPniFomYxtEol[`jIuxSfrIcaCfjGs_A|hCsnGnXi`IebAocNgKonYgvLsn_@gcVggl@_dFelh@jnD}yTd_Pq~P|_O_hMt}DssMhDibHvFekBgsBkdQhUe`QvkDo`O`ScoYwcCo|c@}t@i{BfeAyvPpkF{qTxwGmxOpz[e~\\`mFigPlgIefb@l~GapObpMieRlxG_`In}NizSzbYqcW~wSggCbrPwnDriGm~Gp`@kkF_|Ay~F__G_yFkkLguAsrVfjAuhR~dEacEd}FkxE`yBcsG}fDkdCqlLfsAeuOnaJmoZn~Lqt[plWqfb@foNwk_@|kKikb@juB{b[yvBiwTibIiuXutJ{oVagKsuIijLyuFizPgnb@shOmk_@x|AqvMvrCilIc|Hef`@avAoqJ{yBet^buDmt_@jnPgaYngJuiXuh@yqU}wDmvQy{IkjKa{KajHmfGeoKmO_}@lmCshg@eTuhXgz@stA|nBcj`@zbQ}wc@`aSyzUlrXae\\fjGkrLnqBmwRpp@uoNv}BuxSxjDg~u@xcBmjGjeCesDf_MjbDzpBq|Cg~Hiqk@amFk}J_cTgvMyhTcdLq{F_xHeaAilIvcBqmIlqKmqMdyK_xRh{CsuYd}@ejO`a@khXseEamz@mnNsqv@azOwv^mfXowMqt[{eHcbQmfMcpQr|DmrP|~ZqhDrlHqzHz_cAabFjeCis@jzBirNd`bAytEzi_@whIhaH{nLn_E}_Kp|Sc}Irqh@miGfgFamG}zEekH_z_@{vR{md@q`CqlMa[uk`@_cO_{]_fHmiTw~I}bJaiJh}A}da@|{]kuS|cH{mLwmDuqMmwPu}Fu`IohMgaKosFy~FufBuc^gj@ezd@dlBu}X~w@ygc@lsAk``@zjAevOyjCkhKstF{{GadI~HgzH~}Kw{Kfpo@atItwSvd@piO}hBjfZy~ElqWsiAryTauHjbFaqLuoCawFwkG_{BwcO~|@cmPesDw`RyhBknDyfCis@{aEnaBe`DrxGii@bpKrgCflMrwA~ePugE`e\\mpFbgV{}Ece@ujIudPukGawFcsJ?aqL?u{Nq}DyzIy`PayDw`SlrIusr@|mHwp_Aqp@gcJk~CkgBcmCalFu`AarxAqbEwlPkzCwtGo_F}duAysEchIseEksKzBuxRynAwrV{pFg{_@gdCwhVcJk{Bht@wqWk~D}r]_nAspEyoCo~CguG_tYsdFecr@phCgnK~|@ikWaeB_c^knDy|U`mDqlLxqDwcQovCwpLm~MmvEisMgyG{|E}iNwoA{cKgsDu~IizDohGv[wal@kqMiig@drEe|Fap@uis@kkHs~_AokCm{e@gyHcdbA{|Fm`^o_Dclk@aoBowg@w{L_tYi~@snTyc@cdY}iBg_OucD}mIssHkwEqgK|sBo|GnvB{~CouQmp@_tYg`AuzO{fS}vc@ovHskXmbEcfY|iB}ts@t`Bibo@ltHyfo@v`K_kXdbH}wTjjCosShxAiqQ}bCwsTcrDkgNy~Fy|GmuDynLmmCeep@drGgeIb_Y}kVfta@_}Nn~l@ugYhrUoqJhzJvcD~fO{B`zPbo@jfS`lRtlHq{FtoIqon@azBmpaAsnG{`h@zaByzUeaDc}Jg_NuwFgjByvNnmIufOruP}wJblJkhJrpLlYllPucCnlCohGgsE}hO}|Be{IqhDkqA}oEhrCgsEveAwaE_rBsnAwvFp|@eeVfjB_x`@fvW{ag@fnCorTvLsbHgl@yiS_cFskWe|GcnOekCanDpW}mHvbCm~Gr_HkRf`LrcFf}JtjW|aJrf]xjSphQ~fT~{BfxIk`GbfFuyEvbIi}@xi@izEqdCaiK_~S_x`@udDifP}hBu}W~r@u}g@jyEirZpoH{cLryFwnM_hBm_Ik`HudDajIaFaoGkeCu|Suyk@w|Lay\\_s@mhIj{Ae}Rom@ijKqbLay_@_|Mes]oaIs~AccHec@mcCcsFaeBu{i@}u@m`FikIktc@euPqwq@}lIwrWgsC}{k@}~AwiGm`Fa|M_vHeb[ga@afN~oV~lHjfZbxOlgF|mHcf@jnl@plF}@dkJkcFlkEwbDfvD_pDz{HmfKblV}yn@fx\\o{{@~m`@ex`ApjVo|l@|`KspQnlH{yJ|_a@q{`@zg_@kc_@h{w@aeu@|}u@a`o@bn{@mzs@p_b@gr]tfhAoo}@lnUquOhqi@et^t}f@}}Zjib@_vWfeBkqNuqHae@mkEoxAyqBm~FylIkdQaoAixHfa@urMwhD}hN{_IgrD}pQrsBgpGpjAwdH_eDyqBmkG{{AusJsn@uuIekI_xGicB_qO~|@weNxKcpKvpFsaJ~iI_dEpXm}Jm`@esR`uGqtArnMrqDdfJ~xEp_Hvd@nkC_kIy|Bu~d@~|@coL~bH}gCzpFokDdgHquAhgIh}BpbEwvEnC_y_@}|CiaVgKinb@zyIkb_@st@ofUokCmjUnxAkv_@gqGa_VyuIa{N{lGg~C_tCogGl@}{]{X}pR}jK}jMwqDodLm`@gdU?qiOpnJmwj@pnHisYboL{vZdnG}sO`bReeJ~aMq|QdmO_~MhfO}rBrc\\}jKrqH}wK?mdNr~B_dRdeB}cTfuT}fl@xSsrO~dD{wKr~H}~@bqJ`xCrbJ{~CldMcxMbzLivJrwO}jMnqHokCfeBmqJcxCkqN|rB{wWfpHmriAfe@akIl~Hc~FuX}wIwK_kKle@kdPwdHa~Jm`GgyHm}HooWcpLwjSo~JmdPar@qwKvqDikIdkIsKvqFpwKvdHl~HzdHqkApXkdPxxLwaRrk_@moZ~wEujHrkEkrLj{AecN|rCcvO`kL_jKraKeaD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["iud~DmivoEp|DyxAtkOwkEfth@igO~s_@cdM|el@qjPzjPkmDd~J_iAhvp@ydXt{g@_}Mhe`@c}I|mo@ekNh|OcvE"]
    },
    { "kind": "International boundary (verify)", "lines": ["igwXs}jnEcze@wef@wjf@}uf@"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{{gWgns~FaGjq[naBv}p@ziB`kTfRpmI}AtcRgxBzuNetDtkIkxK~}Kq}X~|[wcOn~S`sQfem@hpQjph@biYx}y@hzQpq`@p~Q|bIrma@j}X|eTpdVzpAltGylCbps@giCn~QazBzi^coFd_i@w_Gjg[w\\hq]mwA|dk@kyDndZacRtqZu_Vzpb@euVlrc@ukW~td@ea[rok@us]bso@ebBdeJmP`yCqk@lzs@um@h|u@i^rad@_rB|uJc~EjmGctUznJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "|ltjBepumC~jJt_|@`dO~vuAn|I|py@`fLn~eAxhGvin@`jI|{y@wFhkH_cFnxNgl@jaa@pyHdag@rtAjx^koCpoVyrGl}U_vKjkUqsCpxe@nmB~dv@mnAvet@wlGxer@giB`tc@nx@~`UewAjtV{gFbgX_iKtaTs_Y|jXezWhyRupBbcDmxBzgEec@|eEiTtdw@_Szkt@s@hq]qBhviAqBjviAqBhviAoBhviAqBhviAqBhviAqBjviAqBhviA}@fuf@~}@d{c@vdAfug@u\\f{Dg_BxsHknDdrE{bMd|T_vIbaRy_Q`|XwwRxvO{gEzbMiqB~~WwnBjxQ{WthNliHh}YpeHnhSn|GdnMneIpbXfeIrdTui@l{c@dn@d~FsT|oS}zGxiRzWprR`jJ~vTllC~c^"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "|hrkBojdyChaIutd@bZ{qS{}CmbOntEq|RphQiwVvnBw{XajJ{`[dmByzd@reQwtn@nuByof@ifOu`n@g}k@}}h@igi@onf@gxo@cze@}kf@ukVaa_@yha@uuWqfl@e{Skbm@cqX_neAh@RabT{aM_`VouCe__@?kvSqtBimHoiFwjFiuJqpHycNkjWcjm@iqNk}e@{dImin@qBcyr@{Bw}p@gAqk["
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["|ltjBepumCm`Gwyh@mtFk|f@ctFklm@acE{cd@st@wiHrdFgmxAz_D_~e@|{CmpLxyK{sPlb^sp_@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "vkvgC_|}}D_dSqtZok[qvZgf`@km_@}s\\s}[gaY{mXutb@gza@egb@_ma@aoCkaGi{AokBoj^`{M_lc@c}VutVih@csUf_@ukIk{A}bHqeF}|Qi~Z_e]}cTce[{iPakl@k`WwtIekAk_JiJgiNxsEozWz`O}mT`tJab`@~jIow[_lIekPyuBukH\\o{GrrCwvEruJekC`vHc|JrgBycMfBiyFcmCusKc{XszE_{DwuFoaBw}IuGqkZe~Fu~X{zH{dH_Tc`GboB}tMduAqcUdx@m_}@dD}__AyaDaic@tfAewh@jqOac]~q@w_Ti`KslK}}@uq@|xG_h@`bQ_|B~jLifPvtSqkMd|b@}aLxwg@i{Bzfz@u|h@vgp@avEvre@ejDzlKgcXhbd@}iAjby@cmAxg{@}Vlqd@ejBhpDcta@leAkx]zK"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "|osc@gq|iAxaCuuHxbCirPqtC}`WgnHe`j@}mJegV{qFgoSq`AgsOst@auUz~CibVirB{pG_Iu{CIkeu@_h@ypUzKoxh@bp@qlYbcAq`N~fB_rg@{Vasq@qu@i{Pgb@ekaAeb@aq`Ai^{}y@vE{a`ApCeyp@`wEkuUxxKesSvrJkkHbcDanCthKucE~uHchJfaNe_CtlSfhBnpWss@ft[}pEbb]}tLro^uwS~_Xw`HrpQ|tAfrRmkEnsSemNl|IahJngGipEfs^gqPnoq@kn_@xzd@kjW~oCgoG_s@{mKywBemYgVcfYjxFcuQii@ioFg`Nwd[sqC}~ZseEsg\\ckEufNR{uPfcKqyn@|Sm_H?}ue@uxEsue@oxq@otDu`I_JabRwhH_sO{yJi|Nym@kvTrUsjY}pGy}Sk|Xo|H}}h@u|@{zVs{Dasd@e}Dw`x@nXkaT|}A}t@rmc@faK`|JxEt`KykCrnEysHrVqez@rTuqu@hhAar}@zu@g|m@xx@e~DfvAwwCb`Q{|Ebhb@vp@nor@pmIrco@y`Ctwk@spQlxcAwz@f`h@ppEzvr@dhGxsy@vdBdoW}nG`tX}}PxxYylZjva@}eTnti@}~MxzYkmD|`Jx`C~dRkHhhZetClbQ~dDf{Gf`NvgKz~CdoVgqFljTmz@rcGq}Df}DgiCvZaaFosFkfNweMieQc`EisMpWerSd_Ci}[nn@sar@upAevNseRepn@sk@qmKdy@cwQdtD}sY`e@ozY{}DecLkwFme@qcIudCazBckF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "uw|qAhyadBwz@uop@tXm~z@|Zii`AzKmw]wnZmdOgcKmv]{nCkn^fe@kkO~`CaiPvtUid`@jdDmtSjdDcmPx_JenK~|IiyRr}AurNyt@}gHyeC_mNukBgdIql@{b`@ntKoiWdyLcbDbdMx`CdrFhu_@pyJ`hl@wmEzmd@qdOjql@grJdsYgsC~aJ}jFpsOo}FloMqcD|_MmhB`uIvcCz{FvxHd_Cr|IpiEdnErcGvyBlee@j_Czga@~kB`lQtqAvgKd}_@`{B}Jnye@}Jnce@jQ|pf@`Sxpi@`vEn{IjzIpnJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "yk_zAini@daHltAdaOnEljXvmBnl]vcCxtRm}OpdTyhSvfGmmDlzSxkDvfKewBljSqwInzXaeQ~rYcvQpoBu}K~bAijKzwC_nFxrCk~It_B{zIdyDgoHnuDwaEnlOsyFzyIubTtuIguMvmDf|DceAxjQiuCrgP`{FhhAlb]rU|aXowAviB{_C`sCyjPzq_@gkh@fy]{md@p_GwqKp`BavSzg@eeVgzAw~HkpNgoU}u@m}JfMu_JbnAo_EhtKswItcR}bIdcMuzAtqFj]pzAxlB|sBjmQ`{Ab~FlcCh~@vnHazAdcE_rBhsZ_cSned@ya\\zpHo}G"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gkfToyqpBoeE``J{iQxpI_uBf}CtfGto]dmF`zNzgFjlGdb@`mEq_ItuHsx@zrFbz@r_KuDbgKoh@b~Fl[tfDq|DzkMecNlos@k_Dl_HtOzmIrdL`gZftBzkMxcGxkj@p~Brom@vElwPjyDvfKjgG|zFvgQpiDhk^pcHzoGxxB~oKkSp`TpuAl{Qhh@`tKew@xoXzcL`|]||NxpYlgLpuY|iL"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "i{xLitwaBlgJld@|eFn{Jl|Jd~E|rOf`ArfSuqBdzV{dHl_McFb~@jfBvmCvuD~|Ad`EujOlmOo`JpgQcfRhjZa|E~qZ{f@tub@fjAzjNgfF`_JcjGnlNsdArnGtnEzxJjH~cGqoAj`IdHxhSqcJ`{@mdAbnB|_@z{TefH`wE|_@h}Ak|AxrGebLprPptGtoQ_b@xne@zG`jp@jHfbr@cLjvm@{Kfzm@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "sn|l@mmn}Abj_@xuR`nQr_Y~eJbtFf|LdaC~|LprDf_]lyLhoWrbInsF~bIz_d@`rVpbd@t|NlsHvdBncF~yCpwDtwFdpJrjZbvDxfHhzErfFryFluE`kHvz@~gLwkEfoIetFtSauFeNkxE`gEueC`uBapB`egA?~{I~nEtzCoCzlK`eBv{Lh^joDq`AfnCioDzuHgrFpdUmbCxbmAyfHtiK}iCxsGysF`zOs`WfcUwfXpkMe~FnrVetCxoQctHjhExEtlAp~BtHtkHdh@xiEboL{hDznVs_LtjWmuT|jY{nVfpT}dR`|Wy|VvmRytQl_SifRxuCmoMfl@ezIh|BetCfeHyuDjdIsxHdhL}xIlqLouB`|KtoCtoQwmC~q@kGjhF_rBfpE`g@xpWmeAtlTmvDphQ{fHrn@dD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "igwXs}jnEl{l@jxl@t{`@ry`@vxCnsDfgErxHnCrf_@g~Bzf`@irSfs]v}N`b^d`DluRlz@rwJtqAdwZppGb{e@~uIzrP|nG|oHtqNz{Ftr@f~Bcz@tbF}fEl_I{`HtwSsyRzmIq~JvtH{gEz|F`wRl``@jtC|}N}PzbLadJb}VimHnmYbA`rLzyJ`kSfwPfdVbqP`~JxlIvwD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "pfh[ogxnAjdBf_BnsGhmTjaGt_Vx}_@~f]jgMfjNjpBllCf{FnyLjwEj_IdvB_JfiCmtElaFuyEvyt@rT~}s@t}AtnCbwBdw@|fR|sBxoXpkA~bG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "|yl}Cs{~aEebM~{BuwT`q@gvZypKkft@h_@wvQyn@_`d@vFi{k@jGaeg@vFaua@mOomOxvBk_HlcBekQliGuge@luH_|[pmJmaRxwMu`IduCgmLlwCiuVt}LexLrlJk`JxbBsq[gLkir@ruKgld@dgHmpg@t|LmcZliHgtCfk@chIf`@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "n~otAyusiEr~L`|h@niF`_Ud|Sfw}@|fQzvu@bnB~fMx|Gzk[lmDncMh}Npmp@x|FntS|{F|rOdyJh|g@fcJvqe@pmJlci@bzKffn@ngHxnYb_Gr{PvdOvyh@||Bh~@t_JaSvuU{hDbsSsmIn{JswG~n]yuDpxYmdB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "bjteA{_ktEcN~}X`pAzr_@hdEx~FtsLzkAbc[dfIjiIluD|{QhaK~sYp~O`uGjpBn}GwQdec@k_Ir`e@}nIlzMqiBvqq@}nFjvb@adCl_TmRdb[koBvdNajHzoH_xHlvDw{c@z}Ea_Jr|Pq{Sznp@osl@pr^s`XlxZw_U~sr@{lf@zbg@}r]~sd@wxBjnDwaD`|Z`iIjbl@vvE||\\uzC|`r@r_Apju@prDvmRl_FliFjaH~zDtkTjwEb`n@bkEl`FnpIl`Eh`XfoHjhXnfJ|xI~oBtpAwdAb{Ku`Ip|_@a`I`nw@mx@jeClnBbnAt{L}Vh_NaeB~cEeiErpDs`Kz_C_lG}xH}uMaoBurKzhEyxAjrKypJf_O}vd@taa@onYjp[c}TvoOkvGf}OykDtzCchHlaCijLrAe{Hmp@u`JfhDwbPvbPsnHryF_jJfLy|I{eFiiLusMq`ZsaJwnP}|Bgcb@cuSip]kzAilWgLqgQ`g@}ld@dhDw{XptB}y`@pmXwdBnhG|}ApdWp~Cd{Sv_FnfItJlpNp{Dpug@lpApwKtbE`kF`h@rgCceYvrXag[zoU}bo@tq[uxDpdG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "danGyvosDmaEaRy}l@vbBmc[|K}rPunDeiSaeB}|PsJkn]kvFqgQtzAsa_Aw~HslIisA{}]i{BqpH}fEovB_oDy~Q_eF{i]myLssNoqH}ca@xaAofVkp@wcDceAwsGwkSinTcnYcgX{dJwbOyxNsmI{r]i@}@ktuAiuyAavm@sfi@c}V{iQoqGiTchJwnBsxGbjFy~FhxGgkF~|AqtBfqFzCdyIojD~dFmoI|cG_sEhcG|PfwXovIhyR_sMkGgz[kvFm_`@{`NsbH{XaxFnbAysE|rBarEjyE{{FbjEyvV}|CchVqnHgsJwwFm`L{qFauIxdAahDraJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kp_vA}s|}Eucw@fgE{od@~dCowf@xlCeod@tdC{`V}pQqzTesGycfAsbUcdMgzGgbe@ekPa_JolA{_o@adP}{^tr@{f_@lmBsaRujH_hNakGg{K`Qoa]mxBsnFquA{MyfI~zB_bTq_BcoNm@_{Pw[oxLqdH}dGu`b@{dJy_FogFccAsqDunEywNueIyoLiiFk_J_n@yaCq\\_tJ}hCasJm}CekDs|BguMpeA{jM{hCauHoxAwmE}EciFy`CmvEwfE}tAc~BmlCyaHefJarEucDasEshAkhD_hAq{Gg}CokU}qR{~Ks|O"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "czakAo`taG{gSfhPi|PttKakTbvPmrHlcPy`KjmQg`[baQsz]`nQigXhjZ}lc@ber@cdm@l~m@ofo@n{b@qbX|bVclEf{HiwNn{n@q`Utm`@ydQruXuzCbxNaR|iNhrBzr_@ykJbcZD~jJsiBjdQ_`CjgMjzCbwOrbGvja@uw@zaMijJbuFmtG~oCk`Hj}J?fzHjaGtnDjlSzzb@`iJta{@iY`gMidGvsIg_b@nj]cuDltGyO~yEwcCnaM}uEddL}iMnpJ_dGbqJza[xnKhap@|yTxhYtuJf{`@dbNl_@lwCimA`vFoei@p~\\{zN~yQlo@faMnxFlgItaMjnEjvGv_FzjBprFst@zjOgvExcXnm@`}XlsHruYpG`pB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "w}b~Iud}eDqiCqMedKolBcrIioDijJ}}PotFamC}zEejD_cGcdh@eaBouCevAuHcsAt{@kdCrcH_uDrnHynNbvDcgW`gMigOdlLqoHlzAa~IymBcxIuxCaoIwFidy@`kSyqIqk@ypI}{D_xGgoHwmJgfT_|SmpYenZ{|P}qOalHcxBe|Fq\\ihNgbDkxDg_Bi~AoxAgaLmhBmmCarD`pB_xHzbLmaE~kI"
      ]
    },
    {
      "kind": "Line of control (please verify)",
      "lines": ["ehggEoxodMxcGoqHkM{cX|mBsnSgmB{rGrqAy_Ebh\\`{B`jPcyA|{CwmD~_FscSmZgwe@pdGsxUjlH_iXrkI{mLhGmE"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ko_bAvgyaO|`@vmIgjBz`PopIfi[_h@paLj`HfxQtyJvyTqnQfus@s~Kv~c@auJzg`@uoCd{G~]pgFjcEnhEpzIreFrbBpjAl~AvyBxXvhC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "uhgp@|jzxNouJvWonLzwDudJ`}EypJnsMsfCtWuzDeyDyvOspYi_FchBaqMqL{|LzpAmoSf~JiuKezEudIwtLg`Gm`MalBgkAy}EjrAgpFzdG{xKheRiYzoJ_{c@hN{bf@kQa{Bu{AwiAs`Fk}DasDyqJwcBmbCqkGz|GidNfzFwnNirA}kEmyB{yCcxB{jBsrBkb@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}zmFfvdwK}`LvxBcjL}cAonRhbH{vSjiDocFtoCcoNjh@_}Zn{I_{Uh|GasJxdG_|HemB{{HdmBaaGxsEu}XzuHeeJcmBieJtqA}tF`eG{fGvrJkfPboNojOnoQwmEfnHuqAtmEaoNbrDsvCvhCkh@fnHumEbkR`wFxaQy`KtLiiFkdDeox@{n}@kmYun^s{BekB}bEewA{dGwcAmjHhcFwkk@vn\\cjGtfIoyEn`IusQdpJclj@~xLcyT||HivOf_Bi|Q_SwoM~tBwbI~~Fg~]?iyr@__Gqkf@c~@k}Yn`CioSecFeaM_iQkvTefIel\\ocAedWw}Iq|QixRetQwvEclQnhEayJ|_Au_K|xOolGfa^_^`xXtjHjqNxtGf{f@b_Gbe_As@lur@waGvef@fuAfy\\nnLvlSp`BdkMwkFxiG}_A``H`uCxtLicAtjAcmc@nk]ow`@|c[weg@vg_@klm@fgd@eaB~tE~HdoJtXjfNkyCnuVsvExfO}oEntK{fGfjVql@z_OzlAvjMrfOfqf@lo@poUjHrlPa`Gzvm@_h@d~^dhDded@|_Bn{NegGhgUspKbdNkz\\xcMkpVx}HyvCzhPo_CheRuwFhmHspLdtD_kPpj@ug[y}@gcIgy@uo]ssA_}NyrIevFysEkxK~g@cfYrbDopQvbDg`TfiTu|YdhZgbj@rvJm|q@|yLwbD~zIzpAjfI{pA~zIymS~qHwyB~qHxdFlhNjrD~_JvbDb`[wbDfwDqkEq|@yqQizJwvVa}LcuTyeOwdUkaN{rVyfJs~m@osFwl_@}gDyux@}zLuam@ulXafTqqHerZk_Vs~McrIgxJq`Mo`O}qe@menAccm@{qK_rIwxJerm@efHkyb@gtHcpYwbD{uGakA__F"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "`|p~H~yv`Lw|KbmB{iB`dXmnBtnWegHp{g@{`Mj_v@?|bv@ozJ`xj@{bLzjo@od@haeByXz{xA{Xdb{AwOn}y@_Jdnf@q}CrfI{jOgmBs`KrsMmqMfeTuiIdxXeyLpxKapNdhM{wL}`G}m`@_jKqwMqGuiIjeJusMbmBq{EcmB_fDsbI}`WcaEoqVxvCw_TvvFohHxeIykCleLoYpuHhzF~qTu}@~wb@p_BndKtmGdoPdnKrwW{hC~wLuiL~eCmqJpeHeeIhzDmxOxkCerTxiFmpXdsMotSnkU}pQdg@aiVrcCavUslJuuDn_A"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "`vj`Ibh{aLn~x@~Ibbx@|Ixlt@`Idlt@bIlqr@tHt|s@zHbjz@bo@jbk@zb@xzKnIizCcrd@kqB}pf@~Ioxf@~yD{rcArfD{ycAxvBg|e@hnFmt`@p`Ncl}@vuGgdc@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["}pwjI_p}iCth@bvEa|@v_mBufBrjgB{~A`l_Bq{A~|{AiwAddxAuqA`mv@{pAzuu@mjA`xF"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["exemDiltfH~Mz|`@vQjxi@vKlua@jMxdf@ooQrfPkfStyDgwSpfEgs\\jeP_dFhox@wxB~p]{sD`hq@ifCpwd@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gkuaFeefpGnm@s@l{LkmEntr@ebOxoEqdHhoDgnIxtFckFvuFa{Aj~Jl[t}LiIlsI}hC|bGo~Dz`CsqDvJkkGx~@k_Il`GcwEfzy@_mTrtFebAnmAa_H_c@czM`cEueNdpH_hOb|PqiNt{AciIwsA{f_@t{Awck@xfHauSztDbcApkEh|NzmFp`[ruKpgGnkOxtC~fHcZ`dIg{EtcSuxRxhFob@xcIwoBd}EeuBxnLxaCxgHz}PxaIlrVz|k@tln@luHjoBtqY_HzqFnuCoCr}Mak@hvJfiHjR|kKrnF`xI~fCjnXylPboLmbBvhKnwAfeTbcOhhMdqH`eBsiAntDypKnsm@ycf@`kOwrKihCaoOfH}dEvsAuzCdoDs~An_FIfnIteCvgCw`T|rIorF`jc@yqWfxIv\\fdPzwJlkJhAdfIymAzpBkzBhm@{ec@hbC{kNprQstd@fo[wxi@djVk`b@l{Rkz\\im@{~^rrBuuGleEkbG|iOscHz}c@{hQ|gKupN|q\\a`WtvZopUnud@bzM|ef@jpMfrq@?ldZ?bd@qs]ph@a`a@tm_@wG~s_@uGlgd@kHtp@a_Ih~Fu{NhaKuxElqEqpGta@ciIv|DqdIfxIiaIrdGqtB|pDpuAbyHcdA|`Mw_FjrEqqG~aGahL"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "k}kxEuf|tJawFtoCk`HtSm~IuoCmtShh@mzMl`HumEtiIuoCih@wiIuoCk`HayDezPpAyjRreFy|Zj{AagZa{@qvLfyHqAnloAf`@drfAibBz_Cgja@byZgaYzpU}jNlhUg|Qr`r@u{FrlWamMb}SwxNnbPwtTllCwbFlnBgwDf|C{pAxkDvQ~nEodXnhz@qrE|wVjiDjkUf\\n{H{cFjnRfuHhlU~RdqHgiApkLisB``Jy{U~y\\egHr`X{|Dn`QwtGlua@apCr_d@}vBf~Qk_D|tLufBtoBukGcEk_Jr_@s_G~pCsrH`kHceF~~Kdg@tjUaRlt`@kfFfxXeh@~lS|j@brWb@|dSbgDzkMhcEljGvxQzhD|xAtzC`k@hmG_^bgJdDlrV}iBnyg@}^rir@|nHvqe@bsLjo]vkNbc\\jiWnga@vxIj`Ipbj@peSheEd}G|}CjtJ`[xzJhkEpnVhpIb`^bcCtbTmdAjeu@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ryzNi{l{Ypuf@Kruf@Spuf@Sruf@Spuf@Uruf@Ipuf@Iruf@Upuf@Sruf@Ipuf@Iruf@Upuf@Sruf@Iruf@Ipuf@Uruf@Spuf@I||OIlvSl`E`b^vpLpbXzkA~oRodJfwK{zIbt_@?ruf@Spuf@Uruf@Spuf@Iruf@Ipuf@Uruf@Spuf@Iruf@Ibhi@q@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{dowDacby@bxHbbRnoKxrT|vVowNvre@gi]~c^ejQ|pLyiErte@iiMdod@mqJjcK{_Bpz[igCnmnAfgDv}cBmiG`iq@wgJnml@xuPdkj@vdNbxT_^zaa@akG|dX_dGlgL{dJxki@xdAzkNntCzeUv`a@`lSpxd@hfPpmIffR|_BtrNe`Dhqa@u~Xp|r@}_f@bax@s{i@rjMuqB`pg@yw@`}q@azPngUmjRlsOqgF~zJitL~uG}tLr`@klGw{Logo@n|UkmqA~jVi_mAxqCyuDno\\y`Pngo@k{Z`se@wuS~pa@uoQ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{jjlAznxrAqGlp`AiFhpv@oHlbeAiEvhp@cEv~l@vwPpob@|fRfme@hgIvur@gyBboz@dwAd_RzpG|tR|eEtmMzuBhoSeaBnnYlz@xuI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qvujAvnodAeqAzcLwu@zyUxrF~wl@ccBzuN|_@j`]`eCzkTrnHfeZgjAfaTknFlkJ~Nh_Nm~B|{O{eFt_QgtBrmO{hL|vPkkAxhG|nBjyD|lCb|CnvAfcDelAlsHk`H|rB{vGq_BesE{[wrBtoCse@hzIX|nPqvAdf[gu@dnEsgA~d~@"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["{bbbAa{nDx~@jhq@xkDniQpAv_J_pCpKcuA~g@gdNlm~@m~Ghok@"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{`fmJfnvoYm_O`cXclPelHczSwgJspK?zW~j]rd@ppl@r`@|tg@nvMvc]zrLjzZsrIttj@_dKl~p@t{NvdMy}Ffjm@c`Gfwm@gax@?iax@?gax@?iax@?gax@?gax@?iax@?gax@?iax@?gax@?cax@?max@?cax@?max@?gax@?iax@?gax@?iax@?gax@?iax@?gax@?gax@?iax@?gax@?iax@?gax@?cax@?max@?iax@?gax@?gax@?iax@?"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ui|lIhbg|WyzJobHarKa`OsyTmhb@srNgfRabf@ci\\aoJg_H}bHqQsyFhj@kvGraB{}Kh`EedRzaG}nTnmAsqQo`E{|Ro~KodKycAynKbv@_|HtmEkrG|dGjdDfyUawFfwe@ibTtnK{mEzq`@gaNvaQakFjyc@}bDjy\\mtG~vUadInsY{yIpqYafGddSbPn|Mbe@tv`@uoQbv@eeJtiI_|H_{Bs`DdyQamF`uZszQoaGkhMgcEifCjoWkbE`jb@yzKcmJikIifHgeNjqLanXboZieQ~aTqj[lpZm|WbfWwjSdxR}`MpoO{cXxfV}i[|f]whUnw[klMeeCwaQ`k[mhQb|WkaTpt[aiIfi[mjFreSyrIfd\\wnHliNq`GbkEktDtrEu{FrwDgeHdjBytDz}DitLtkb@{qGfxI{{HlmWwcCdnSqiBhcFi|\\b|WktI{~BqtIuwAumDxxAevU|}g@{lHd|SiwHpbTfrKpgk@f|Khil@rvCvv^rpEd{j@r`M{qMrgIx_EvvCtsL_RpcVp~a@lA`}W`{T|Lxxl@nqGvrWhvK`oc@phI~p\\xrOjm^qkAjaOcyModFi`X`sJszS`uH_vIxdSy`Qb~`@mpL~nXyiRnkc@ioLplXubMbqYcpQh{a@_`WnhMstGr{^ygHxba@cs@vpA"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["m}_jH~tsoV?cuX?stQ?wgF?w~S?{z\\?__S"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["is~_Bxbq}OzCplGubArma@viAbhVyb@d\\qoo@o|@y`jAc~Au`v@wdAazt@ecAsig@er@{{u@gdA{jn@a{@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "rxS|~njMz}E||IfW`iJldAxcNouEt`T?thGjxEdc@nhGq}LtlHqqLriMy{Cn_PaaGlaRqlRfpHqbKhxEgWfmKxwBtkIt]rxn@osEr|AvmCvFxdFaGtrFudDpfEybBpmDvkFjlAnhTprDd{n@jsK|}h@haJlzMl{LbrV~aSdh_@xoZhym@~{f@lsTvo\\daP|gVbvRbeZnmXlbb@~hMfkf@|zRlyu@faMjxe@fyHbr[nfI|w\\bpLbkf@fwKveN|e^`hXp`NzwJt}KhwI|{DzeAbxBal@phEidDtmEoNd`CjbFtShcEkfBzvA_cFv_A{fFbpEebAzqFxw@pjCzrEvJf}^n|H`pNxJjcEheCj{LiIl|Kj_IxoJdkChxHp`B`xEjaGttIzzAnrUdnFvvPvuGxdNhcE~iJzb@``GqtCvmEsr@`sJheC`vGjgAp|DjcJdcMlcV`tHb_Hl~ItpBtjHkgA`wF~]~{Al~I`xE~zBj}JtlFjeCvkGoiEzpTeC~{NayDvgKwcPbkLelM~~IytQl_H_tX~wAipFn_Ky|Gh{JlnAxcM|u@jzOq}DziH{yIf_VwgKzsRkcEjzM~{AvhJvlF`xEvfLj}J|cHlrPqMd}FwbE|rIkbF~|@uhJavGyzWmwPuSnuRawF~wEk`H~]auHjfBasJ_{BkcEwiI~yCcoNjIatIm~IkbF_zCkbFupBkbFunD_|AsqPhnFqpHveAunDkgAm~IjIkaGhIkbFtoCatIjI_yD~zBkcEjh@kbFhIupB~yCisBpcD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "xizX`f`jLomMj_IksLxcN}dGveMgwI~_Ey}TvdGioFnjJ_zDr_GlZ`wFd`E|dGjzBtsKwQzpGybNfna@om@vsD{pa@ycU_x|@{qf@kgf@idX}qj@e}ZyfUogMcxBwz@{tDr@snGjaEsqBpmLioEdqN{pIvxH_pClqLgpF~pIyiFzfRuxEnpJomAvaMomKneJibWjzg@ihAppIduBdnJ`zB|xOneLzeOfgCdgSyCf|Qg{FvzHwyAvnHuvIbkK{eG`{TwvDvyNrsAvxH~~JfrKb|JrvKvkFvbIiKlqLb}IzeOh{Bh}N|u@haOjyBtoQorEvoSuyD|xOssAjpFvy@jxEvaEzpI`rAn}QtQnyMmyAdpIcrIpnHclDriNerEjzOksLtpB{dIylAquMsqEwdN|sBa_WvaFsxHp_ByhGzgDg_BnhGjgA`fOkaHlvPmtG||IcqI`tDo~Rc`Eg~O`hDulH~pI}qOdxEoeL~pI_xEn}LzVn}LwcC~|Ii~LpmK}gDbuJkqLneLc`ErtWghDdyKmjGniF}_NtzHmhGic@sdGfxCstMbgCmsTpkGwhKtfHygH`oH}zF|`GutJz}JixEpuMidFfmK{pI|{CmtGvcC`St~EqWp_ImeAd`JohE~sJetFjuHu|KfjOsu@n|G?j|FtsKduJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}zmFfvdwK`vGp}c@}j@liBuxC`fAifd@q`@s~h@rJ_ePxtDuqZb|Oiqc@nlUaoIvbE_`EbnHsZheJtqAxdGdyEn_J`lFjkI~`Up`S`xX~cSlwDzxJpjAdzJeXvmIa}EdlGkaMnsGutQhkIgbEhlKnvDpxCt~IvbC~{IzeBrzLsiGztImdFsJzhKRbyf@Rz{l@T~yl@Rjfh@Hrde@m[jqMugExxMy~AveMnNtnFpbEtlLr[znPtxDbxJmUznHle_@tDf|l@fG`uo@nGguBspIhJscHnlBouEowAuwQzm@elIjf@ezHnDscHtzBasDiUaqFifC{aGrsAqtHhzEakIneI}tEjtKk~DxtEk~DdcKhJ|nHrDd|FnbAlbDmsAlmD{|@jdB~O|k@poBz`@zpFb[zaGiJfsDs|CrkCwO~eCfU~cEs~AjoE_dE`sD_dEz_IrsAbvI`dBlkF`{B`qFn`CnzE}`@lzEr~ArxGhqClkFduB`zHdw@hvIpw@`iKfU`xJfl@vjLjsX`Xrkq@`p@lj`@n_@vv]sAdeJkdD`uV_uVnnKuoQv{LevNtyDyrN|fDmpEnrG}hCj`HwcA`wFgv@|dGfv@`wF~zBrdGgv@tmEarD|dGav@`wF_{B~vF_dAfrDsvC`{By_EtmEawFx_EsZr{ErZreDlAdzJsjFbjGaeAx{HhmB`ka@piBzbf@|oG~z\\`mDjuo@vzGdsw@`iIz_dAlqKtdcAllKr~`An_Kdsz@nzIdw`A`~Jlzf@`gF|{E|mB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "t_zaAjqtgLbki@olWp_^c{Pjjb@ckSxm[_lOhfj@a|Wtid@moTnwf@e|Uhfl@gaYdnJbkGrdHdxEtoN}VdhGrhIp~Cl|IfaLv{KjiJjwGxbO|Jn~pAir@xgUpdAtcR~sEltH|{EzqFvcCn`R}}Hvee@apHfqF}dF~pNe}GfvM_aCxtDbz@f}EnzPd~DrkEn|T|t@|zFtvFlhIfaLnzJpkG~bGtcF`xCz}EnmMxkBtrM`sCvsHrhOz~P~wAdwMbEnyM{qGre^u`[`lFgzAtxQl~Nt~KhhHbzf@|wUpgFtMjxQ_tDtooAw`a@rqE{wDxsFaoIcZwdPlsG{|Xb}H{rKr{Cce@|hBh}AxtEvuL`vGtgNpgGxeD|_Lfa@vlRmmBzgEjrEfqFjfNzxItcLx`QhdLzlZpiUzpF|uFhmHzjB`eBhuKpsQnvV~lHbaCx}GuzB|oFacK`}IwdGj}LocAluGT"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "t_zaAjqtgL}UmtUbn@wul@rpF{hk@fhBi}\\~oEmpKtjIowAtyCehGk{@crHsUi{IwrI}gWm`FarR_oG}}O{eGkuGs|[qaT}~Nw~OqrDyrNugAar]hpCmsHkQgnKcmOwwIwcQimOutUii_@sfEimOe}FoeIec@sqPyhGklNeix@qoiAewMse]{tAqyQmoBeqNefGynY{|FaeaA}hB{pi@z|ForLugA}hNyyK_`LmdCcxIrK_}FjeN_kJzaOqqDjhKptBhzPiUtkViaDjwSlyA`eZ~aOtaJ~aG|kJ~~@pkNsk@fbXqjF|wa@yiLpwX__AdvOriHzlMvhCpbKgVpoGqiBh|Cg}DtuHyhBxoMmTp`MqwF`qLmzMv}Ks_E~iKxxAjuFaXp`BujCwnAo`CekByjDve@qzC~ePckIjoB_j@xdMotD|wImu@l_EogNbwCwnOptDiaHn_P}fQzeJyhNdeH_eRrtM}jEzdUswJhoGii_@hgCwwd@`yCi`WswJek\\ht@amRb_GgbSllDqpGflJc~MhsMadVxlDw|QucGsnLwyAgnKdlBmsH`{NgbDpwImbD`bG{dJrySk~VfoGorLaQ_iN~sLsp^thLqv`@jeAojPi}@adPlbD{iJx`OipCba_@yh\\lpKexL|wIgmOcD}yh@teByoKa{A{sQumDc`w@}u@aeIr~Lmv^jbS_pd@byN{xWluGwiPldMiaHdwMckFvzNukBbxNjoCxiEjyEneIxgA~hNwyAjrLenKbxOcrCzs\\wwEjkHysFlyzAk~CdX`cXza@nkb@jwGwhIfea@mh\\~n^i~Ylrq@}gCp{^guAf}k@mxBxxYugAnlAsgbAdxAiolApjBmd|A||Aw{pA_IwaG}sBqfMmwCslHzCayDnzIo^pvLx~@pvNwAjc^lnVfzH|m@p_h@iqBrd`@ehGp_]odC`jHulHlyNuwZ|f\\s|h@xxBswO}}BsdMb|JgoGzgRmu@vyt@wcV|ca@}tMn{JcvEtcEo_JvlCt`Azx@hdHlkEvaCvfe@~uKflq@lwO`kb@djJ`QoeI|xHaM~}MshAvy@zrKxjDtuBp_\\bnMt_e@f~Qtgf@~qRvhV|rJ~eP_zR|t[k``@x}F|fDf~BrdMlyAb|J|wIhaHd}FfbDrsAx{K"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "xizX`f`jLfvKbe@bbDpfEnc@lsHkaHzvMjgAxwIjQvwImqIbeN_lIbfDioGb|JdlBprWxEnhSa|@v~ObyA`fNj~Ix~KxyK`uH|wIziJhdF~h`@nEbvPv`Ff~N~qAdvVzgEdfOxlBzu[riBnma@xpH|eR`dCrtFbfLfpRhySl`a@zfFfwQfoU`uU|cTzeZngJzsPtdDj_YntDvwI~xEl~Bz|F_hAljSrkCjsd@`}FjmQteAhyG`{@~e]nfPxa[toQ|rQnaHtrLlbDtiJotDbjSmqFziOiiEt`Jow@ttK`dAjrJtyFzqFtgKpaArsOtmSt`a@`c]n_e@|`MllK`gLjpBjwSnpD|wIugAvjFuxErqP{xEjaHaQbbDntDlc@xwIhu@lsHhpC|jFoc@vjFtgAzxE`kF?~nGugAhaHhc@ntDdpC|}Bb~BptDc~BjbDuxEhoGueIbmOsdMvyAwwIntDkaHjaHic@jaHxkBz}Bd}Fd}F`QlsHwwItxE}jFpeI}jFxdMuxEhaH?viJ}jFvsHepCjaH?~`Hc|J~xEoeIrfE}jF|}B}jFtxEmu@`iIn^d_PmrIfwKwkR`oQqvNdlLedI|pT{yQzxWaVxl[ziVlm[jjVeXyee@vQ{}e@rcG_xg@ryFmnZloByvOjaHc|JldMotDlqJ{oCxwOsc@trLk_P`|Kze@|gQtN`HspFfA}{p@zAoqu@ykBums@clCcyRsdUw}V{qEsjMkjIszLi{Q{yOgpGsiL}mI}gJeoI}xOawFa}EwyAitDwbDm`LzeIntDpnI`iCf`Nfj@xlOqfEvgK~dDt~InlG~{[dCh~g@xDhbb@`D|{j@lEhwp@lF~a`@xC}oEc}GizDojK~eN_bO|qEamJ~q@gyHoNuaIsfBmvLsvKc`]ogI_uShUspVz_C}j_@eMksQ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "xoufCvok}JuuHskC{ce@u_Kojv@_lPeix@i`QwobA{fTy{n@]qmq@i@moh@ye]cn\\omT{`[yoQ_`o@gwQca_@ooK{qFgzn@qtOyepAyhGing@uoPaktAayPuwuAec@obzA{a@w}vAbzf@sfcAlm]kcs@fp`@wlx@pfFw|Bxb[u|Bxj_@`{B"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mu~}Bhu`gBkbQrbBciT_fCggY_cFqnc@kaG_@i`Xq@gxk@y@exk@w@axk@s@exk@y@gxk@w@axk@s@exk@w@gxk@y@_xk@s@kxk@w@gxk@w@exk@s@axk@y@kxk@w@axk@s@axk@]_p\\g}Xpv@eqSfk@ytZvz@}oZ`z@apZbz@yzXtv@syXpv@q~Vzr@q_Ubn@usKjpAqbX|nHknKv`AucLqqAclKoiEeuUqmPgmP_nYucSkp]mjN}gVqxBq|JaiDolc@wrJws[eiJ{{ZwgEouJogTqk@_vV?arY?{qY?{qY?arY?{qY?{qY?arY?{qY?{qY?arY?{qY?{qY?arY?{qY?}qY?_rY?ogV??ef\\?okc@?ikc@?okc@Cokc@Eokc@?okc@?okc@?okc@?okc@?okc@?okc@Cokc@Eskc@?kkc@?ikc@?ikc@?mvf@egUIe~^Iizj@l@y_k@x@yue@p@ete@h@qp_@x@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ahpeD`~~s@drTivc@brTkvc@drTivc@hrTivc@jrTivc@brTivc@drTivc@drTmvc@drTovc@drTivc@brTivc@jrTivc@hrTivc@drTivc@brTivc@drTivc@bbQyw]vc\\_gn@bdZo`k@hiZ_ik@"
      ]
    },
    {
      "kind": "Indefinite (please verify)",
      "lines": [
        "ysxgD`~~s@ssn@?wih@?}ih@?sl[?yq\\?clLa^suDsrByrHyyR_}T}`^mwHqnJsyHwuMot\\c_s@qgG}vIica@epq@o_DkyJmiBubZqkE_jJasLafN}sNylUakF{qMij@anB{a@ygHhrCgwm@|mBurRb}AikVs~@cjFuzCqgEw|I_yGs|Ko|@{gJsPm}C}j@meAacCnYwdI|o@mtL{Mq{Zur@ylHykA{t^ckF_xk@{pHsnb@orFkf[yzRqh]}~SqdUqh^uaVocZqhQu~Os`d@ufIe`^u`CotPiiMihg@}rT__a@ohSk|^wtAanWwjByz]gyB_{EseFoxFctK_Ne|G`kHauCfgJ_dDd~Fa]h~FabExeCigJajAslI}e@ajIsaDquMpl@guMd}FypIxlAimIaQqeGo{BykDcmJ{`AkgLdrAytQcnB_e_@{iXioqAsxF_uDuoPmhDgjNg|DkcD}oGuc@qsCsbCcoZ_zD{|e@}YyrMfu@_li@jf@m}]x~@a~p@|_@eob@`\\i{]xc@skf@"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["ahpeD`~~s@a|f@?um_@?"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qkkyAxp}iAup@|gCaaMlvSevO`_IiqKziOelGptUmrHpwMgyIhzEmeFvjGuuBjzGa{BzXoiDebAe|HrbAw~TzhLgcIrkKrr@xqIeuAb_EkzClsB_cFdm@kdEvfFssAnoK}hOdaIg~\\xrFujVzzHovO`cKwfEvtGsc@llEerA`eAuzCfv@ev@fnH~_DfhL}t@`}JsdG|{DgVxcGlvEdkIi~@vmJ{tIxoKsrId}EepI|i@a`TnrT_p^`{h@_xMhsl@~}@~kp@yn@`vZs}Cb`ErKfaEvvDvbEvg@boEqeB|{ExlA|hCjaGzu@bbCblPzBva`@r}CruYrwHliSjeClx[}j@lgd@uqB~mUkxDltFgj@~vInaBxxLxrNnjK|c[x{IdaOz_Hf~BhdFx}SdsFhcb@fhCnlNjnE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "k}pwCj|l\\\\blcAr@lkzAh@zh}@\\`}~@^d}z@~nk@yeDdqo@ypDbqo@}pDdqo@_qDdqo@}pDdqo@_qDbqo@}pDdqo@}pD~po@_qD~po@}pDdqo@}pDdqo@_qDbqo@}pDdqo@_qDdqo@}pDbqo@}pDdqo@_qDdqo@}pDbqo@}pDdqo@_qDdqo@}pDdqo@_qDbqo@}pDdqo@}pD~po@_qD~po@}pDdqo@}pDdqo@_qDbqo@}pDdqo@_qDdqo@}pDbqo@}pDdqo@_qDv`n@mkDfvWcgVxa^uf\\f}j@|oG~ls@ddIbgx@rbJ?bhh@?ryf@Bxyf@Dryf@?ryf@?ryf@?ryf@?xyf@Bxyf@Dlyf@?xyf@?ryf@?ryf@?ryf@Btyf@Dvyf@?ryf@?bad@_i@ryUwmC|cGgs\\h}A`|@jxEpuGv`GdlH`cC~iKem@|lIjh@bbC`qXn~Exra@blDtkc@_}@xvc@elAbpK{{BbjLwgCtf\\yJn{N~]xfQ`kArnTllDd|EhbUpfOpsX~uNeCbhIs_MxpJioYzr^cxa@~ie@aiP`oPkfAngHflKxjQp}JxmNr{OvmOrdOdnFtbRl|DppUfsA`fYf~DncTrhLj_OzvNbpF~uJhbCtoCcmKjja@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gyysBuuxXxoJ`_}@ffGzgk@f{Grxn@fo@vkFbJltG}IjmEkzCxdLusJ|}Ni|DvsIgdH|sA{bKseEc}IauFkqGi}AcoEqiDgiDkxEmnF_HofKzrDw}Oz}C{y]wEyfIeCkuBs@eyJriM{}K`|Y}tFpwWmsAbhJsqCzjZgfGzxd@gsD`hLir[pnWiiFh_KozCxvw@_vCtyQexEvmNicHvfLavNvlFkxK`fAebEp}Coz]lq}@wnIt{NixHjlG{lMhIouPgu@evNhtAkwF|sAetQjp[ayh@t}~@gyh@t}~@gyh@v}~@cyh@~}~@gyh@v}~@gyh@t}~@cyh@t}~@gyh@v}~@gyh@t}~@cyh@z}~@gyh@z}~@gyh@t}~@ayh@v}~@iyh@t}~@gyh@t}~@ayh@z}~@}ib@l`u@eid@`uz@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gyysBuuxXcdGiri@emGw`k@sjK{m_A}jLkxdAuqMgbkA{wGufPckp@wlx@shUk|Xqhk@eor@mea@owf@kmj@yoq@yvj@mot@e{a@}si@mpf@oabAesz@qcdB}rz@qcdB_sz@ecdBesz@qcdB_sz@qcdB}rz@gcdBesz@qcdB_sz@qcdB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{dowDacby@wam@xzJ}if@hcIgm_@ljGqbx@zuMeoo@nnK{jo@pmK}{j@`iJ{dk@hkJkmE~{CczS|ca@meR`n^gzTtw_@auV|nb@ky\\buDc_l@hfQwbX|eRwqEreFefOzve@g|J`kUg|EvbEaiQdiCykc@t}N}``@heQ{jUxtEmc[j[yhSiqBcuG{|FkhXm{d@wl]ipP_lJmuTyqGaxQm_IueNyaOmpLmcPciI}oQyw@{k\\giCgpSg{EghVq`OouQbvEweShnGm~a@ymAmeMlcAcqKrzEwbOn_F}lL`Gofb@wvEa|YkdDg_b@{eGsxHj{AciF`bE}uFnjQusCbFqcDkoCe`P{bZs`XkqMifDoeKaaH_nQiwHfUclIbcC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_}~uBatjqCqem@jq|Asem@~p|Aqem@hq|Asem@hq|Aqem@hq|Asem@jq|Aqem@hq|Asem@hq|Aqem@hq|Asem@jq|Aqem@~p|Asem@hq|Aqem@hq|Asem@~p|Aqem@hq|Asem@hq|Ag|^`s_Azc^bvdAllW|ru@de_@jbgA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["eageCs}mwCni`B\\li`Bh@ni`Bf@ri`B^bJtR~IjRbJjRdJtRUrdo@Yzdo@Wzdo@Updo@dkW?bkW?dkW?bkW?"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qre`EqeoxCjnDroFjtJ`uIdkI`wEx{OlbQbbQbbNxnYel@~|YmmBhiYicI~g\\auGtcRnmAdpV|nF~rR|zGjlg@to\\ptH~oCpqLss@h}n@g~PjbNqk@jqm@gwIf{d@}xHxw\\qzIfeGgt@nzj@?nzj@?nzj@?nzj@?nzj@?nzj@?tzj@?nzj@?nzj@?rzj@?nzj@?nzj@?nzj@?nzj@?nzj@?nzj@?nzj@?nzj@?nzj@?nzj@?nzj@?nzj@?tzj@?nzj@?nzj@?rzj@?nzj@?nzj@?nzj@?nzj@?nzj@?nzj@?"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}vsaAozojCgjTkxE_z^mjGstMi_@wdN~|B}kJzjMuh@dyKuyDbwDwjGr`J_oEj_JunK~vHeoP`xEwr}@wxCwjG~fBshAvpMaoCxkBe_KaRqtb@hzFko\\hxGchOovCygUpcKkqHdfV`|Ad|T|lCdpVcf@vdM{cC~vHsdGtxEcsH`pBynMkfBirYc{Kw{TmbOk|Rmw_@crI_vGqwJq~CooLc[kfMbeAk~KxuBcgPltHkhS|yGaqL`FwyHsfC{xJ_xGyhLekP_tAkdCicFm|IueD{oHk`MixVivE{qDkaGz_AorEtyD}eHnqHuhJ~|@ojRbyAkhK||Ck`HtpBaxE_xE_lHkaImvDmpKm}CunR}uEesFm|KigAwgKtSgdHo~E{qRimHe}G{qF_eIiuKkxKivKczMetDohM_r@aij@d}EmbQguMs~MawQh`@i_ZugB_|h@ggEmo[rEmjSzaGulm@y|@owBwq@qa@kmJcnA{{[^ybvAfA}bvAfA}bvAfA}bvAhA}bvAfAwbvAfAybvApA}bvAfA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "eageCs}mwCHyriANmriANwriAHyriAHmriAHwriAJyriALmriANwriAHyriAHmriAJwriAHyriANmriALwriAHyriA?svUem@aaIskc@ubRguA_dGhcAynK`pGsgCtiK`zBziPpfE?ypc@Iqa_AIqa_AI}a_AIqa_AKsa_AI{a_AIsa_AIqa_AIqa_AIsa_AK{a_AIsa_AIqa_AI}a_AIqa_AOqa_A"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{{gWgns~Ftka@h`Wtfh@xx[`}jAdat@t}f@fkg@te]jo]llDxxAbt`@gCphqAiIthqAiIvhqAkIphqA_IphqA_IphqAiIphqAkIzhqAiIrsZqBdra@qwY|x`@mdYxuk@era@j~VipQx~FeaBp`Oj]"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "shcbAaj~dG~rFrfBpcJ~lGndJtkIdpJhbHxi_@ffSjdCjRziEaoA|xMo|IdzVqlJp|TykElrIq|CddKoyLb`Xe~RzzOyqId`Hw_UdmTsdFzm^kpOddX_yPxtRkfPfqFqfRrSwuFlmc@ihg@fvZgt]lmCcsFddQ}iv@l{Sks~@vwOqar@|jTqb`At`Tmd_AncS_c{@rh[iosA|xUcbcAj~P}tt@ptD{mJ?k}~@?mz_A?ynaA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "`i_q@qauzD~cDry`@tmFd|o@|eGr|t@|nGduv@jlGldv@x~F|js@dgFdpn@z~BdnMjnSkbFppThgBzsOrlH|oSbzMhcGjxEz_ObcNxfJ~sKd~QdyX|xIpiOfyHfB|{l@elZn}_@gmKbx\\y`DlaPvF|db@r`@`yh@tf@vnO`|@`z\\kmFbgVjh@~~XtnQlpX`cDtma@biH|xn@`|KpbXfdHpjOabDj}IsrCdwM_zCzeUe|HfbL{oJzsDumE|}Zs`e@noLyvNnyY_bWvwPmwPjdC{wW`wEcx\\tdD{jOmoAuiJohEywBskLnOy{H|~@}pFwcBc`DkaIqXoyXmuEmgJit@o{Gxl\\_@ve[]pfa@_@~gf@i@|f_@g@dga@i@lnf@i@`oCbFpzG||BdaBdgIwuFbzLkaGxXapMpkBwlFtmEigAtkGxuBveM`vIvmRtjHr_XbkD|bI_S|rPkcDx_Rs`Kp`MoaQp_CqqQjhKyzYdvOu_JjlGyoKzcJol@xfJwnBjrKejQlvF{eVpeFy}GbnCkrJfpFm`F|wIogHpoVw}Kp{_@sgOhhh@eXnsRyvAv~TwwFfwL}dEp{FoqU~`H}kY~jKkm^bgc@qza@hcGe`DzgFvyApmKpiCbsHviHlxBvl^jvHxnMniDf_CrsBxuCp{FrfC~}KdbAvlQqWh`YcvCpp_@aoB~qP_fDfon@kpAnwL_yEllR_{Er~LmyMjbm@nx@p{S}mIfcIkcDjbHqzHxnKkqLprDg_\\vlFwoNox@}hPyjDwwCz}D?ljGz}D`}JriBdgTlsFv{e@rhCpwLtfB~gN|}A~tJzuO|f\\bx@|cI{}D|hPo}GjjG{cIkjGyoKuqBgnWz}D_jJn}G_dGj|XoXz{HgvLtdCcpKhdFelAzwM{l@taF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "|ltjBepumC_n_@b{e@{yc@`bk@obh@xtl@sf_@vja@gqQ|{OyoW`d]k_KluTc`EhmG_i`AnqTc_{@fxJgel@Hut}@Twt}@Rut}@Rut}@Tut}@Rut}@Rut}@T_u}@Hcm]R?w`l@?}`r@?qkt@?c`y@?m`y@?c`y@?yng@cPmrI_|@oxKadEk^_z]dvOo{IyXo|SmmCe`Qg|EgwVibHu}Li_@knl@bjFgkXsT_jYcdAu~Wq`AmlPvoAsnHyaBwqLmmDqiNkzAqrEqkBabE|_@slJdbBcqXz_Bepb@rfCwqXrgC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "zubEev|mEeh`@hSavsAmwCkkiAvPmgd@_fCyqVckQkdPsmGw}VcbEgpRyrHwzNixTiwGi|BcqY}aV}ca@czLcrJimIivIg`LesDqeH{sDycNafBm{JeuAcdA_pDi_@ycTr}Be}EmaDacMwaGwdLogHijGakGsrG{tCw{MaeAopI_JsfPdCedf@hsAuw_@~wHktc@l`E}`KcmConTbvFwd@jyBquCzgEqfSx_GynQl`E}sCxvBqdOleYece@~~KynG`rMw{d@z|F}wIvo@qxd@ehGctGdYy~F~vGicGbqW_rNp|RgmD_qAosDen@ixBznI_t_Alm]"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "zubEev|mE?a{MjkF{aMjvGisNxfVish@nfVgsh@xfVish@zfVgsh@xfVish@xfVgsh@xfV_sh@xfVgsh@xfVish@xfV}rh@nfVish@xfVgsh@xfVish@nfVgsh@xfVish@xfVgsh@hbJ}zRtxCs~ArdTmmBbfLmdAjsJ`e@hyRj`JjjI~fB~dFdBlyAouA|_@wkHduCm~FnuBs}A`|MwbErnFkwF~sK}qPzqTq~\\zqTg~\\xqTq~\\zqTq~\\xqTq~\\zqTq~\\nqTg~\\zqTq~\\foIarMf}AsdE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["iifLuscdAOxil@Oluz@Odkw@Mdce@Iv{~@q{GhmT{tD`nEumEhh@ojCzXoh@z}C"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "iifLuscdA|el@aGbfe@aFzjh@mFvbj@wFznc@yEvsVeCoCr~f@oDfat@oDdat@yDfat@}AftY{Apk\\jf@foHd~DtmE|j@rxFmbDjaHcmAt_JggDh~AqqHjnD}_@b}I|_@jnD`nDzzF`{AfzG"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "|hrkBojdyCmd@vjGdrEx|z@~lGryU~vc@pbr@ovCxzIesFvfKaeAtkIryG|mUxpIjkU~}M|vWftMljSrzFzsE|f]x~^~{ChlIp`AngHgk@nvBk~K|~Bej]drR{wf@`n^i{BpeHmo@zgEt|@viVxfJvxbAfnHhdx@jeObsvApaLxa}Av`Gb`y@|iAdnq@pkf@s@|tnA{BptnA{BrtnA{BptnA{BptnA{BrtnA{BptnA{BptnAqB`wa@s@tmFht@?r}[?dn`A?lbv@?|ok@jjn@q@p~v@}@p~v@}@f~v@}@p~v@iAp~v@gAd~v@}@p~v@}@p~v@}@tfi@s@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "zefvC}l}xBz_qAJd{uA?zzuA?xzuA?f{uA?xzuA?zzuA?d{uA?xoZ?sJ``SjsI~hg@dyLruXz~O|bJ`iIxwMptB`nQxtGhcGzuLmeArnI`cFzfFblOobAdoYqnJlqc@{uAfqm@x`Ehpw@czA|sg@exJhvWcvEjgYst@nxZs|CvbO_xGd~_@{`NphE}kJ~zBk_KjkHktHr_@yjFwjFozJs`@ojOrgDe~FrbHfM`}KggEv`Gw}KvcB}xHdsFk_I~dQrpFj_WhkJtiJlwPdtEn|G`aEt{Mf`BpoIfk@bfJheE~pClkE{`A|pEjnChjK~qOldZ`vG`vF"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["zjavC}l}xB~yC?"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{bbbAa{nD~~Sx_Db_YviIngGvuEte~@zuCdhD_gBfq@gkAjkTkm_@v`[upi@xxRo`]tsEaoAtph@}Lvtb@qKjlS}eEjxRui@|}M}oFpz[ovZ``P{rEznu@sUljh@mPvhw@koBz_n@?~lz@?jtdAUhsgA?j]zhQnpUa~HpmS}u@rtE{jAx{Hp}CjaNcbCbrDy}Fti]{gSluXkxE|pGzr_@xsEihA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ur|bByffdG_yY{oc@eaGefHsaFqhDmcNorG}|CswJ_}NkdC_~F|JoyEzqFarQduD{oVw{@uzHu{@q~Pi|BstE{wKaiDg`BikJzzHqwEm[y_RivTsuDgqG}{Dq`M|@w~InjB}tKviDajJttHw}I`_JasJtdCuyPaa@qcKjzCqzH}sAajGeuDsnHbKwdNkmEitLyaBoye@n}@gmd@uiD{bf@`Li_f@fL}jf@hXkvGpjBeqGd{O}d`@rmB{cX|rCmrq@r|Cg~t@vgC_xm@m~Bitf@mhB{|_@pQe|GbmIy|H~~X_yRnoWeuQri@sx_@ifHy_Tk~KsbV{`IebMq{f@qiOiyXoqI}~[cgW}gWciSmd_@a|YmxPa{M}cb@ok\\guL{`[amYccu@{|Xobt@e|O{qa@avF{j\\osEkjp@yxFm_y@uxFe~x@_iGgx|@}gHs|cAijEgfn@obGyf{@wvE}aq@u~D_pk@odE}yl@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}d}rBe{f|HhoRosGhoRysGhoRwsGhoRosGhoRwsGhoRysGhoRosGboRwsGdoRysGhoRmsGhoRysGhoRysGhoRmsGhoRysGhoRysGhoRmsGx`RimGxiEk}Ln_QehG|vXezJ|vXczJzvXezJ|vXezJ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qkqiCsnyoIlbUsiMjjQy{JxeXqiOhxY{jPprXgrOlaRujKhyR|pExrT~cFxrTtcFxrT~cFxrT|cFzrTtcFxrT~cFxrT~cF|rTtcF~rTrcFxrT~cFxrT~cFxrTtcFzrT|cFxrT~cFxrTtcFxrT~cFf`YxrGp|EtwSjeJdr`@heJzq`@jeJdr`@heJdr`@jeJdr`@heJdr`@jeJdr`@heJfr`@jeJdr`@heJdr`@jeJdr`@heJdr`@jeJdr`@heJdr`@deJdr`@jeJdr`@vdHbpZ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qkqiCsnyoI|sNh~KnNh}Am{@lnNiSrfDyx@dxM}xAl~UmsBvx\\}hCxgb@{xCrjf@qcDxai@whDvmj@uhDtmj@qcDdbi@}xC|jf@{hClgb@msBvx\\}xAl~Uyx@dxMkShfDg_AllOiqIf{GkxKrvIqxK~vIkxK|vIkxKtvIkxK|vIkxK~vIkxKrvIkxK~vIkxK|vIkxKtvIoxK|vIkxK~vIkxKrvIqxK~vIkxK|vIkxKrvI{pG~dFmtHf~B{hXzVsoD?"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "uwnaFwfpaG|sAIbvEzv@jlR``UrkYh}\\psO|mTz`[nfc@d_E|_ZlbIfql@byHlfKlyNtjJbtTxtE`qL|}@~hXle@fgYktIdeXyfIttO_i@bmO|_@dpPd|Hn`W|vIveZrfE`}q@~gBxjj@pA`bFb[fr]xtQlxb@zzTjhG|cI`tIv}n@ffYtis@`i\\foy@trYzbt@z|Zvwv@`~[jyx@luSzih@luZ|hv@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "ipxfEiulyEbcCy~SfeHs`Kx}X_cSvpF{h^hjFcrKtwLadPd_De|S`rG_gaAi}[yys@}mW{sk@ixZgwq@w{Qqoa@mf_@}{y@mkS{we@syYs`r@inYsjq@"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["{enfEgijxEscH_aWyd@aiI"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ciacEar|mFwhVyw[{|SfzGvzBd~St~CzgRgr_@ttJy_Cu{Mmni@dwLyvj@ldMifi@jsLifj@~}L"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qbdrDsiitErjE_rh@|fDega@btFu_q@z|Fywr@psCih]}}@kjIuf]kzh@ohZgwd@qk`@orUyi_@e{TwuEa`I}`E{p`@yrHmet@woH}ts@_gBkeCk}X_hKo}_@urNimBkeBkjBuzBwmQsvd@oeJe{Uaa`@ds_@{d^lw]s|a@|ma@cdZ`f\\cug@`xj@esY|s[urKyeq@_sLufu@kwLcxu@eqO_}`Ak}Kmqr@yiRk~kAumHksd@mmA_xEqzUi~["
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "szqpDsd_{GxjErda@ghEnmnAe~Eh`wAe}EvrvAudDle`Aqu@f_Dunl@nn_Am}b@h~q@w{k@`t~@mzl@|_`Ayom@r}`Acx`@n|n@anj@~dy@mqf@h~s@}f^lyh@}iZ|st@mjTh|h@ub^~`|@{zWfyo@whTlyh@kx_@hj_Ae|GtkTc}IfuaA_hHlf~@srHlo`AwkE|qj@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "siyxCa{{vJqjOckDyhy@wyCg`TabEkoJlz@smBii@udIonLajCsgBcx\\wcD_b`@yuDazJeiE_fBojDyxMayi@i|H}eFviAqcUekAs_A_kJi}@ckKchIsbIweM{qBoqI}jEooe@k{G{nUu\\_zEhgAgyz@_lBktKyaBg_Aer`@woBqhDqyIsyA{u@_fVztBgpNeaAadHuiKcgDrU{_JpzG}_F|vJmt@bvDxsErap@}cAdhSo`CrnHw_B|~@{vEw{@k`JgJ{cPkcF_gIwdA{gz@jxDmjf@biGgaf@cmCibGb[iy@rt@R|eEbmBh{\\kcXxoX}|HnxNooKlmj@gkAv`R{yIh}ZatVfwXyeWrjYsnNbrIkkY|vJsqq@lj`@i`LiIi~F`cCaf`@vm_@iqVh`Vqce@lgd@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{wfuDgnjrJqts@w|q@{}l@amk@w_m@unk@mll@s{j@u{NieDgb^sTuph@lqJa~QroQctFxg|@gwDl`m@wgEfcq@qiA~nE{h_@buD{lMmnAwzZ|gB}mTyMmib@qhF_|N{KancAdfVa~d@`{K_df@vgLonK`zA_mN`Hygc@mw]wzFgpHo`Qm`QiqHchJ}qEh~@azBdsRyI|s\\kmDnwNe{H~hKggMtzC}kXc`Gckp@v`GikWknO_bPedMukAoeo@agRxuO{dJ`aGkfBjdDkdD~|@idDuqA_}@wgKwmEukGk`HaqL_{BkbFm~Ikh@awFumEauHauHk~IawFm|K~|@aoNkbFauHifBukGkdDwgKtoCwiI~zBwgKjh@ifBawFwoCauH_uH_}@wgKkdDauH_{BawFwmEawFsSk|K~zB"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["ssc`Fyv_aMiCehF~|EebZtyDejQmO{fFw{Lol]w}Ogdm@ooFqpT"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{wfuDgnjrJ|iT_liApjOw_y@flYgt|AloSawgAriB_cSkoPibtEjgLexmAjmFm}WqjCyvBa_HyqI_bHcjQuhFw|Wc}Be{WoOmsb@pQedWffAs{P_i@sna@kpB_rOemMwvw@yuHqce@_dNytx@iaJyai@g{DmqIirI{zIgnHkdDosMl|Km|Kzu@yjOinGc}WqrCqob@`[ynSzvAw`e@_vJ}jTgyHifIgqR}fEaqLiqCetDabDipDc_\\{|S}nLacRieG}pQr`@geSheJifPx{C_n`@}gB{i_@alG{_[w{E}uKm`Ek|Ms{ElZ__E~zOymGltHkkIxwByhE_nHyy@ibUcjXadu@gtOkaUawFy_EsZwiI`wFmtStqAqbWawF{bNav@{_NhmG{wM~aIq{F~_K{kLdkA_}O_nEkkSg{LulT{mR{gS{gRo`Q_a|@bmCs}b@r}Ak}Q}mHktJwqLo`Qc~Gy|NdDmkLsnHcqc@smHurGk|K_~DwpY_nBugi@cvOef`@iwPmk`@csNwnCevOvqK{l_@zuOmjRncNgva@nyc@elT_fCkuGsoSbyMaqq@n{AqaM`bAsqPuJgpm@_xDa~d@}fL}tf@{wLawFujOzLioL_TgxQiSw`KveMswInrGorGtqAsvC{{HexGmsHk_OwhHacRc~TefP_jLwdGynKkeJg}QgmOgbKgyHspDyrHc~IeiEqtBwrDh~AkaF`nDi~FheEawF?wdGkdDkiFgrDuiItqAmxOp_B{{HtiI{zUf|EmgVl}IkaHhzDskJ`uIqcKv}V{aGhzE_qNwiHwsHaqN{yVyl\\snOccOonJkqM~|@mvQ}_@k~IcrIauHukHsfRgmR}ca@qbLk}JqrEudQ}n@gaNiqCcjSgaFgqRikDszP{`@i_[ufBulk@}hBa`WeqA_ox@_e@as}@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "cuz`Gqx_pLzaG~zOtpAbvQj~CbsHp}JlhIlhIbsH|sBzsDiTbsG_~Fx}HtI~gM~zHd_Pf_O`cSnoWdmXj~KnnYraJfq`@h|ClgWhlGdhRp_Pba_@z_IbkEr|DxfVryExtQnkJfiPpaSheChpJt`JjzNxnYf_ObhUfuNloM|sOfkNpdH~yC|oKxOpoI{fFv_Isj@hhF`nDpvAz_NobAzvNidF~`WeyKruX{hE~jHgxIlrKw_Ioy@{mR_oEcjLwlCckEfnIsyE`wFgrE~oDy~KxzI`eBrtL`eBzyJypCrtLb~@dmg@rn@rp]vk@hs[tw@~jc@bcAtyj@wzAlrK{hCpyFs{Pd_GweN|pCom[|oGa_UxtDmfYvwEs|[`nCkrS`eBsTrd`@iPnnYqVpzb@ekOaIysSqK{nVqMez]muEszXmoAip^oaBgzSq_A_}UwfApaFtnQnyFllSriF~cRsqQxcL}`QzwKumZ`mRqqSvpMc_KjiXq{GjwQc~M`mRwoNbyOgvMr}NeyKjaRz`CphQ|~FxsS|uFf|RldGtaTv~B`jImo@rlWii@`jT}jAdee@c_Afg_@u`Az{_@gzArzl@e{Ahmm@vxBvb^vxChjf@x`Dpjh@ndCfea@fhDpgj@l}Blk_@mP~}N}rOl`S_sYjb_@mcOtmRgyNvaRyxUboZcgPpdUozOxsTwpNzlK{pR~dEszGdfJa~JdcXczKh~YczKh~YezKt~YczKh~YezKh~YczKr~YczKh~Y_zKh~Y_zKh~YczKh~YezKt~YczKh~YezKh~YczKr~YczKh~YezKh~YwiHpeUxlAbtShpEr|]~yE`l_@zwEx`_@~cKtnx@~xFt~c@frEh|[r_Fxw]jeHpjg@`vFhy`@j`Hhtf@b_Grab@lvE`p\\n_Fbw]|pD~jWtyk@_@ryk@Styk@Utyk@Sryk@Styk@Utyk@Snyk@Snyk@Utyk@Sryk@Styk@Utyk@Sryk@Styk@Utyk@]"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{tsrAqn`rAk}rAnsRyao@xfJyrM}wKqfa@ycXsn`Akd_@qhdBgngAyyr@iad@{llAc~hAqd~Aw{yAmrt@wer@st`B{gG{gfBiwG{amAesEap{AgfGuilAs{Eoiw@y_DmznAkbFqiNabE}r}@ctb@ukGwxAmnIprEkft@j}q@y{Jj{NysZrcHapN}aLahxAng|@m|IjeNs|IpsEcbOxWsw|@|a@w|_B|gO_{oBrnT"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["uipnCgn`hAfuUsvdBdqTys_B`uTie`B~yJc|Ubni@mqr@tju@q_aAjXa|ApF}}Am`_@qm~@yvh@otqA"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "yk_zAini@geIaeAefBsfJlFmt[tuCaxv@aiD{tk@e]cnAydZun^op[c}a@uwAyos@m~Acuw@sn@ytk@}cA_~_Amz@oos@cdA}x{@_dLaz@kfBguBuMy~Dr`Fcvk@jxE{_i@iwWwdBe~]m|c@eiEq{S}kDkdD}mI{rE}cOybCqnJmx@epHkxF_qPcuDiu]spFcf_@_xSmwj@m{Jsgi@qw@ec_@shAmqE_eEi`x@bE}jx@xDaoo@dD}i{@nEu}s@lD}jx@dE_or@bD_ca@pB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "o_zbAzkLq_Ival@`kHzpAl`EjnEzLrvHin@`xEbfF~oCjoHtmFptClmInzDtfIdcDjwDzBpdCocKpiIqf@ruL`aAtsXiiBdoJcs@dwN`oAfcd@w}C~kz@|tAvuHfeAhqApQ`xy@jSvu_AvOrcu@zMvjn@kaApAuGjeNraC|t@hvo@|lLxnYbn@lnO_cF~kIm`GziCw~Gz}Dm[prFheFryFwRv`G_mGlnGeaAz{GfhCjkT}_@|z`@_jEr}TsDd`Ix~DpcPazAxfWotJxgIs_A"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "slfv@jfcpAwaColJ|x@c|IdrA}mH}hCygIesE}rH_nGwvDivUuwFerFg}Wa}LcuMerTu}LwdNwkEgqFmwD{pE}rBseF{tAkrE}fEaaOipEmsManCy_FgjMydEgj\\|rIemY{fHk{i@kvL}gAcFqgf@aGcom@sEgve@jtBahLnfIuyCt`OsvKhbJiiLdjWmnOjj[ieRlrXuvSf{LkhLrzC}o@joDz]r_L|pEvaMprDdhDmQ~sA}|BrkCctTfuNy~@dvTW~gSqoIf{Mg_IjiDhOjmXfnW|gXnpHjbF`zCzsD~|@|sA_|C}t@muErbAaoHrVg`HgaHa~JyeVq|R}yA}uE|_Aa_N"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["emjmHsxib@nnE}qEr~AafNjkAckDfnC{}Dhx@scIix@wfKa~Do}G{tAa}Jv[a}J|gBszE`zCsaL"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["qja~CuehuIqa@m`Fp`Co}Hb~R}^h{QrrBb_SfLdzIxl@`|GyrF`yByzKuMetDknCcxB"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "lmoEe~eyDwFhyFuQvfJhgApdIhoFjwFxyKd}FpvMlfM|`LfcJbhHrmHhhN`uTvnCpxJsU|zDwyA~qBspRjxEwcBtdC~`Ivci@xCnkE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "lmoEe~eyDdaBvlE~kHri@|`NwkF`b^eeWlvDgkN|aKu`IbkSezHloX_|Aft]x`C|xUolAr}Mg{GvkR}iApyV~eC~gMbcDdvCjaEdw@~zEar@lhHh_A~jJtnC~iKtStwF"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "zubEev|mE?liT?`va@?~ua@?`va@?`va@?~ua@?`va@?`va@?~ua@?`va@?`va@?~ua@?`va@?`va@?`va@?~ua@?jva@?~nSaRvbCoXlyAvmAzbL|pGxoLrqBxmM{k@zkNt\\~|@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["`bahAiccrEbeAxhFjbFplAneH{qFdDkaGwiIa{BysDpkBstAjlE??????????????????????????????????"]
    },
    { "kind": "International boundary (verify)", "lines": ["earjHsf~sOnx@yiQ{{AwrJs`EawF_}@ozJ_|Ag|PcsBokQfVy{I"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["kjewFwqvtGjfBd_DjaG?nm@e}EifBulFwmEa}@_|AvnDeD~xD????????????????????????"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["apwyF}}rqGvf@`mEneDxNp}Ci~@jfAkmEkfAueCoeDs^suCln@un@teD????????????????????????"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["aimkGw{|jAbjHbsGz{FawD{l@eoJeaIyvD}dFxcA~l@bfK????????????????????????"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["atkyFirvmL~|@zhCvmEgtBhgHopIwL_yDsvCrS_~Fx_EuoCl`H????????????????????????"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "odqeEtr{iU{dCo{v@{dCo{v@{dCi{v@{dCo{v@{dCm{v@{dCk{v@{dCo{v@{dCm{v@kaAiiUxk\\djK~_JvjHd|[_s{A~{[cs{A~{[cs{Ad|[}r{Ad|[_s{A~{[cs{A~{[cs{Ad|[}r{AaCa`dAeC_`dA{B_`dAeC_`dAaC_`dAqAoik@m@ouWgC_`dA_C_`dA_~TaC}}T_C}}TgC_~T_ChFy|i@`F}|i@bF}|i@bF}|i@`F}|i@bF}|i@bF_}i@fF}|i@bJ}o@pWmy@duOskPrfYmyPzhQw_TdkIyeWpr]chh@tyq@_jy@j{`@qom@~|Omua@jqMwhVbfKc|JboYg_O`e|@_e]~a[?nrYopJxna@}aVnhS_eStbEqgPxeKi{QfiQsnSjhKorVpgEevYbmOy{c@jrYqan@vqLug_@jQwmPapGihNqsP{bLojJs{KsaD_tKicGqcDaeJzjAacX{pG{`f@ynRmdTihVugByaZyiFeuPmkJciGwe@onM|}GmtSvwDes`@tqA_rm@c[snZejCckGfFojClxC_J``Aw{EgVumLhuEivJ|dTa_Nn|`@otr@RcAvsJkjCfxOe_QdyXub`@hgUwvQhuQojCtq\\i|Onmg@om\\|xTybLvcBteBhkJiiAzrRmzFrrOirMjrLgjT|lW{qTngb@syTlyY_mYxjQo`^bbPmqP~xNsbClpLxHvgJnvCnuIc_AxbIevGjlK_|ArgPblBn{CmFHCt{BapAtt\\wpZl~VidM`he@yfJbJw@t{U}pKtjHcaQxmB{vZb~F{aTtnKklMfpF_eQ~qAs}TzfGm`Tv{LicShcHopd@zjCs}u@phJqyh@rfQqu[xuB_sKbGelBexAss@_dDidAg}DmbJa{BenY"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "u{wwArt}qPe_DcbDepJmhC}{JqhDgvLjfBqcJ~|@keO__EadK`QynFsxA_zCe{GygHutCs|^thXihFOy}G{iBuba@ioS{pg@skWawk@k|Yk|YwdOs@kbz@i@ebf@c@wsp@m@c~t@_@ykb@eHurMooPlnA{iR{{@}pPenEawF?snHdqIsoDhmSakGhkJcsI|@czKz~CqaNd|HolNfqSowNre^mdTjqYkqYz|T_bP|pQ_dF~gMqxBdkBbJgyh@hI{pf@{ae@mG}y`@mFcfe@aG|@mufApAistAfAeywAbAaxdAb@{_h@q_PnDemLasD{sDqfOrvJu`Tx{CawGixAu{FidFc~HgvSagK}vi@yv]ej]_jK_`Ey`Kqa@ejPz|@y~MbpJgcHaRa{g@ldj@pLxuA_fi@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "jib{ChdjlI}~Zi`@aoh@yyYeiRqeFm}IlnBase@}_GsgaAipRekj@qfE_nStaFihMbE{cK{_IgsBw{CmzMbeXcqL`qL_uHbmPawFlvQhfBj`HvoC`uHjbFlvQtgKbiTtoCl~IvoCbkR~zBx}TuqAvaQuqA`oNawF`uHmxOjdDweM?mtSjfBasJ`sJk`H~zBm~ItSwgKih@k`HkfBk~I~|@awFjdDaqLih@mvQrqAasJ`wFcqL`{BaqL?aqL~xDmzMtSaqLkdDcqL_}@auH~xD_yDl~IcoNtkGw_Sjh@m~Ij`Hk`H`uH?j~IkdDlxOtSlzMuSx{VifBj~ImbF`yD_uHlzMmxOtkGkfBviIjdDlzMtmEhdDj`H`yDviIviIuS`qL`yDveMtS`qLhh@xaQkdDvaQ_yDx}Ta{BlvQ`{BxaQkfBtgK_}@xcOkh@vaQuiIveMayDboN~|@tkGvmEj~Ikh@bsJkdDjzMwgK`yD_wFkh@awFifBm~IayDasJjfBuiIkh@m`HsqAuiIuqAauH~|@wiItSauHhh@uiI~|@mzMawFwgKumEwiI`{BkbFkh@asJkdDweMumEonYtSaoN~xDkeCphE{tCtr@kcEeaBohEviBwmEhh@{sDwiBqcJbsCifBhgHkfBhfBwgKjfBweMtqAk~Iih@auHtoCayDtmEuiItmEawFvmEk~IrqAceMhhC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "xoufCvok}JvlDa}CzsDp@xpJqnOlnPs_`@|y`@m|]neq@my[rad@aaZv}VkhX||OyfVx{HaeTx_GkiJ~cE_n@dxKuyRjmRmee@llR{cWbkRsbIb_S_vd@drSoi`A|yHwnn@w\\gt\\bnOopi@|y`@gmv@|mViy`@paLoeK|cTmgc@jyj@inyAl~Ig|f@j_Ig|Q|uKyeJj{BiaJs}Co|I~pC_vUfaMaoa@d`Po~Ydod@ava@h~MsaJzkLeuCpxJrt@lrKhqIfkLtmRtyDlvDzsD`MlgJ|}CfaW`dOdeJbbCpgGxZ~`HxfIzuOpeZhcGprDjvGlj@~dDtlBldAhvB`wGhfDbnMteCfqQpLxsU{jBbiF~St{Bd_EfgDdkBnqIve@`wFfbDp|Cr~GftD|hBlkEqjAdiEtrEzfEdrNjaHzpHv|JnoBvsI|tGjkHbzLdoKtoC|aVweFy~FugtA`mGcpdAdfU_fqA`wFoqu@ouEu|Yj]{}RdrG__Lxw@enPcaDe}Th|BgcQb{KsiMueBs_LggRsuJ}`MamLgzGgdN{tAs{QjoBcsUlaFy`Q`sIonLuHavMmgJs}NonLosFevNnTyfJeiE_xEeiLidH}~GopJ{tCm`FmxNkpAg|YotDkaMsxGkf@ubG{}FmkFguMyfHu`IibJ}kDc~Eu{GczAikKwhVawLmwj@sbN}dz@e}G{|rAgcB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "xoufCvok}JeaBbxAsjJrnNgpTzwLgzH~vBiJnw@jS|wqAfVdvnA~oC~bGs@fmJggCjlG|ItgGvdChzJxqGfsI|gx@bl]doWzaNd{T~dJznd@tbGzhEnkB__LfoHcia@~}L}oRthE{eUx}Gm{Zv~NsmG`nQywA|lJejDlnOcuEze\\_j@pvKa\\blrAqU~rEdaB~t_@qaAlqOirNdlPqkZdwe@ctGtxFcwDpzMkRj{GlmDnjDfzUvvElsSb{FzyJ|iG`vGfuZpdHdxXncAreMjjIdrFzkMbhB~~KflEfqRpgd@dhGdhGpgRrgC~~VtxSljH~lE"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "awpeHs_naDmuEieCedQijg@b~AgmI|UuaTwR}}i@_~J}dTpiBs`LojDutIkwEmvPtl@cpAja@_gAf_BcnZtnEesSb~HexLxdEweMtkA}sMf~CucGdqFis@dvBqvLqBeyXl~Cw}IraI~|BbiBssAomB}dHh~A{|EtmFquBtpBmbC{tJodL~c@a|LdzCor`@heWg~PluGoeJjpBqxH_xBslKeoCw|I~bA{iEj`OaqLb~SaeBrnGpA`gMlyCvdNrzEpzHtmDh}FqiAtsEuzCvdA{}F|lLi_Y|hHkuHf|EybM`KivIfzBiqDbvCs~@|}Jdn@lfJl_EveFeXloG}mHn|Hi_@lkEsSh|Ce`Dl|IqyVnpI_{]taHqzFrmJmwCdhRlo@jyOf`AtrU}jg@heC|qClsCreEbmBlre@j{@|yFe`PxwOmcApyG|fEzfG`oB`uH{v@huJigDdoKcvBphE}LlaDdvBtxF_r@hlIueCtwEnmMfyHz`Bz~DaNxwB_pWfVuuBjzAkQtxFtyD~xQ|oFh{PvuEb`EvaKkRjlM_qArzTcfKdpHvuEvdNdvCp|LrdRhbGnsThsOvy@hjJr`KviJfqSrtLxxLtjHwnB|zGmYx_E|iAzsCvOz`AblD|t@jm^zzAf{GxoEnfI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "me{aFwdq|KvgE{j@lyMsjLd_Q}bWviCumTc_Mwd[rs@opHipCqsCqdIk{AqqH{`Pm~G}d^g_GgtPesEehE}z@{pIr}@{nJqnAicGwgEa{AovAqhBceA_zDyc@udDpv@goH|lJmnPlcT{lXtvHapOgt@esFanE}vHwgJezJefO}}A}dTn}DcaPmaCw}KgaMc_GgbYe`Bqbe@by@ikVhtEctGjuBktJfVqtMurFqmLs}NagKkwR_U_qVzyIcoF}}AygBouCqoGwpMouPalSiwUcuRiyZy~Q{ePsmVorEk|Z|oFgz`@btTexf@fuYg_Nxu^~vHjnPxYnfBabG}ZurL{~C_dRwFcpK`oCg|Dn}GpJvkLxtEnsd@b`G`r_@p}Cha_@jzCvd[|gCv}TqrFre`@yoJ~{Ts_Lb`FuhLroAuhLi_A_jL{aMiiZceYgih@_bOebg@g_Heiy@u`[_nR{oQg`ZapZws|@{nIqp`@yy@}eR`_DsaWfv@anDbi@cxChhAskKtkGuqAl`HjfBbnF|jL`xDvcCviCy`Dln@axQ_`Iw{e@umEceXuqAcmPwkGkbFukGm~IuSamPtoCmvQtqAcoNwjAqkYdiFw{Lj{LsoRtqGkwGr_AybB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["cs}bFgs_uKqmCwsz@~bFkbn@vmRivW~~CwgWomHeyVgu@ewMx`EyuDdqAo{Ju\\waQrjDwiIhkDce@"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "k}kxEuf|tJa}@wcOjbFumEzfHerGpdPyrVp~C}gNtoAqhRkjAutVqeBq}QdYo}GboKctStoPgbWjwFkwF||JuqBtqBidF}xJekN}|Bk{MzfAgvLbi@ecNuiCwcN_cBawEshNqlYwrJ{zVcdFk|Me{VckDaqLszEq|FgzHmxHfuBmoFbaCwcIvdC_kDwdCkkAopHBm~V_uIy`i@{tIuab@guGwk_@em@owMrn@i~LapAokE}hG{v@oxGw~FmaFq~PeaN{|`@kkU_{\\g~OuuIkxWsdF}ee@i_Me|h@ekNqmQcvDafMesE__KqlYmtG_~Ygv@ywh@mZ_bp@{{UujIklRsnEw_IucGscGw{Jur@ccCl|JcoYhfQkqg@hbHqfn@nqCsvVsVgzH"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "arceCc``tPctLftAgweAxvDgpUziC_e^~pBoqHfgDcaPpsEcuMdhF{fE~cE_oZf~Bwu`@nm@y{NqAe}_@hwGqid@tmGpq@xoJq`H`xEhDf}CdmGjeO_xApxKrd@zpHlcPRvgQis@fqEzsBrnTxeXvkMd_FlcNiVfgSmbBlgIvmCfoHv}Ih|CzuMiiAn{KkfGngGi_T~wFkmJrzEgvA|dFdbBfsD|dLfWn|I_Kpe@dy@wt@d_CejDrrC{qs@~~Jgog@rfPkpNt^e~RggE}w]wuFseRwkSocGguAkmEghB_h@{~Chy@{bY_bBixGa`HkwFugFyfJ{|AmhJ{a@m~Gf|EqkMi|By~DqwKgiCitK}fEcbE{_CowAatHmTaiKyhAyaCygC}hB}wO{_Bwmd@ovN{sOsqDc~AqWgqQfM}tAmnCj`H{bY{BsjJovBifEoxE}_Ae~F|iBwzLhpQyuQx}_@wlJhg]dv@r{v@rrBxlv@gz@jfOucDzeSjWrwp@fzArd{@ur@d{UfFvgJjv@vsUkiDx{c@syEvpX_oFnrUoxEvzYfA`mEomAdwBm_EhqA}vFv[a_c@qqDoqu@z|Ck{RspCi{k@taUiiGdrFsJfcIfxDhoEznI`pAjuJqsBtbLjbGxfCteOclCd~Q{cEnvNcjLlaSwxQhgNevSlf@skL|zEooE~kH}x@f{Ehm@tcErfFxlDtfFouChcIkoEb{EldAta@lxDy}AlsG~r@hkL{hDv{KiNtwFu|@vtFa~J|LmdNzxJk_Pz{RaoIrpRhm@hlHxqJpuCziC{a@|cAuxEfvEqzHn`FcdA~cEnm@bfJxdKvsIdrGloNphRlwPvnOtmLrfCvaKtdEthLvnAjeHghCpxDe~FhfCerSt{P{oTjdWolPxhFgxHxcGcxP~\\cia@xtEwbDhvP_{CxfEavEfjGwmP~cE{m@paFrgC|qD`wFjpB`fMnl@trL_gA~tLem@zfSqBv}Udik@~gO`qNjsJSprEspFnuPbd@dsFbkf@hmSvnHj{AtcFhj@`fN{zIxoK_~Kf|CkpNovBgcKx`D{yHvrKmrJliG_zRd`Coa[b~HmzNzqG}}@jvGpj@rwUboAnbLdvA`la@dbNpt\\|wInbM}qDxvD{~BlmCywBzbJ}aKt_J_mGpa[reFvkF}~B||CsfOlwBanPzsCcaE`p[bcNhzRaeB`sQwkEpm]qsCpeBuTtsFbf@tsVe|Hxcm@siNngPyc@tdQnZ"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qsrgAmsqMe~RsqC}|c@lsHmpEwOo~F_eS_dEyeXeNswHicBwlEc~F{eHw{Di~Mr~@}wGbd@wmDhwo@i_t@tsWk_VtsKieEtbHc{JfqD_qP`rKq~NvxPgmK"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gkfToyqpB~`a@}hAjki@|sMjw^b~Ibps@vx[b~m@fwXjmmA`fZvkx@{Bd`c@~|Av_Uv~Gfkz@bjTh_r@hgBrl}@wuFpez@liF|}v@jkUd~j@dqH|_t@qrD`ck@p_h@tzj@lqr@rtKtl`@pvMt}XlxOjoQ~aHx_EnhSdnL`_~@`x]jqZ|}NlqVp|Sbx[~d^vqL|lJjxRzsCxfc@g_ArmmB}_Bba_@~eDrts@dqGx~y@hr]ry_@`~Uj_Ij_VrzG`e]pcJxmMzjOrxGhhMjzOlfKn{Wf~\\vl^hwn@v|d@|jZ`}Xx_Fh}L~SzlMcvDj|M{XzlKhrAzhEybAn`CwmCr{Dw~IcFgfQzv@axQniFobNkuGqmJaxFq}D|j@yrH~wFqvLvuGj\\pfGdpIblPfeGheQdlB|~OfpGfjLrqCniF?fmJe`DllEi{Ct}L|t@nrFriAfhCdjPbz@ftMjr@rvLxvA`lEd`D|zEjaTtlH~hMniErkKwp@nsFmpKpiNcrJvdN_wHjlGe}ExuCmcBdaBqMxrHllEvzA"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "hgbvDwfzoD}eEqnIinHonL_`VqtC}pRq}BmsHwiIclEypIgcIctG_lW}xIyzVwkF}wHoWc_IjzBiuI|yEqlMbwEigA~bGmaG|}N}fO|lV{bMvjSqqSb`RejBtyFa|LvlQy~Fx|FqpHhqDadBrfDxlAxgGhfChxTztOlvm@fkNf}[rfQjiWd~ElhXv`EhoQ|zSrtM`mRpuL`oPtiKd|Fv`FlbD`mEzdJ`nEprQthLboKndK`yEz~OrxGn|TtcDjnF~nFr_@joPiyFr{O}pF`wR_iKnmMw_H|sPagMtiIwiGpiPnb@hfEyxAhdFmwCvy@}|BjqAwmCf~CgyJ|hBkzAf|DohG|wI{|FlyMq_NvgJu{OpsCy`\\rrBavUkeAqpFuaHkvFmrJ{hEguMs_AiyF{fF_kd@weZczL_~Ms^{dH}sA{xJyc@}`Nxb@mgJqLmmAuxCiqPilKma_@yrFynM"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["xvmfC_ifrDyEcnAsaHmxv@`lFavm@f{Sigw@tkFgus@abEsbp@qk@u|f@ziBcv]|fFoeWddJ{tP"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "zefvC}l}xB|{DukHtoj@ez|@x{UqtOxnMyhGrus@arYngn@uxR`sb@mbOrhOwe@j|NugAryFugAbtGnn@vjRtiJbzMnpJzfSl{LfwYri@ro^keCptNgoG`dDuuIsyFwqXdlA_fOp~D{zUguBw~iAj|@kaH~fAih[uqA}mHmtEsmGs{Q}xHseE_xGaeBk{NcbDuyQe{IirNsjd@svWid`@qnp@{|FwdNo|GeqHk_KciGcxh@{iPgxa@gbLelOwmCoxYsuJwbPocMw_HoyLuhAq|EqrCayP}hCc|UvyCsaWjjIeyXtnPwc\\xrTwy\\v~I}uLf|CwxM|u@sjYiK}gPhnTc{Yhj@arL~nEyk]luEcqd@qWksVmrJuiXcO}gQ`]mrVwdBa}Xq~Cc`R_bIupMi`JeyK}z_@qvMonYinGwl]ecLkgh@ybOmw[awDg|F}{DsxGukVo`EoiR_iJs_s@{_EatIwpLavHk_VkuUieRg_[k_JemM_f|AymYooJweBivWqfRsmIo{JcEysFsoEozIezKobMy|FewOs~AamRgpGarK{`MawDuyEa_IhKmfMymCubGajH}~@y~ForGctEafN}zFc~F_bHgVicUwcQgdb@yqb@qqRgo`@{~Ban^oiFay\\atIwd[ovOmuSsxUcfLgvKivUcxBg{l@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "bjteA{_ktEiSsqj@~r@m_m@tf@knEr~AkjIoNiuJg~Bs_LkvH}kMcnNmwNtIyqWvcOwj`@p`MifQv~JyaBx}EwiU~|@irh@qfEqh]{lM{~QosFizRcZkvS||C}tNhvIutIbuFklSptCud]}{Ee~_@kmQswb@}gRwkSuaSy_DeeKs|D}gCuxEcnA{}QiTkb^niE}`Zz}R}na@wgLsxTsvUikd@i`Kusd@sAqyb@wsGel\\kePa~Uy|IygWqsCkqXchGw}V_{Pso`@s`Ywta@mpYkkb@e`PwtU"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["ko_bAvgyaOxmNqbQfrJe{HpvFis@pdCqoD`\\{aM`{Fupa@gp@ubTmiG}dRs}HqpIguNaiB"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "iltuIqsxjDaQtzDhmAvwO`dJdoYhhYbnf@jyDrcIx_S`iI``AlnAk\\b~UkNfgEvKt_VoeDfcq@dmBvlRdgSboX|}Ap{HxxApr\\zjAteD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "k`ltG}fekDxdSqpShvI}aYziJ_m{@si@mkDocAaRs|AjeCywB~RqrCi}AyFciGbcCitLe~D__YyaO_ie@ugBqdb@fpHc`_@vbJymOnpIepI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "uerpGm{jaCtcFiz^twE{lM~wGesF`yDmiS`zAy_`@``Ha~U`fNm|KgtBkaTqpU_g\\g{Dqu[pxIke[`{G{kNn}E}rA~xAzpEui@zvNrhCl|Kd|H|aIlqIlo@dfJm`FtvFw~HrgCk|KnzD}{EnmFm[v`A{jB"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["}cmyCegfvI`gF`nB|lIdd@xZmxD_fD_cGalGcd@ejCf`AqQ`lG????????"]
    },
    { "kind": "International boundary (verify)", "lines": ["zaybDs`_cEod@u|OvnDy`]mRwgWmPwtTk\\utc@sIalT"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ax_sFs`ztLzkAzxI|kCzkAlrDqeFb_AqeHelGueD_yGg_A|KtxCzkArrD????????"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "m}_jHzdykV?{grA?{grA?{grA?}grA?{grA?{grA?{grAE}grAC{grA?{grA?{grA?}grA?{grA?gkS?s{}@?{grA?ohn@?k~b@?}grA?{grA?{grA?{grA?mxQ?on_A?{grA?{grA?{grA?{grA?}grA?{grA?{grA?{grA?uz}@?glS?{grAE{grAC{grA?{grA?}grA?{grA?{grA?{grA?}grA?{grA?{grA?{grA?}grA?qb}@?idT?{grA?{grA?{grA?}grA?{grA?{grA?{grA?}grA?{grA?{grA?{grAE{grAE}grA?{grA?{grA?{grA?}grA?{grA?{grA?{grA|Ggam@{gh@wVap_@kQp}Bwdi@||DkrKfyA}~Bl~G~d@lfZinBjuUssF~fZyuPrAi@psIum@~sE{xD|eEksIroFckg@xxGqbeAhbIewf@rkJqkHxqCwuQqfAs_[gwCctR_yIewOokAglV~TcaSda@}eSlq@oyIbrGad^x_FoiS~_Lud\\~xDwcO`qLawFbmPk`H?m|K{eI_vHkz@cxWncFmp_@pjSgt[`dQkfh@j`HceXm@grX}~Gcp_@ykPira@q_Bm{W|t@kxM`qLukGjdDwiI{p@cyYxrAo`w@guBgrk@txF}bIvgKk`H~zByaQ_{BmpWf_B_|j@pKeeInIcjGksCksb@ujDcbP{`Ha`W}aKi__@ycTi`w@isF{rl@rdNqni@`kLmy`@tdDsaLtsLwna@jhRiwo@xbUy{v@|bUy{v@phRiwo@nsLwna@tdDwaLbsN}{d@bsNc|d@bsN}{d@bsN}{d@bsN}{d@dsN}{d@bsN}{d@bsN}{d@n~XwpHzhXwhHrjQgeUxwOciSc[cwJuaFw|JelBkqFcQiuKaaEkf[li@yiG``BsvCxvCwK|wB~]pqFnjCjmMq{Et`Oem@`cKcxB`pN}pJ`cKk`I`jAusKaaFog\\mtAyiQ~c@olIdjJ{xPnyE}uGrtDuaArta@daWtePede@txQuqi@nlUqwq@`vLi`^frRk{g@t|Z__FxpVs{Drz_@moFfo`@_tFlk`@osF~lb@ebGt|e@y{Gppa@w{Fbvd@csGxap@gnJ|{QhgIzdh@ziUdfd@leSjxIpw@tgu@j{LrlUbcJn_LxnRprKdjRrcTdcWhmIrpYjcE`qL`uHjbFzfT|yFzl_@go@r`Dy}BjzUc|PxrNo~^leNela@|@k_p@{gS}ak@wnTqum@adR}sh@cxU{op@ssSszk@klF_vo@ygIwnbA{xCwr^_cGkjt@wvMakh@m`Rumt@}}Tut|@w}Qaft@eoIqwY{~Jc`RwzG_vC}aDdc@cbDb|CswBdxEueBh`Ew}BryAytG`Qo~CjuBqtBvoBwq`@si@mlIzsCwkY~iPuyJqa`@c~Ius]}bGcmWah@ser@dDupn@|Eap`A~Dafv@|Egl_A~Bqwd@aKunp@cn]sbW{fZ{pTc`YovVgq]kei@wnDggKs`KkwEwmJgqXwrI}d[}}Hy`JotD_jDewt@{hkAkyWwij@cyLgxb@grE{fZj]skQa]}mIIe|Gs@inl@gBygpA{AwgpAs@g`o@i@qf`@aBwgpAaBygpA{AwgpAaBygpA{sd@qfR_pPi|P~xDmpWoNqaL}aEexHm}A}vCunDgxJxXawF~gGesEnoDooDor@{lE_yFkoDuyIdEgpFmpF_d@y}GpFugG{tBgcC}gDtMgoGl~AyfIm_@waQotSwgKijXkcEe{G}lKuqAk|KcpMwlFogFumE{w@e}FnwBycN_KwaQe_DmuRe~DmwP}kLckRw}T{mXetDmzY}}DodYwpYqt\\wb]s{OmcPev]g|]{zTw~T{_IsaJi|JoqJ`qBszQjpBmwQ|gPzvAfoGkaAxaCy^ngFg{Gn|C}zKrs@_vHaB}mJixHah^eiE}vc@w|DweSipDauBc}@qeHft@gvMl{L{aZd}Ses^~pOi_Xdv[qWfm]uNla_@sOt{UsJjm^uSj_XiOxs_@mTlmPoJh`D}lB|zE~`AbmBf\\tvAgFbmB}j@`yCfFjjCveBh`Dhr@`gGpMh`D_mBh~AgvD?ayCl~A_eEvgDs_GrqCucKdr@mrKsc@quGp~AipIniFmtB|zE`aAteBp}DvoAllErgDrc@~nDueB`yCsqCtmGi`DviF~`A~dErqCblE`aAhoDs{BniFciIjbFglEt{ByaIawA{xCktBu{B_wAccCnr@ebFz`AagGnmAk_H"
      ]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": [
        "tdteAs}jtEipEtg@}tNp`BssL`aHicG|xFycAtuHxCrhDohE~eCk|Lx_DozJjlFsyHryHibH|{DukG|~@gfHaq@w|UubHquNi{AebO|_@wnOf}CesR`jI{sDod@gkL`oBujHrJauJ}~@ekN~}@ux_@n|GukG?k{NtlHopd@||[i{Chj@ezd@vjl@ogGjdQvaFhpEfqEbmApbK_|@n_Enb@nvA`|@{KfwI"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "swgbCel_rSyfIxpK{pOtwSo|@ljGv_G|aVp`B`c`@uqG`lFnoEbaOyzRnmNeg@rgQaaNzyUe}FhdG}lJrrAq}Df|EvVn}GwaEx{H__EztNyqB`sKrwArfEjl@xsEstFnc@cbVyMcoSxc@ueHlmBo_F~mGgjB`vF{nIzjBguS{vAc`MggE}nAo{HcbIsjLihMuxE{gLoqGasQ~o]_tEd`OfyAlwPf}Dv_Uld@npJwiAvwDuvOnxKi|Ap|Ega@~rNzCxdLdhFppFbmA`tJlL~sJ{aHdzJoyJ`xPcjGt}ZgsHzjBaoJvaFmsI`sIccMjoPoiFrtMdoCrcFx_GvuH||Opwd@drEduO~uCf{GbaFtmFvmP|hAtmRzuBt{HnzIhnF`iI`XfzIiJlqIlbBd|HbpRfh]qp@riMe`JhvJs~Fn`Dxx@vpL`jHllPbxOl`GptN|gCp}EbxBf`A~yDlJjdDugl@tfu@cjAziBrhHltHz~V|yGlrCbjEaz@|gCyu]hmUi}AbwDp`@vaD~|HluEvsM`gMp{Gd{Id|HvFnvGdyJfuGpwLp\\hqC{nBrcHeqJl{J}`KbsGk~JxhTmcIn|Vu|Fh{N_}@l`H~oBtkG`zC`eCt~Jx~DzsRhjMbsNzvKz_Il|Jp|EhnH"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["k_`jG{zkl@wcA~Icz@xkCza@lxBpjA~{AjeCzM"] },
    { "kind": "International boundary (verify)", "lines": ["atw~FezzjAuCmo@|o@eD~Crt@uRjRq\\kR??"] },
    { "kind": "International boundary (verify)", "lines": ["kjsfC{j`tTupCvbClZllEnuC`qA|gCpL"] },
    { "kind": "International boundary (verify)", "lines": ["mzkhCgs{vTyNaQmqDggEur@chH}tAk{C?ewKbdA_yF`pAmkF"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["ezyqFil~mL_YbgIygFx~FayElvD_zBtg@|@s|A|aBmpLrdAq}Q|z@etEt_CiTvoF`oP"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "mhqrFuhtqL~wA`z@xw@~vHeHf~Py~@xfIkzNgfEmdBmFuMzV_cAtdDymE|yF{qHrtAazGq`B{uBcuDpR}sB|oLk~Ih}B_wH~fA_fR~iLnsHngMabF"
      ]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": [
        "c{`fGa}vyZmw^rdFciTjxFm~GrrCuhKfwJsvK~dQ`mEna\\oiWbtTeoQfe_@kvHz`C{cPu}@s`FyjCcjm@qnq@az[{hPmw]akGqvZvlBqae@pbL"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gkzbEzaxF_qBwsHeeJ?cyS`aFk~KggCy_KydNcoLo}Q{kOd{Gg~ItaN_cLxbTclDn{I_|NvbRacQ~uJwge@n}F_mTvoMulYbqIsmo@ujHci\\f_M}tKxdAk|MpBqxXwhCahc@bxAgnd@nqOgwKuxFerEcsBqtDre@g|JdaN}xHpmEufHqjBqkLmzFgrDhTajOzmWmlYbeh@ooJroJ}oMlsD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "o~sy@e~~oDcrKm~VmnGqmVuzHcal@aqNmmOygM_bHaa[uHmbJquO}`Xybs@whDiyGjhy@ob{Arcm@gur@tfAccBrZguAevB{_Da`A{gEkR}bUegAmyh@_pDgwL}kqAo~rAqs^cxYgvQ{cKmyb@}jNselA{_{A{bE_gBezCa\\e~X`|LgeLf_BiiS`Rsr^ewAi~R~]ioE`{@}ww@|jr@gQyw`CouCuHypJ|}Au`Hpl@wtHcZszDvFtHmy|AdaOve@zwd@viJbtUoEvzX|sA`bAhTrwGxwCr~GhfCfxoCyjRn`Epm@``H~cDb~Ari@~zBcy@lsNg}i@zgAewBzrQwmNdvcA}qsAllB_|ApqT_wGdmG_h@j_CvEd}KvdAdyDgV`zBom@t}E}^t~YvdLvvPdbCt|Mve@hsGgVpqGmxBhCwhc@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "go{s@ghkrCm~DkpAc~L_kIeaHi|OceMqgl@wmDwoAq}Pm[ywGeuB_{WkqNy|HafAicT}Tw~HebAkbFaoCijK{lK_oF{iCueOa{@ab_@pj@m}Eq{@qvDgmCwc\\kp[e~KesFsuJ_rAazJjGsuJ{u@kiJinGwoBgfF_pBa`TjfAijMojPctyAaqAaoHnvA_wJpxJ{gD~yQdNbdHgu@noEykDb~Gk|Nx}Mu_JbpDizDngIybOl}tAcqiAncGc~Sc}AalSkzPong@_pCogSbaDsulCutAkyN"
      ]
    },
    { "kind": "Disputed (please verify)", "lines": ["_iry@_ndiDnoj@qpUtxHkhItNakzCcgK`}AevLw}@ssPicQmzJecL"] },
    {
      "kind": "Disputed (please verify)",
      "lines": [
        "iizJnxvwIikEfvFg|Df{FccAzqKa_CjaNciN|aJgyTrmJqzHn`CgpHx}GwpLrxGe_K|tAo_J~sEquBfnB}~MzcDcqD`a@wUfpAmxCrrBo`OzbFs~Bhr@ol@bcBwgJnhG_|B`rEwwDtlAqvNaQ_wF~oB{vMva@s|DrEmoEnkBwhCzsDatI~]_iYfk@_rCptAjIfyVhqAzkAvp@fhIjH~oJw`Bl}G"
      ]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": ["kmeMtfjlIgw@_gAsi@abFiCyiEgfMazHqzGgiOogp@}j[wiSq}JgcJom@geVukBuf[ziEo|Fo}Ayo[ukSwKcH"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["du_z@c|ymEqk@lwEqdItdPynArkLny@pf`@nkAhtJ_hArcHojPrqP}sBdsSk[hoQyuR~p]j\\rdFbo@zkB"]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": ["odjxGkj`lEkwHcwJmiMib@neA{s[vyRi~i@xhBwyRoeAovQxuFcjXnvQovQoeAmiM?u}^|oO_}SxyRib@zbK{s[i\\gxI"]
    },
    { "kind": "Indeterminant frontier", "lines": ["{khuEypguMi{OxrG_xHz~CgqRv~HykPf{GqqYjqLypPx}G"] },
    { "kind": "Indeterminant frontier", "lines": ["{khuEypguMi`KilVynKaiWgbLenXa{M_}[}qKonWghIc_S"] },
    {
      "kind": "Disputed (please verify)",
      "lines": ["yhxiEoo{aNnyIwom@|qCybCx|Tx_FrlJp`@dsZwvRxhS_jKbdGza@twG|rChiM|sOfkKjdQza@dbMHxB"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "kzjeEilobNvVppH`eCnhGlbPfxJznClpLrj@zjNgoIvyNq}It_L}aE`nBopJtgBkpFb_FzoBbpL~q@ppSvpAdfU`pAdaChzC|KjkIylDlpLetCj}QevAtoKo_EzOcG"
      ]
    },
    { "kind": "Disputed (please verify)", "lines": ["orvcEeq`~M~mBgt@psd@gob@btFajHr`D_}@fvLxaBhm@jQ"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["srqaEqjm_NfrMvxDbvKkg@`aMqxJfyHyqHvfLjjHfiNhpDh{EsfEz_Ut}AfdCoxAdv@qrEqn@m_I"]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": ["{o`~Di_f`No@}HuyDuvIoc@saHrt@mmDeuOegFwjAokEfrC}jKrl^eoWjqYmvSd`Dc`EhCcD"]
    },
    { "kind": "International boundary (verify)", "lines": ["cdu|Do`mcNz|AmoBnwLimS|uG{bMycBohRaRqmXxoGebNrbDkoF"] },
    { "kind": "Disputed (please verify)", "lines": ["gzq{DwnvfNpY_f@t|Tse_@qp@ugLn~DkwGtvMcoAbiNnaChcFu]"] },
    {
      "kind": "International boundary (verify)",
      "lines": ["}mqyDwimhNhAIfk@_sLfcI{_\\~}GatXpzAkgLxsE_iMbsI_sKnsLgwWbmIszTvdMuyC"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["qurjDshjfPaIGoqH_rB_mHybAojDj{AkrEl{WyvCtuUcx@hbWpiB~fOpkF`yNzoBfnB"]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["}gjkDq{acPxwHhsHtyDz}Q~|HxrUxgHj~If{RtpOblWraWvxVz{TjsPbsG"]
    },
    { "kind": "International boundary (verify)", "lines": ["cvqgD{o|~OtpDzuAxqMr_N`QbY"] },
    { "kind": "International boundary (verify)", "lines": ["q_}fDg~i~On}H|kMt{[j~I"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "{_gdEyvrjMvnFuyDtnKfv@nsMxwLd}E|oUl_BncL~lZlz_AnpJzfSt{LrtN~lIjwDdeIbcBh|c@}_M`mJqjA~yf@noJrxMzjBviI{hC~zB{wLnrGq_BdtEgk@rsMh`W`}KlgX_@l_GtiWndW`uo@hjg@|mOtlTfaGlo@|dGdv@zwL}dG`sJ{u@fvJ|cHflLnbN|vJjo\\n_Kbfd@jhFxwOho^xpKnu^vrJlvJ|eD|mc@laSjvt@hab@hvJf{G|{Xjfu@jd[blv@ltIhwHxtX`jJbc[ttIjvMn{Hr_`@ngb@hjXnpJbrOfsBjgHz~\\pyGp|`@lzAhkp@prCzqSp{Ufo{@~\\f`NgxBnyJyxFd}Gq}KnhGe}Rh|Bq`HttJcuFbwN}JtqOhnGzsO|gHdnMhtFdzHt}GbsHfc]joQ~dj@p~\\|l^rn`@blH|kKpbFjwFfmIfnIzaIb`Ex}_@xhGtf\\bxCfpEmeA~oDo_DhoGqhQjaMglYr~Fcha@dm@k{[z~DsxI~bGumExyEox@heWxn@v|X~fBt{Z~uI|~NyD|rN_fCzvf@kb_@daCqyJlZ}aW{WoeJe`C{lKzvAsyGb{CqqEf`Gsu@`sf@h_@||PgzHpmWicRz{ZebNbn`@ugMddYusL~sL{hDnrEp{GrzEvaD|cHtg@|sHmz@~yEbe@dlGkmErxAesF~yD`GdsFl}JgGttIbsBfeGb~NbzNtfB`kFhm@l}H{q@hbJwlE|sNkdIrqCutIex@ijE~pBfe@nfJb|Ifbf@fmL`hd@fdHjmEdqHdrGf}BbaPhe@pbXam@dkPsgIz_OkjHhsMgMnrUpk@fug@qAdqUmmB~gLtqAraL_xBdjOhaDxhFnNtzEsxG|oDa\\ptBjg@|iCf~AvwBzcDtfAzwy@fX}JlzYaCtbRfeBn~SfnCdhRhjD~lHjmGboL"
      ]
    },
    {
      "kind": "Disputed (please verify)",
      "lines": ["snmuGg{}~Exgd@jTpmO|eEboDtqG|oBxdDbyF_hHtkExwBdmD|bT|eL{nDlyRwwJxaNa{A"]
    },
    { "kind": "Disputed (please verify)", "lines": ["zml|DpprsIpK`LvlEvzK`eAthN_IlhImyBnbAwfLfQw}YqkB"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "hci{DtuxtI{fBaLmsJn}GenKl|JgtOpvLwib@dcl@m{q@hl|@iqN|tTme@dlSnv@tsQvvEvcPpoVd~KrrB~jDyOva`@wxBt{_@siMz`J"
      ]
    },
    { "kind": "Indefinite (please verify)", "lines": ["lxvnHrun_M}cLtsCgnUf_MegV{hCk|K{wL{jO}hCuqAmv~@"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "b`|kHlfk}Lc_UbtAuxPmrIybOy{JoiFmcIalE{uUciHawYutIiaN}oHseFsiKolC{bLmc@u}ZnkCoqGq~CajJqpO_aIg_[quYy`KegVl{EmkQvpNyhGdwRg}Qfv@{~Pu|G{gRusJ}cUc{LaoNrZkaHaiK}eSy`b@uxRy`KyjDuiKekAwjMoeJsZibJpnIu}Lru@ymNmf@yrSueBawFqjOyvOodWmsImmE_gM}Z{k\\r`FibTn_EuwFd`B_iM``Jm_HnbGwhJ{}Kc{J_kWifPwiIisMbnHawF`xLukUvhCol[kdDorGwiI{hCqdc@usMgmBmtS}pZuxRrZedKtoPgrR|cPoiPbuKinHnei@kdDfxk@ojOx_EinHav@lyBsyS}iB}_a@qWurX}s@kyP{jAwpSp{Em}Q{hCe}Q{yXawFywL}`Km|Kav@wiIv`KkdBzaUsdGfp_BwiId}A{iPyYouPssBkvGl@wtFayGeaOc~HuuIs`Fk|Lh_F}oSfkNinHeeJkiJ}[_aJrnBkhKf~N{~OhdMyaQ?kxCopOipDk_JeeJuqA{wLx_EkeCzzU}mGtn]waFbiHowMhrG}sh@alEgbXpeBc{LjtA_uIcnForHwcIilUzxC}vJnaHkaHoeBuaHqpGyeJenFstAalEblEurHowBsgOu`HioRutIicA_hNd|Bske@jpMsvVr`LqpGmtAm_HodDos_@lbCmvR_h@_dy@u]}yR_o@ehSdjLc`R{x@m{LcmHaxQwyG}sOurEinFa}EovB}vJuaHmtA{|ExiDgyI`fNweL|mB}cIkeB}zDinFfAiqJonMavGs{P}mAygGyx@smIrtEktWzyCi_MfoC}zD{iDccAinFfhBkcLgu@ihH_nFir@m_Gca@wmDuoBucQ{gGinUkzG_{NuaAq_j@jdBo{HeuCw_HimHinGidLc`FahPqcIsoT{uBymYyeJ{tIi}MenFahKmcAqpGvcIscIbjLkrXhjEwrVhmBcy\\l}@ksXfhLuy[d}LksXrvBg`MetCygUknDscI|zDadQ`}EafMqeF_bU_yGyeJ`a@guYf}Eu}M`lEq_OalEs}MwcIc_Gi_Gy{Kni@mrIymBubFwcNcdLcfMkr@wcI?ahKovBg_G}cIqeByeJicAk|LmpRgxKslJqtAmySc{LwcIuxP}Eg~PjjAsySe}Eww^jvFkyOeXc{Lh_Gs}Mkr@orHxgCiqB`bKm|JvmC_{Dc{DioCslJscHsiM}}j@cwIg`LsaD{uNm}CicGzRiwJg{EszP_rGigP}pLyzJuwFq_OooFyrHmcAmxCorHuf@e`J{_By~K_{D_jDeqGt]s|QbYe`]t{Bewe@boA{mXohAksXqpGc{Li_G_uIhcA}vJjcAclEl}M|pDffMkp@n|H_sLluKqlMnvBawRgcAaiKi}HwmN_}BwxC~zDegIxoKslb@rzJwc]ul@m_G|vJyqVfnDimGtcK}rPzxC_dQtvBm_Gir@afA}rKsiMicFm_GxiDg}EtrHbP`hKgeGz~Iyga@zvM}|QjsJssZqtBoqTihAanQe_DmpMcz@e}EoaHteBmpGir@g_G{yJ}jFmkFubG}zDbPclEvxCoeJhhAsjLqsDgr]uvHmu`@ovMarK_jEwtIdr@uxCqeBdjDg_Ii{Dcm[u}MsrH}iLovBknFmpGutInvBueB~vJq~CnbFgbKwyAyxZgdCinS~Touj@rvI}fj@bsGomMabEawRkrQq|GycMwgJqpAqar@y~Lw{Zur@cmNwdHs~[y`Eu~W}iX_qOenF_r@}cI{iDuiDanQkmLe~QknP{pH}~Mi}MuvBulS}dF{{`@{{MmsVgjGqpG{eJq}]gaLkdQwrDinFm}MecA_wJfqGyeJ_s@}vJauI{tIogF{wXi}BgrJutI{iDeuQ?m{LvtIuqYpyT{t\\lwQwjHf`AyeIzBc|K{eBssM_~GiaW{oUigPtkAsj~@nlOmmPbaEal_@xkJeyKkr@sxb@a_I{kMauGqtAeyKwxCa}EclEocAc_GppG{cInvBglMtvBy`DxzJ}_KjyEgsP?y}U{tIalE_wJscIuxCwiHsqK}eFmmJgjLsrHsiO_sf@}tKkn^mhWcl|@qsOobi@qoJu_C}yFafBkvy@}oRm}jAmgXorn@gyNsab@djc@"
      ]
    },
    {
      "kind": "Line of control (please verify)",
      "lines": [
        "akarEkxujMkuB|wImjFh}MtLznLow@|o_@cfErz^ulFj_e@wdB`xQooEtqe@fuG|aXhzFltU~hDtnQphW~fNppGjmElhKjlFrrGdmBviIs_BhiFikU`_IwiHfzGgk@zaH``GvdFbvE`iEi@rjEiqBxvCyjDl}Aww^x@uyQtqAoiFnrGmZ`sJp{EjjHpxYpzHxbN`aL`xCbmIwEb|EadDr}FczKhbHk_K`mF}sBxaIdm@f|L`zCzdOddL~oJ`~IlbClZheEevAr~GszG`hL{`NlwIwuQ|}Ak_KdrAi|BzmKovBtbLgl@`zHxwC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "_bmyH{kaoCgvRdyKuyPs_@aeI_cFkdHmtGgwLhqBoeQ{oGidLmGouDxvBgpEr{EehFf|QeuDxiGerFrsX}mHrlXqxDrgCm~Bme@c`EwmCqtPckRadPm_T{{EglLc_UeifAcuFi`Jm_LywAcnHeDmyOhj@w}VdjCkoOvmDy_^|sLqb_Apdd@woaAbiU"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "sxvx@_{~nEshI}Fifi@c_GedWeqFivKmbDugg@awSa|KkzBozJsUq_u@zsFqnX_jLqfXoaP_wIs}MehF{mKt`B_zDpsJuhMjnJuxQepA_xGg`Ic|K}qIyqHi_Rjg@y~e@msGymU|s@i}ZefHkhf@ibIezWkoCyiLaxDylZqjZaxe@}nVgi[g_Nqfm@sr[e{OenMahFexJ{sCsqPaeC{r_@}|BilVe~DymBylH}}@ctS_Juqb@aoCava@{dIuhYa~J{|JioEmrJmuFynRmtGqdi@u_Jer[tRqls@euN"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "qsrgAmsqM|bJbaDba\\bzMfcKj_J`dh@l|o@szCb~VviG~hq@cnHrpFeg@fvJ|s@lqM~qBpgDn`Cjr@ztD|eDpiOngH`dCreF`pAb}GsIb}InbAllEnbG|@f`F~|@loBtlFf{FbcBtvFaRtpBfjC_}@|mHccAzrD`_I|gDryEroEwAzuC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "|yl}Cs{~aE`eA~dDboA|xHmiUtbl@yqVn_k@gUdjEvmAngHlcP~}WnyYlhVnzUjuIbsVjeP~_e@puZpeGlxAr{]tHxl\\ii@bbCylApk@s}M|aWkuIhke@}mW`sWmch@ddJcee@byAiit@oXadi@yyXdlAuqh@ccC_~ZyjDkf@s{DftAgbJvzAabE??"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": ["zaybDs`_cE_l}@fj@quLjnDm`S`xDyzKhj@w|KisB}nSqv@}|Pjs@c_Hd~PkzAh}B"]
    },
    {
      "kind": "Indefinite (please verify)",
      "lines": [
        "sdtxE}opsMciBxtFy{HbuQsoGrjL}gUzjAfv@xrHv_GtuUzbDbeYlAplMsrBhzDgnVluGarExiEorAfxJwcCpwK_cE`lE}uFnm@a{GwuDiyEwvE{uh@ec@"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "u}s^}jyeDdaNyyLhtLo_F~~LsbIrvVgy`@|eLiwIltMqfG|lJseDfdHsmIjyDssM~~EooKlhIosFftIqnJ~pMgdUnI}wIv`AgmK|wBk~Iga@}wJkoHy~Qi}N_lUqzHcbP`oBymh@b`Gu`VvgJyjQ}UgjMyxSsf^wcU_qOovCebOdrH_kW`uSubSn`]{sPfmJqmK~vPy`Pffe@q{`@tcRmbk@dlHmbPfnH}qDrpKufBhuLoc@vqDyiDe}@c|Jc}@qeIh{BydJ|}HuwFzwFu{BliGifC"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "}vsaAozojC`hWqxLboGgqEplx@{|w@nsLa`Jpvh@wd[`d[qgPxmg@wwRn~T_}@xyQ~rA`kt@r|BzjN~dDtv[`~Wj}Kda@rwIkcDbmCerFdjDgtCh{WbzAhwHy}GhoEwwQlmCkkn@xqBatWp_DckR"
      ]
    },
    { "kind": "International boundary (verify)", "lines": ["cihlFevmxGpu@c{IqoGmy[ld@uw`@"] },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "c|eqF{vipG~tEgrEjdCmbCrcg@qs^~yJu}L|_I_bGxdJaoDrpFwsHbbC}vK~yIkpNdmGqnIjoPetP~oEgsQrtKyvbAh{Dmrd@??",
        "u}mlFmewzG??dMcpKyvb@grk@g|JwpLseE_sYmeMu}MkePa_WkeO{h\\mpMw{YgxGesSspSkid@_cFaiV`FqfShbWgi]d|TooXxrHq{FxrGttKhiGttVjbEtoC~xF~s@bnFw\\bbEaeBbdM{_\\~wF}hBp{FmEv|C|hBvzA~mE|}BreSvrC|gPtoCd_EdkDreDz}D{VzwEifDbpQ_mb@jyEo_CfdHc`F`sDysG`p@cxMbxBcaFzea@efa@`lAwjGyoFi_g@~IipD"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "gobwD}hmmN{_BnrGtq@rlJ|gEvrJp~BtoDllWvoYloF`|Ll}IzmKpb`@dw[r{]|qOt`\\rbK`qSyEfbWvnClvLfkKntCdsF|vSx}G~dW`mE|yFevBhqIolNhhIs_N`cJgeRvrI{hQpk@qyJc`E_gBsvDgiCf`BynLrlIcnOngG_vIxwAkxCv{Lqk[poJ{oV~pMcw\\d|GehFhnHwkE`rK}_MlhU{ea@~}Nke\\l_LswVbcHgsQem@msG_zCimHmyAehGdqAmsHt}E_sMrdTaja@npO{}^g~A{za@btAogH|~MipEldNykCt_Ik}e@poC_sXdgGug\\jbEcyMitF_qN{vEwyAk_C_jKdw@alSpxJ{ce@jpBs~NeeJgjL_eDy|WmxD_}K|kK{aZvpNa`p@jtHwgXfpH{}Dv_HyvAzzTbEn{HkdEnhUodp@fmHaeOf`BocLfKwlFxxAmbDruKclC~|AmmB`dBsmHny@ciIm~Ig|^iiGe{TzbAurN~fH_aI~mLym@vfM_zDh}E{dJzWa}JmrHir\\ljFezVptAe|TrrCkiW`pBulHzwJwfX~{Jay]_j@w|JkdUcrp@juAieCldTuaInrFyaNfsE{pVsfKksWfoBwlRxc@{nVy{DopUin@{rRvsImn[cnAsfEuyEmmDsp]}`Js_ZuwHybOdZetVt_Hax]v_VgjHpu@gut@awFq}]qpGitMmjFgzS_bGgtHgl@{uGpWqiDd|F"
      ]
    },
    {
      "kind": "International boundary (verify)",
      "lines": [
        "e}`}EawunM_xMxkCsJlB_`KlqBsmN`kHeqHtvGsyGjhLaeHfoSkkBhgQbuEfdUiqAl`Fkl[nfH{xD|{DotJ~if@avAjyPptB~mSnbB~tJueDjkHgqEfuMunCdlMyDh{PjyAnqJ"
      ]
    }
  ]
}
